// Auto-generated from heartlandphysics.com posts — do not hand-edit; rerun scripts/generate_guides.py
export const GUIDES = [
  {
    "slug": "about-lancer-smith-and-heartland-physics",
    "title": "About Heartland Physics",
    "excerpt": "Heartland Physics is a physicist-led consulting practice focused on radiation shielding design for diagnostic imaging equipment that uses X-rays.",
    "readTime": "3 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Heartland Physics is a physicist-led consulting practice focused on radiation shielding design for diagnostic imaging equipment that uses X-rays."
      },
      {
        "type": "p",
        "text": "The work is intentionally focused: general radiography, CT, cone-beam CT (CBCT), fluoroscopy and C-arm systems, and dental X-ray and CBCT projects."
      },
      {
        "type": "h2",
        "text": "Work directly with Lancer Smith, M.S."
      },
      {
        "type": "p",
        "text": "Lancer works directly with facility owners, architects, contractors, equipment vendors, and imaging teams. There is no handoff to a sales team. The person reviewing the project information is the person responsible for the shielding calculations and technical recommendations."
      },
      {
        "type": "h2",
        "text": "What Heartland Physics does"
      },
      {
        "type": "list",
        "items": [
          "Review the project location and identify the shielding or plan-review path that applies to the project.",
          "Review the exact imaging equipment, room layout, equipment orientation, workload, construction, and occupancy around the room.",
          "Prepare project-specific radiation shielding calculations.",
          "Provide barrier and material recommendations that can be coordinated with the construction documents.",
          "Coordinate shielding questions with the facility, architect, contractor, and equipment vendor.",
          "Help organize shielding-related technical information for state or local plan review when that process applies."
        ]
      },
      {
        "type": "h2",
        "text": "Who Heartland Physics works with"
      },
      {
        "type": "list",
        "items": [
          "Medical and dental practices planning new imaging rooms or equipment replacements.",
          "Architects and engineers coordinating diagnostic imaging spaces.",
          "General contractors and shielding installers building or remodeling X-ray rooms.",
          "X-ray equipment vendors and installers who need a physicist to support a customer project.",
          "Hospitals and outpatient imaging groups planning diagnostic X-ray, CT, CBCT, or fluoroscopy projects."
        ]
      },
      {
        "type": "h2",
        "text": "What a shielding design is—and what it is not"
      },
      {
        "type": "p",
        "text": "A shielding design is project-specific technical work based on the actual equipment, expected use, room geometry, construction, and occupancy. It is not a regulatory approval and it does not replace facility registration, equipment testing, inspections, radiation surveys, or other requirements that may apply in a particular jurisdiction."
      },
      {
        "type": "p",
        "text": "State and local requirements vary. The current requirements of the responsible radiation-control authority always control."
      },
      {
        "type": "h2",
        "text": "What to send to start a project"
      },
      {
        "type": "list",
        "items": [
          "Project state and location.",
          "Current architectural or floor plan.",
          "Equipment manufacturer and exact model.",
          "Manufacturer planning or installation drawings when available.",
          "Expected clinical use or workload.",
          "Known wall, floor, ceiling, door, and window construction.",
          "Occupancy around the room, including the spaces above and below."
        ]
      },
      {
        "type": "h2",
        "text": "Contact Heartland Physics"
      },
      {
        "type": "p",
        "text": "Email Lancer@heartlandphysics.com with the project information above. Heartland Physics will review the scope, identify missing information, and respond with the next step."
      },
      {
        "type": "p",
        "text": "No compliance guarantee is implied. Shielding and plan-review requirements depend on the project and jurisdiction."
      }
    ]
  },
  {
    "slug": "ct-and-cone-beam-ct-shielding-design-guide",
    "title": "CT and Cone-Beam CT Shielding Design Guide",
    "excerpt": "CT and cone-beam CT rooms should be designed from the exact scanner, geometry, workload, technique, scatter characteristics, and adjacent occupancy. CT and CBCT are not interchangeable room labels.",
    "readTime": "1 min read",
    "tag": "CT & CBCT",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "CT and cone-beam CT rooms should be designed from the exact scanner, geometry, workload, technique, scatter characteristics, and adjacent occupancy. CT and CBCT are not interchangeable room labels."
      },
      {
        "type": "h2",
        "text": "Confirm the scanner configuration"
      },
      {
        "type": "list",
        "items": [
          "Exact manufacturer and model.",
          "Gantry orientation and isocenter location.",
          "Scan volume and equipment travel.",
          "Technique ranges and expected protocols.",
          "Estimated procedures, workload, and growth.",
          "Control-room and operator locations.",
          "Manufacturer planning and site-preparation drawings."
        ]
      },
      {
        "type": "h2",
        "text": "Coordinate room geometry"
      },
      {
        "type": "p",
        "text": "Mark the final isocenter, gantry, table, control, doors, windows, and surrounding occupancy on a reliable plan. Small changes in scanner position or room orientation can change distances and barrier conditions."
      },
      {
        "type": "p",
        "text": "Provide the use of spaces above and below, not only the rooms on the same floor."
      },
      {
        "type": "h2",
        "text": "Avoid generic thickness assumptions"
      },
      {
        "type": "p",
        "text": "Do not assume CT automatically needs one standard thickness or that CBCT can copy a dental or CT room. Requirements depend on the project inputs and applicable jurisdiction."
      },
      {
        "type": "h2",
        "text": "Construction and closeout"
      },
      {
        "type": "list",
        "items": [
          "Coordinate barrier continuity at doors, frames, glazing, joints, and penetrations.",
          "Review model or layout changes before construction continues.",
          "Verify installed equipment location against the design basis.",
          "Complete required survey, inspection, registration, or authorization steps before use."
        ]
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "ct-room-shielding-design-key-differences-vs-general-x-ray-and-what-regulators-look-for",
    "title": "CT Room Shielding Design: Key Differences vs. General X-ray (and What Regulators Look For)",
    "excerpt": "Learn how CT shielding calculations differ from general X-ray, what drives barrier requirements, and what facilities should prepare for state plan review.",
    "readTime": "1 min read",
    "tag": "CT & CBCT",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "This article focuses on radiation shielding design considerations for CT (Computed Tomography). It’s written for facility owners, architects, contractors, and imaging teams planning new construction or renovations."
      },
      {
        "type": "h2",
        "text": "CT shielding is not “just thicker lead”"
      },
      {
        "type": "p",
        "text": "CT rooms often require a different approach than general radiography because of higher workloads, different scatter characteristics, and the way the beam rotates around the patient."
      },
      {
        "type": "h2",
        "text": "Inputs that matter most for CT shielding"
      },
      {
        "type": "list",
        "items": [
          "Scanner model and typical protocols (kVp/mAs, scan length, pitch)",
          "Patient throughput (patients per day) and operating hours",
          "Room layout (gantry orientation, control room, doors, and adjacent occupancies)",
          "Shielding material selection (lead vs. gypsum/board vs. concrete)"
        ]
      },
      {
        "type": "h2",
        "text": "Design details that commonly get missed"
      },
      {
        "type": "list",
        "items": [
          "Control room window and door lead equivalence coordination",
          "Penetrations (ducts, conduits) and how they’re shielded",
          "Ceiling/floor requirements when there are occupied spaces above/below",
          "Clear documentation of assumptions for plan reviewers"
        ]
      },
      {
        "type": "p",
        "text": "A clear, well-documented CT shielding design helps avoid plan review delays and change orders during construction."
      },
      {
        "type": "h2",
        "text": "Need a shielding design?"
      },
      {
        "type": "p",
        "text": "If you’d like Heartland Physics to prepare shielding calculations and construction-ready barrier schedules for your project, contact us for a fast turnaround and nationwide support."
      },
      {
        "type": "p",
        "text": "Technical review: Heartland Physics maintains this guidance through its medical health physics practice. Regulatory and plan-review requirements can vary by jurisdiction; confirm current requirements with the applicable state or local radiation control agency."
      }
    ]
  },
  {
    "slug": "dental-cbct-shielding-design-how-to-plan-a-compliant-cone-beam-ct-room-in-a-dental-office",
    "title": "Dental CBCT Shielding Design: How to Plan a Compliant Cone Beam CT Room in a Dental Office",
    "excerpt": "Plan a dental CBCT or X-ray room with physicist-prepared shielding calculations. Learn what affects barriers, layouts, occupancy, and state plan review.",
    "readTime": "1 min read",
    "tag": "Dental",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "This article focuses on radiation shielding design considerations for Dental Cone Beam CT (CBCT). It’s written for facility owners, architects, contractors, and imaging teams planning new construction or renovations."
      },
      {
        "type": "h2",
        "text": "CBCT is common—and often installed in tight spaces"
      },
      {
        "type": "p",
        "text": "Dental cone beam CT systems are frequently placed in existing operatories or small imaging rooms. That makes adjacent occupancy and barrier placement especially important."
      },
      {
        "type": "h2",
        "text": "What we evaluate for CBCT shielding"
      },
      {
        "type": "list",
        "items": [
          "Manufacturer data and typical scan settings",
          "Room size and distances to adjacent areas",
          "Whether the unit is in an open bay vs. enclosed room",
          "Occupancy of nearby spaces (reception, hallway, operatories, offices)"
        ]
      },
      {
        "type": "h2",
        "text": "Practical construction notes"
      },
      {
        "type": "list",
        "items": [
          "Door and frame lead equivalence must match the design",
          "Shielding continuity at corners, seams, and electrical boxes",
          "Signage and controlled area considerations (state-dependent)"
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics provides dental CBCT shielding designs nationwide and can coordinate directly with your architect, contractor, and equipment vendor."
      },
      {
        "type": "h2",
        "text": "Need a shielding design?"
      },
      {
        "type": "p",
        "text": "If you’d like Heartland Physics to prepare shielding calculations and construction-ready barrier schedules for your project, contact us for a fast turnaround and nationwide support."
      },
      {
        "type": "p",
        "text": "Technical review: Heartland Physics maintains this guidance through its medical health physics practice. Regulatory and plan-review requirements can vary by jurisdiction; confirm current requirements with the applicable state or local radiation control agency."
      }
    ]
  },
  {
    "slug": "dental-x-ray-and-dental-cbct-shielding-design-guide",
    "title": "Dental X-Ray and Dental CBCT Shielding Design Guide",
    "excerpt": "Intraoral, panoramic, cephalometric, and dental CBCT systems have different geometries, beam directions, workloads, and operator arrangements. A dental shielding design should start with the exact…",
    "readTime": "1 min read",
    "tag": "Dental",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Intraoral, panoramic, cephalometric, and dental CBCT systems have different geometries, beam directions, workloads, and operator arrangements. A dental shielding design should start with the exact system and actual clinic layout."
      },
      {
        "type": "h2",
        "text": "Identify each imaging system"
      },
      {
        "type": "list",
        "items": [
          "Intraoral units and wall-arm locations.",
          "Panoramic and cephalometric systems.",
          "Dental CBCT model and scan volume.",
          "Handheld or mobile equipment, if applicable.",
          "Expected exposures, procedures, and operating schedule."
        ]
      },
      {
        "type": "h2",
        "text": "Map the clinic workflow"
      },
      {
        "type": "p",
        "text": "Show patient position, beam direction, operator location, control or exposure switch, doors, corridors, waiting areas, neighboring operatories, and spaces above and below. Multi-chair practices should identify simultaneous or overlapping use."
      },
      {
        "type": "h2",
        "text": "Do not combine unlike systems"
      },
      {
        "type": "p",
        "text": "A panoramic unit, cephalometric attachment, intraoral tube, and CBCT scanner should not be treated as one generic dental machine. Provide the exact manufacturer documents and expected use for each device."
      },
      {
        "type": "h2",
        "text": "Coordinate construction and registration"
      },
      {
        "type": "list",
        "items": [
          "Confirm wall, floor, ceiling, door, and window construction.",
          "Review penetrations and equipment-location changes.",
          "Verify required state review, registration, survey, or inspection steps.",
          "Keep the final shielding documentation with the facility records."
        ]
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "fluoroscopy-and-c-arm-shielding-design-guide",
    "title": "Fluoroscopy and C-Arm Shielding Design Guide",
    "excerpt": "Fluoroscopy and C-arm use can create variable scatter conditions. The shielding design should reflect the actual procedure mix, equipment configuration, workload, beam orientations, staff locations,…",
    "readTime": "1 min read",
    "tag": "Fluoroscopy",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Fluoroscopy and C-arm use can create variable scatter conditions. The shielding design should reflect the actual procedure mix, equipment configuration, workload, beam orientations, staff locations, and room use."
      },
      {
        "type": "h2",
        "text": "Fixed fluoroscopy inputs"
      },
      {
        "type": "list",
        "items": [
          "Exact equipment, table, tube, detector, and control locations.",
          "Common beam directions and table orientations.",
          "Expected procedure types, duration, and workload.",
          "Operator and staff positions.",
          "Room dimensions, construction, and all adjacent occupancy."
        ]
      },
      {
        "type": "h2",
        "text": "Mobile C-arm inputs"
      },
      {
        "type": "list",
        "items": [
          "Every room or location where the unit may be used.",
          "Common table and C-arm positions.",
          "Likely lateral and vertical beam orientations.",
          "Procedure mix, frequency, and operating time.",
          "Staff workflow and nearby occupied areas."
        ]
      },
      {
        "type": "h2",
        "text": "Plan for variability"
      },
      {
        "type": "p",
        "text": "A single idealized position may not represent clinical use. Document the expected range of positions and procedures so the design can address realistic operating conditions without assuming every case is identical."
      },
      {
        "type": "h2",
        "text": "Coordinate changes"
      },
      {
        "type": "p",
        "text": "Changing a fixed table, adding mobile use, expanding procedure types, or moving the control area can alter design inputs. Review significant changes before construction or expanded clinical use."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "fluoroscopy-shielding-design-designing-for-higher-scatter-and-longer-beam-on-time",
    "title": "Fluoroscopy Shielding Design: Designing for Higher Scatter and Longer Beam-On Time",
    "excerpt": "Learn how workload, scatter, beam-on time, room use, and adjacent occupancy affect fluoroscopy shielding calculations and state plan review.",
    "readTime": "1 min read",
    "tag": "Fluoroscopy",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "This article focuses on radiation shielding design considerations for Fluoroscopy. It’s written for facility owners, architects, contractors, and imaging teams planning new construction or renovations."
      },
      {
        "type": "h2",
        "text": "Fluoroscopy often means higher scatter and longer beam-on time"
      },
      {
        "type": "p",
        "text": "Fluoroscopy rooms (including C-arm and interventional use) can have significantly different shielding drivers than routine radiography because procedures may involve longer beam-on time and varied beam angles."
      },
      {
        "type": "h2",
        "text": "Shielding design inputs we focus on"
      },
      {
        "type": "list",
        "items": [
          "Procedure mix and expected beam-on time",
          "Equipment configuration (fixed fluoro vs. mobile C-arm)",
          "Room layout and adjacent occupancies",
          "Ceiling/floor considerations for occupied spaces above/below"
        ]
      },
      {
        "type": "h2",
        "text": "Construction details that matter"
      },
      {
        "type": "list",
        "items": [
          "Door and frame lead equivalence coordination",
          "Shielding continuity at penetrations and control areas",
          "Clear notes for contractors to avoid gaps and rework"
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics can provide fluoroscopy shielding designs and plan review support nationwide, including expedited options for fast-moving projects."
      },
      {
        "type": "h2",
        "text": "Need a shielding design?"
      },
      {
        "type": "p",
        "text": "If you’d like Heartland Physics to prepare shielding calculations and construction-ready barrier schedules for your project, contact us for a fast turnaround and nationwide support."
      },
      {
        "type": "p",
        "text": "Technical review: Heartland Physics maintains this guidance through its medical health physics practice. Regulatory and plan-review requirements can vary by jurisdiction; confirm current requirements with the applicable state or local radiation control agency."
      }
    ]
  },
  {
    "slug": "how-to-make-smart-ethical-and-practical-radiation-safety-decisions-beyond-alara",
    "title": "Practical Radiation Safety Decisions: Beyond ALARA",
    "excerpt": "radiation, shielding, ALARA,…",
    "readTime": "4 min read",
    "tag": "Radiation Safety",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Feb 17, 2025"
      },
      {
        "type": "p",
        "text": "ALARA is useful, but it is not the whole decision. Good radiation-safety decisions also consider the real size of the risk, the benefit of the work, feasibility, and whether an additional control actually improves safety."
      },
      {
        "type": "p",
        "text": "The goal is a reasonable, defensible decision—not dose reduction for its own sake."
      },
      {
        "type": "h2",
        "text": "ALARA"
      },
      {
        "type": "p",
        "text": "The cornerstone approach to addressing radiation safety is the ALARA principle."
      },
      {
        "type": "p",
        "text": "ALARA stands for As Low As Reasonably Achievable, which means our goal for reducing occupational exposure should be to minimize radiation exposure to workers through reasonable solutions."
      },
      {
        "type": "p",
        "text": "The crux of this issue is that the concepts of low and reasonable are loosely defined and may vary from one individual or facility to another."
      },
      {
        "type": "p",
        "text": "Knowing the three methods used to reduce occupational radiation exposure is essential to fully understand the ALARA principle."
      },
      {
        "type": "p",
        "text": "1. Time – Reducing the time of exposure to a radiation source has a direct correlation to reducing radiation exposure."
      },
      {
        "type": "p",
        "text": "2. Distance – Providing additional distance from radiation exposure has an exponential effect on reducing radiation exposure. For example, doubling your distance from radiation exposure does not just cut the exposure in half but instead cuts the exposure to one-fourth."
      },
      {
        "type": "p",
        "text": "3. Shielding – Placing an appropriate shield between the person and the radiation source can effectively reduce radiation exposure when reducing time and increasing distance are unsuitable options. However, consulting with a qualified physicist is essential to determine the appropriate shielding required."
      },
      {
        "type": "p",
        "text": "Reasonable solutions to reduce time, increase distance, and use shielding to lower radiation exposure can be a complex balance and may require the help of an expert."
      },
      {
        "type": "h2",
        "text": "What is Considered Low Exposure?"
      },
      {
        "type": "p",
        "text": "Exposure to low levels of radiation is part of our everyday lives."
      },
      {
        "type": "p",
        "text": "Whether it comes from the sun’s x-rays and gamma rays, trace amounts of radon in the air, or even the food we eat, we are continuously exposed to various forms of radiation."
      },
      {
        "type": "p",
        "text": "This phenomenon is referred to as background radiation."
      },
      {
        "type": "p",
        "text": "However, when a facility plans to use radiation for business—whether for medical purposes, industrial testing, or nuclear power—specific regulations must be followed to ensure that workers and the general public are not subjected to excessive radiation."
      },
      {
        "type": "p",
        "text": "Regulatory limits are established for the general public, occupational workers, and the embryo of a declared pregnant worker."
      },
      {
        "type": "p",
        "text": "These limits are set higher than the background radiation we receive but remain well below the threshold of known adverse effects caused by radiation."
      },
      {
        "type": "p",
        "text": "It is relevant to mention that scientific evidence is not conclusive on the effects of these low levels of radiation exposure, and there is only firm evidence of adverse effects from radiation exposure in acute doses much higher than regulatory limits."
      },
      {
        "type": "p",
        "text": "In some work environments, achieving background levels of exposure may be simple, while other work environments may find it challenging to be below the regulatory limits."
      },
      {
        "type": "p",
        "text": "For an environment where background levels are easy to achieve, reaching 10% of the regulatory annual exposure may cause concern and require an investigation."
      },
      {
        "type": "p",
        "text": "Yet, in an environment where being below the regulatory limit is challenging, significant oversight is needed to ensure the exposures are necessary, the workforce is adequate, and proper equipment is used."
      },
      {
        "type": "h2",
        "text": "What is Considered a Reasonable Solution?"
      },
      {
        "type": "p",
        "text": "Quantitative and qualitative approaches have been introduced to help implement the ALARA principle in practice. Quantitative approaches include cost-benefit analysis (CBA), cost-effectiveness analysis, multi-attribute utility analysis, and life cycle assessment."
      },
      {
        "type": "p",
        "text": "Qualitative methods are more judgment-based, and the International Commission on Radiological Protection (ICRP) has stressed the importance of stakeholder involvement, safety culture, and individual equity."
      },
      {
        "type": "p",
        "text": "Wieder et al. have proposed a framework of the three Rs to evaluate whether radiation exposures are reasonable."
      },
      {
        "type": "p",
        "text": "The study indicates that Relationships, Rationale, and Resources need to be considered to assess if the ALARA principle is being followed."
      },
      {
        "type": "p",
        "text": "The relationship component ensures that all parties involved, such as workers and management, engage in active and open dialogue to discuss occupational concerns, scientific knowledge, and expectations, fostering empathy and trust within the community."
      },
      {
        "type": "p",
        "text": "Following this, a well-communicated technical, contextual, and ethical rationale can be established. Finally, an appropriate examination of the effectiveness of technologies and techniques in reducing exposure should be balanced against resources like money and time."
      },
      {
        "type": "p",
        "text": "A 2023 study by Engstrom et al. established that the cost of radiation protection can be assessed based on the Value of Statistical Life (VSL), productivity losses due to adverse effects of radiation exposure, health care costs, the number of years between exposure and cancer diagnosis, and other factors."
      },
      {
        "type": "p",
        "text": "The study suggests a range of $56-$170 per man.mSv for the general public and $61-$162 per man.mSv for workers."
      },
      {
        "type": "p",
        "text": "This implies that if the exposures of 20 workers can be reduced by 10 mSv (20 x 10 = 200 man.mSv), an appropriate cost for the radiation protection technology would be between $12,200 and $32,400."
      },
      {
        "type": "p",
        "text": "However, it is essential to note that these values vary by country and are not all-encompassing."
      },
      {
        "type": "p",
        "text": "As mentioned earlier, monetary calculations are not the only factor determining the need for additional radiation protection. The method could substantially increase the time it takes to complete a task, thus potentially increasing overall exposure."
      },
      {
        "type": "p",
        "text": "It may also be an ethical requirement for a particular environment. It should also be determined if the solution creates an even greater risk than the radiation."
      },
      {
        "type": "h2",
        "text": "Final Thoughts"
      },
      {
        "type": "p",
        "text": "Low exposures and reasonable solutions are an ever-changing landscape influenced by the working environment, individual needs, and available resources. Some methods for reducing radiation exposure are simple and require little to no cost."
      },
      {
        "type": "p",
        "text": "Techniques such as increasing distance from the radiation source and minimizing time may be accomplished with little to no effort."
      },
      {
        "type": "p",
        "text": "However, due to its complexity, a qualified physics expert should be consulted for guidance if radiation shielding is necessary."
      },
      {
        "type": "p",
        "text": "We must always remain aware that what was once regarded as ‘low’ and ‘reasonable’ may not always hold true."
      },
      {
        "type": "p",
        "text": "As new technologies emerge and techniques advance, we should be open to embracing them for the benefit of workers and the general public."
      },
      {
        "type": "p",
        "text": "What was once cutting-edge may now be outdated, and what is cutting-edge today may soon become obsolete."
      },
      {
        "type": "h2",
        "text": "Heartland Physics focuses on diagnostic X-ray shielding design"
      },
      {
        "type": "p",
        "text": "Heartland Physics provides project-specific radiation shielding design for diagnostic imaging equipment that uses X-rays, including general radiography, CT, CBCT, fluoroscopy and C-arm systems, and dental X-ray and CBCT."
      }
    ]
  },
  {
    "slug": "imaging-facility-first-steps-shielding-design",
    "title": "Imaging Facility First Steps - Shielding Designs",
    "excerpt": "Are you planning to install an X-ray, CT, Mammograph, or fluoroscopy machine in your medical facility? Start with a solid shielding design. Without it, excessive radiation could leak into…",
    "readTime": "3 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Mar 11, 2025"
      },
      {
        "type": "p",
        "text": "If you are building, remodeling, or changing an imaging room, handle the shielding design early. Doing the calculations before construction can prevent expensive changes to walls, doors, windows, and equipment locations later."
      },
      {
        "type": "p",
        "text": "A shielding design is a detailed plan created by a qualified physicist to determine the exact amount and type of shielding required for a medical imaging room."
      },
      {
        "type": "p",
        "text": "It involves evaluating the space, calculating radiation levels, and ensuring that all surrounding areas remain within safe exposure limits. This process ensures no excessive shielding is used, saving costs while maintaining safety."
      },
      {
        "type": "p",
        "text": "Many medical facilities install X-ray machines without realizing they need a shielding design by a qualified physicist. This oversight can put employees and patients at risk."
      },
      {
        "type": "p",
        "text": "For example, a receptionist sitting on the other side of an X-ray room could be unknowingly exposed to radiation for years. Without proper shielding, long-term exposure could lead to health risks."
      },
      {
        "type": "p",
        "text": "A shielding design ensures that every part of the facility remains safe for years to come."
      },
      {
        "type": "h2",
        "text": "Shielding Designs are a Regulatory Requirement"
      },
      {
        "type": "p",
        "text": "Most states require a shielding design before an X-ray-producing machine is installed. These regulations ensure that radiation exposure in adjacent rooms stays below permissible limits."
      },
      {
        "type": "p",
        "text": "Failure to comply with these requirements can lead to delays, costly modifications, or even fines. A proper shielding design helps medical facilities get it right the first time, avoiding unnecessary expenses and keeping operations on schedule."
      },
      {
        "type": "h2",
        "text": "Cost-Effective Shielding Solutions"
      },
      {
        "type": "p",
        "text": "Facilities may spend more than necessary on shielding materials without calculations from a qualified physicist. A qualified physicist can determine the exact amount of shielding required—no more, no less."
      },
      {
        "type": "p",
        "text": "This prevents overshielding, which can significantly reduce construction costs. Facilities can save money using a qualified physicist while fully complying with safety regulations."
      },
      {
        "type": "p",
        "text": "At Heartland Physics, we enhance shielding designs by considering facility expansion and increased machine usage over time."
      },
      {
        "type": "p",
        "text": "Designing shielding solely for the current machine workload may lead to costly modifications if future expansion or increased patient load occurs, requiring additional shielding and temporarily decommissioning the room."
      },
      {
        "type": "p",
        "text": "By anticipating growth, we create shielding solutions that ensure long-term compliance and avoid expensive rework."
      },
      {
        "type": "h2",
        "text": "Keeping Staff and Patients Safe"
      },
      {
        "type": "p",
        "text": "Lead is a commonly used material to block X-rays. A common misconception is that any amount of lead will prevent any radiation from coming through."
      },
      {
        "type": "p",
        "text": "While lead is highly effective, it does not always stop all X-rays."
      },
      {
        "type": "p",
        "text": "Depending on the amount of radiation passing through a wall and its energy, the lead may need to be thicker or thinner in some areas."
      },
      {
        "type": "p",
        "text": "The key is calculating the correct thickness to reduce radiation exposure on the other side of the wall to safe levels."
      },
      {
        "type": "p",
        "text": "This is why a detailed shielding design is crucial—it ensures the proper materials and thicknesses are used to protect people without unnecessary costs."
      },
      {
        "type": "p",
        "text": "One of the biggest concerns in any medical facility is the safety of both staff and patients. Radiation could pass through walls without proper shielding and expose individuals in nearby rooms."
      },
      {
        "type": "p",
        "text": "Over time, this exposure could have negative health effects. A shielding design ensures that the radiation levels in surrounding areas are well within regulatory limits, preventing unnecessary exposure."
      },
      {
        "type": "h2",
        "text": "Don’t Risk It—Ensure Proper Shielding"
      },
      {
        "type": "p",
        "text": "Radiation safety is not something to overlook. Whether you are installing a new machine, expanding your facility, or simply want to verify compliance, a professional shielding design is essential."
      },
      {
        "type": "p",
        "text": "Heartland Physics specializes in shielding designs for medical facilities, ensuring regulatory compliance, cost-effective solutions, and long-term safety. Contact us today to discuss your shielding needs and keep your facility safe for years to come."
      },
      {
        "type": "p",
        "text": "If you need a shielding design for your facility reach out to us and we will be happy to help!"
      }
    ]
  },
  {
    "slug": "radiation-shielding-design-for-general-x-ray-rooms-a-practical-guide-for-clinics",
    "title": "X-Ray Shielding Requirements & Design: A Practical Guide for State Plan Review",
    "excerpt": "Understand X-ray shielding requirements, when a shielding design is needed, what calculations include, and how state plan review works for new or remodeled rooms.",
    "readTime": "3 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "X-ray shielding requirements are not one-size-fits-all. The correct barrier design depends on the equipment, how the room will be used, the people and spaces around it, and the radiation-control requirements in the project’s jurisdiction."
      },
      {
        "type": "p",
        "text": "Before a new diagnostic X-ray room is built or an existing room is substantially changed, the facility should determine the applicable state requirements and obtain a shielding design when required."
      },
      {
        "type": "h2",
        "text": "Quick answer: what are X-ray shielding requirements?"
      },
      {
        "type": "p",
        "text": "An X-ray shielding design evaluates the radiation produced in a room and determines the barriers needed to keep exposures in surrounding occupied areas within the applicable design goals and regulatory limits."
      },
      {
        "type": "p",
        "text": "The result is typically a calculation report plus drawings or barrier schedules that tell the construction team what shielding is required at walls, doors, windows, floors, ceilings, and other relevant locations."
      },
      {
        "type": "p",
        "text": "The exact regulatory process varies by state and facility type. Some jurisdictions require a shielding plan or calculation package to be submitted for review before installation or construction."
      },
      {
        "type": "p",
        "text": "Others require the design to be completed and retained for inspection. Qualification rules for the person preparing the design also vary by jurisdiction."
      },
      {
        "type": "h2",
        "text": "When should an X-ray shielding design be prepared or reviewed?"
      },
      {
        "type": "p",
        "text": "The need for a new or updated shielding evaluation depends on the jurisdiction and the scope of the project. Common situations that should trigger a requirements check include:"
      },
      {
        "type": "list",
        "items": [
          "Building a new diagnostic X-ray room or imaging facility",
          "Renovating a room in a way that changes wall locations, doors, windows, control areas, or adjacent occupancy",
          "Installing or relocating an X-ray unit, wall bucky, table, or other beam position",
          "Replacing equipment when output, beam geometry, workload, intended use, or room configuration may change",
          "Changing the use or occupancy of a space next to, above, or below an X-ray room",
          "Responding to a regulator, architect, equipment vendor, landlord, or construction team that requests shielding documentation"
        ]
      },
      {
        "type": "h2",
        "text": "Who can prepare X-ray shielding calculations?"
      },
      {
        "type": "p",
        "text": "Qualification rules are jurisdiction-specific. Depending on the state and type of installation, the regulations or agency guidance may use terms such as qualified expert, medical physicist, health physicist, or another specifically qualified professional."
      },
      {
        "type": "p",
        "text": "Facilities should verify the current state requirement rather than assuming the same credentialing rule applies everywhere."
      },
      {
        "type": "p",
        "text": "Heartland Physics provides physicist-prepared shielding calculations and state-specific reporting for projects where its current qualifications and authorization cover the work."
      },
      {
        "type": "h2",
        "text": "What information is needed for an X-ray shielding design?"
      },
      {
        "type": "p",
        "text": "A shielding calculation is only as useful as the project information behind it. For a typical diagnostic room, the physicist will usually need some combination of the following:"
      },
      {
        "type": "list",
        "items": [
          "A dimensioned floor plan showing the X-ray room and surrounding spaces",
          "Equipment manufacturer and model, or planned equipment specifications",
          "Location and orientation of the table, wall bucky, tube, control area, and other relevant components",
          "The intended clinical use and expected workload when available",
          "The occupancy and use of areas next to, above, and below the room",
          "The project state or jurisdiction and any known plan-review requirements",
          "Construction details that may affect barrier materials, doors, windows, penetrations, floors, or ceilings"
        ]
      },
      {
        "type": "h2",
        "text": "What drives the shielding calculation?"
      },
      {
        "type": "list",
        "items": [
          "Workload: how frequently the room is used and the expected operating techniques",
          "Use factor: where the primary beam is directed and how often",
          "Occupancy: how the surrounding spaces are used and how continuously they are occupied",
          "Distance from the radiation source or scattering region to occupied locations",
          "Equipment type, output, beam geometry, and intended clinical use",
          "Existing construction materials that may already provide useful attenuation"
        ]
      },
      {
        "type": "h2",
        "text": "What should a complete shielding report include?"
      },
      {
        "type": "p",
        "text": "A useful shielding package should be clear enough for the facility, architect, contractor, equipment team, and regulator to understand the assumptions and build from the result. Depending on the project and jurisdiction, the package may include:"
      },
      {
        "type": "list",
        "items": [
          "Shielding calculations and design assumptions",
          "A marked plan identifying primary and secondary barriers",
          "Barrier specifications or lead-equivalence requirements for walls, doors, windows, floors, and ceilings as applicable",
          "Relevant construction notes for seams, overlaps, penetrations, frames, and other details",
          "Information required by the jurisdiction for plan review or facility records"
        ]
      },
      {
        "type": "h2",
        "text": "Shielding design vs. state plan review"
      },
      {
        "type": "p",
        "text": "The shielding design and the regulatory submission are related but not identical. The shielding design is the technical work that determines barrier requirements."
      },
      {
        "type": "p",
        "text": "State plan review is the jurisdiction’s process for reviewing the required drawings, calculations, forms, fees, or supporting information. A project can therefore involve both technical design work and a separate administrative submission process."
      },
      {
        "type": "p",
        "text": "For projects in states that review shielding plans, it is usually more efficient to address the shielding requirement before construction is finalized."
      },
      {
        "type": "p",
        "text": "That reduces the chance of having to change walls, doors, glass, or room layout after the project is already under way."
      },
      {
        "type": "h2",
        "text": "Common X-ray shielding design mistakes"
      },
      {
        "type": "list",
        "items": [
          "Assuming a standard lead thickness without calculating the actual room conditions",
          "Failing to identify primary-beam locations such as wall buckys",
          "Ignoring occupied areas above or below the room",
          "Specifying lead in a wall but overlooking the door, frame, viewing window, electrical boxes, or other penetrations",
          "Starting construction before checking whether the state requires shielding-plan review"
        ]
      },
      {
        "type": "h2",
        "text": "Frequently asked questions about X-ray shielding requirements"
      },
      {
        "type": "h3",
        "text": "Does every X-ray room need lead-lined walls?"
      },
      {
        "type": "p",
        "text": "No. The required barrier depends on the calculation. Existing concrete, masonry, gypsum assemblies, distance, workload, occupancy, and beam orientation can all affect the result. Lead is one shielding material, not a universal default."
      },
      {
        "type": "h3",
        "text": "Does every state require the same shielding plan?"
      },
      {
        "type": "p",
        "text": "No. State requirements vary. The required professional qualifications, forms, timing, plan-review process, and records can differ by jurisdiction and modality."
      },
      {
        "type": "h3",
        "text": "Do I need a new shielding design if I replace an X-ray machine?"
      },
      {
        "type": "p",
        "text": "Possibly. A replacement should be reviewed when equipment output, geometry, workload, intended use, room layout, or regulatory requirements differ from the conditions used in the prior design. The applicable state rules should also be checked before installation."
      },
      {
        "type": "h3",
        "text": "Can shielding calculations be completed before the final equipment is installed?"
      },
      {
        "type": "p",
        "text": "Often, yes. Shielding can usually be designed from planned equipment specifications, room drawings, beam locations, workload assumptions, and surrounding occupancy. The final installation should remain consistent with the assumptions used for the calculation."
      },
      {
        "type": "h2",
        "text": "Need an X-ray shielding design?"
      },
      {
        "type": "p",
        "text": "Heartland Physics prepares physicist-reviewed shielding calculations and construction-ready barrier information for diagnostic imaging projects. Send the project state, modality, floor plan, equipment information, and schedule, and we can review what is needed for the shielding scope and applicable plan-review process."
      },
      {
        "type": "p",
        "text": "Technical review: Heartland Physics maintains this guidance through its medical health physics practice. Regulatory and plan-review requirements vary by jurisdiction and can change; confirm current requirements with the applicable state or local radiation-control agency. Last reviewed August 20, 2026."
      }
    ]
  },
  {
    "slug": "occupational-radiation-exposure-in-the-use-of-fluoroscopy",
    "title": "Occupational Radiation Exposure With Fluoroscopy",
    "excerpt": "Fluoroscopy can create meaningful occupational radiation exposure because staff often work close to the patient while the X-ray beam is on.",
    "readTime": "13 min read",
    "tag": "Fluoroscopy",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Apr 22, 2024"
      },
      {
        "type": "p",
        "text": "Fluoroscopy can create meaningful occupational radiation exposure because staff often work close to the patient while the X-ray beam is on."
      },
      {
        "type": "p",
        "text": "The practical goal is straightforward: use the imaging needed for the procedure while controlling avoidable staff exposure with time, distance, shielding, good technique, and dose monitoring when required."
      },
      {
        "type": "p",
        "text": "Many factors are considered when evaluating the risk of radiation exposure for interventionalists. The stochastic and deterministic effects are carefully weighed in every decision in the FGI procedure room."
      },
      {
        "type": "p",
        "text": "The patient's needs always come first, and the intervention staff can act accordingly to protect themselves from radiation exposure."
      },
      {
        "type": "p",
        "text": "The physical location of the staff inside the room can change based on the fluoroscopic tube geometry, radiation protective equipment worn, and the room's design."
      },
      {
        "type": "p",
        "text": "Not only is the safety of the staff inside the room considered, but so is the safety of those outside or who may enter the room during radiation exposures."
      },
      {
        "type": "h2",
        "text": "Introduction"
      },
      {
        "type": "p",
        "text": "Fluoroscopy-guided intervention (FGI) diagnostic procedures are performed when noninvasive procedures are inadequate to answer a clinical question."
      },
      {
        "type": "p",
        "text": "Some procedures are easily performed with simple imaging equipment and require little radiation doses, while others require an appropriately equipped operating room using specialized equipment."
      },
      {
        "type": "p",
        "text": "Many FGI procedures require physicians and support staff to position themselves beside the patient. These individuals are frequently irradiated while performing their duties."
      },
      {
        "type": "p",
        "text": "Workers in FGI procedures are in a small population of monitored healthcare workers who could experience high levels of radiation exposure."
      },
      {
        "type": "p",
        "text": "Irradiation of these workers is considered an unavoidable part of providing healthcare during FGI procedures."
      },
      {
        "type": "p",
        "text": "Like other public service professionals, including the fire and police forces, some risk is simply part of the job description for medical professionals."
      },
      {
        "type": "p",
        "text": "Risks to medical personnel, such as severe illness or death, are acceptable by society if avoiding these risks would result in patients not receiving appropriate medical care."
      },
      {
        "type": "p",
        "text": "However, radiation risk management is of vital importance for medical procedures. Proper education, training, awareness, and personal protective equipment for radiation exposure are integral to the safety of FGI personnel."
      },
      {
        "type": "p",
        "text": "Primary and secondary radiation are the two ways FGI personnel receive exposure during a procedure. Primary exposure comes from a person's body parts placed in the primary radiation beam between the X-ray tube and imaging receptor."
      },
      {
        "type": "p",
        "text": "This exposure is not common to FGI staff and should only be acceptable when it is critically important to the patient's health."
      },
      {
        "type": "p",
        "text": "Secondary radiation exposure in FGI suites comes from leakage radiation of the X-ray tube and scattered radiation from the patient’s tissue in the primary beam."
      },
      {
        "type": "p",
        "text": "Typical operating techniques yield a leakage rate of 0.001 to 0.01 mGy h-1 at 1m, and scattered radiation levels are generally 1 to 10 mGy h-1 adjacent to the patient."
      },
      {
        "type": "p",
        "text": "The ALARA principle should be in place without sacrificing patient safety or clinical procedures and increasing workers' non-radiation risks. An example of non-radiation risk is spinal injuries related to wearing inappropriately heavy lead aprons."
      },
      {
        "type": "p",
        "text": "For FGI procedures, ALARA is satisfied with the design, selection, and use of equipment, equipment replacement schedule, and day-to-day working procedures. Implementing these items maximizes the procedure's net benefit."
      },
      {
        "type": "p",
        "text": "All workers involved in FGI procedures manage their radiation dose (ALARA) while providing appropriate patient care."
      },
      {
        "type": "h2",
        "text": "Effects of Occupational Exposure During FGI Procedures"
      },
      {
        "type": "p",
        "text": "Occupational exposure during FGI procedures can cause many different effects on the human body depending on age, sex, anatomy, location of exposure, and many other factors."
      },
      {
        "type": "p",
        "text": "These effects may manifest themselves immediately or after many years or decades."
      },
      {
        "type": "p",
        "text": "Consideration of special precautions for each worker during the FGI procedure ensures the lowest possible chance of adverse occupational health effects due to radiation exposure."
      },
      {
        "type": "p",
        "text": "Stochastic effects of radiation exposure typically are unmanifested for years to decades after the exposure. The age, gender, life expectancy, and health status of the individual determine the risk of stochastic effects."
      },
      {
        "type": "p",
        "text": "Deterministic effects manifest within days to weeks after the interventional therapeutic procedure. Interventionists, nurses, technologists, and all staff in the procedure room are at risk of developing stochastic effects, primarily increased risk of cancer."
      },
      {
        "type": "p",
        "text": "Deterministic effects occurring in individuals as a result of modern practice are rare and typically due to insufficient training, not using available protective equipment, or poorly maintained equipment."
      },
      {
        "type": "p",
        "text": "An example of a deterministic effect of radiation exposure is radiogenic eye changes resulting from FGI procedures (cataracts)."
      },
      {
        "type": "p",
        "text": "Studies have also reported hair loss on the legs of an interventionist (below the margin of the lead apron) resulting from years of occupational exposure."
      },
      {
        "type": "p",
        "text": "Special precautions must always be put in place when a radiation worker declares a pregnancy. The highly volatile nature of an embryo and fetus generates different concerns depending on the stage of pregnancy."
      },
      {
        "type": "p",
        "text": "Further information on monitoring the dose of declared pregnant workers is described later."
      },
      {
        "type": "h2",
        "text": "How Interventional Staff Can Reduce Exposure Based on the Use of Fluoroscopy"
      },
      {
        "type": "p",
        "text": "The use of radiation PPE, engineered shielding, and dose measurement all help prevent or monitor radiation exposure and are fundamental tools for radiation protection from FGI procedures."
      },
      {
        "type": "p",
        "text": "However, the most critical radiation safety solution is a general understanding of X-rays and education on their nature, along with the best practices."
      },
      {
        "type": "p",
        "text": "Proper training, procedures, equipment usage, and personnel placement are as crucial as any manufactured and designed product."
      },
      {
        "type": "p",
        "text": "While a procedure is in progress, each person in an FGI-procedure room must have radiation protection training based on FGI best practices."
      },
      {
        "type": "p",
        "text": "All radiologists in the United States receive training in radiation physics, radiation biology, and radiation safety as part of their radiology residency."
      },
      {
        "type": "p",
        "text": "They must also pass an exam on these topics to receive certification from the American Board of Radiology."
      },
      {
        "type": "p",
        "text": "Interventional cardiology fellows receive training in radiation physics and safety, and the board examination in interventional cardiology includes questions in these subject areas."
      },
      {
        "type": "p",
        "text": "All pertinent staff should be well-versed in the facility's policies and procedures for a time-critical, urgent, or emergent situation where an additional dose is acceptable. Advanced provision exists to exceed an annual occupational dose limit."
      },
      {
        "type": "p",
        "text": "Conditions under which an annual occupational dose limit for an interventionist or assisting staff member may be exceeded"
      },
      {
        "type": "list",
        "items": [
          "There is a need for an urgent or emergent FGI procedure; and",
          "No qualified individual is readily available whose occupational dose would be below the annual dose limit after the procedure; and",
          "There is no time to locate and bring to the site another qualified individual; and",
          "There is no time to move the patient or the patient is too ill to be moved; and",
          "Each such individual does not exceed the NCRP lifetime cumulative dose limit."
        ]
      },
      {
        "type": "p",
        "text": "Table from NCRP 168"
      },
      {
        "type": "p",
        "text": "FGI interventionalists can lessen their radiation exposure by using the fluoroscopy unit as little as possible as long as it does not compromise or is a detriment to the patient's health."
      },
      {
        "type": "p",
        "text": "Fluoroscopic units are engineered to have multiple exposure modes to lessen the radiation to the patient and, by association, the FGI staff. On many fluoroscopic units, radiation may be emitted continuously or in pulses."
      },
      {
        "type": "p",
        "text": "Options for different pulse rates may be available to the operator. A variable pulsed rate should be used for FGI procedures, but continuous exposure is acceptable for low-dose FGI procedures."
      },
      {
        "type": "p",
        "text": "FGI staff need to be cognizant that pulsed modes may degrade or lessen the ability to visualize the procedure. A balance of lowering radiation exposure and adequately performing the procedure should be constantly evaluated."
      },
      {
        "type": "p",
        "text": "Interventionalist experience may govern the exposure to patients and staff. It has been observed that less experienced interventionalists tend to use more time and radiation to perform procedures than more experienced interventionalists."
      },
      {
        "type": "p",
        "text": "Fluoroscopic gantries designed for FGI procedures can rotate the X-ray tube and image receptor at a fixed point called the isocenter. This point is where the patient's anatomy of interest is placed during FGI procedures."
      },
      {
        "type": "p",
        "text": "Backscattered radiation is the primary secondary radiation source during FGI exposure. Much radiation does not penetrate the patient’s tissue but is reflected."
      },
      {
        "type": "p",
        "text": "With this in mind, an X-ray tube positioned underneath the table minimizes scattered radiation to the chest and head of the interventionist. Subsequently, the most intense scattered radiation is directed away from the operator’s head."
      },
      {
        "type": "p",
        "text": "Fluoroscopes are available with the x-ray tube, typically over the patient (over table systems). Additional caution for the patient and staff is vital when these systems are used for FGI procedures."
      },
      {
        "type": "p",
        "text": "These should be avoided because of the highly scattered radiation directed at the head and neck of the interventionist."
      },
      {
        "type": "p",
        "text": "Tube collimators influence patient and staff exposure during an FGI procedure. Virtual collimation furnishes a graphical display of the collimator blade's position on the clinical image while the collimator blades are adjusted."
      },
      {
        "type": "p",
        "text": "This feature eliminates patient irradiation while adjusting the collimator. Regulations require that the X-ray beam is closely collimated with the image receptor so that primary radiation outside of the visible image is minimal."
      },
      {
        "type": "p",
        "text": "The physical size and shape of the intervention room and the location of the FGI staff inside the room can help reduce exposure to the staff."
      },
      {
        "type": "p",
        "text": "Generous procedure room size is beneficial because it allows staff space to safely maneuver and function during the procedure and allows them to maximize their distance from the patient as long as it is rational with their duties."
      },
      {
        "type": "p",
        "text": "Interventionalists whose presence is close to the patient should incorporate tools and methods to allow for increased distance."
      },
      {
        "type": "p",
        "text": "The interventionist generally stands close to the patient to manipulate interventional devices and is located between the hips and knees on the patient's right side."
      },
      {
        "type": "p",
        "text": "When using a c-arm in a lateral position, staff should position themselves on the image receptor side of the patient if possible."
      },
      {
        "type": "p",
        "text": "When the c-arm is in the vertical orientation, positioning the X-ray tube under the table will place higher scattered radiation areas toward the floor so that the interventionist's hand, neck, and eye receive less radiation."
      },
      {
        "type": "p",
        "text": "An isodose curve shows that exposure on the image receptor side of the patient is approximately a factor of 10 less than that on the x-ray tube side."
      },
      {
        "type": "p",
        "text": "Personnel performing clinical monitoring of patients during an FGI procedure should be located in the control room whenever possible."
      },
      {
        "type": "p",
        "text": "However, clinical requirements may demand that staff responsible for anesthesia, clinical monitoring of patients, or other duties be physically located in the FGI procedure room during the procedure."
      },
      {
        "type": "p",
        "text": "An intercom between the control and procedure room allows staff to remain outside the room until needed."
      },
      {
        "type": "h2",
        "text": "Radiation Safety Equipment Used in FGI Procedure Rooms"
      },
      {
        "type": "p",
        "text": "Each person in an FGI procedure room should be provided with appropriate radiation protective equipment while a procedure is initiated. Not all forms of radiation protective equipment are required at all times."
      },
      {
        "type": "p",
        "text": "Some staff may be allowed the privilege to utilize more comfortable and less cumbersome radiation PPE due to their duties and location during the FGI procedure."
      },
      {
        "type": "p",
        "text": "When the X-ray beam is energized, all FGI procedure room personnel not behind a radiation barrier should wear radiation-protective garments (lead aprons, thyroid shields, and lead-equivalent glasses)."
      },
      {
        "type": "p",
        "text": "Lead or lead-equivalent aprons should protect against radiation without excessive weight. The apron weight can pose a substantial ergonomic risk to its wearer."
      },
      {
        "type": "p",
        "text": "Apron weight can be lessened by removing lead and replacing it with other materials with the same or better attenuation for scattered radiation from fluoroscopic beams."
      },
      {
        "type": "p",
        "text": "0.5mm lead/lead-equivalent aprons are currently the standard, but thinner lead aprons may provide adequate protection."
      },
      {
        "type": "p",
        "text": "A 0.5 mm lead equivalent garment attenuates over 95% of incident radiation, protecting body organs and lowering the radiation exposure to the wearer."
      },
      {
        "type": "p",
        "text": "Based on the calculations from dual personal dosimeters (one in front of the apron and one behind the apron), a 0.3 mm lead/lead equivalent apron will result in radiation exposure that is only moderately higher (7-16%) than a 0.5 mm lead/lead equivalent apron."
      },
      {
        "type": "p",
        "text": "Thyroid shields are lead/lead-equivalent garments typically worn with a protective apron around the neck. They are designed to protect the thyroid from radiation exposure. For younger workers, the thyroid gland is relatively sensitive to radiation-induced cancer."
      },
      {
        "type": "p",
        "text": "However, the cancer-incidence risk depends on the age at irradiation, with minimal risk after 30 years for males and 40 years for females."
      },
      {
        "type": "p",
        "text": "Radiation-attenuating surgical gloves are available to interventionists to reduce hand exposure. However, reducing dexterity from radiation-attenuating surgical gloves may increase fluoroscopy time. Attenuating surgical gloves provide a minimal reduction in hand dose for FGI procedures."
      },
      {
        "type": "p",
        "text": "Suppose hands-in attenuating surgical gloves are placed on the primary beam during fluoroscopy."
      },
      {
        "type": "p",
        "text": "In that case, they will intercept the automatic brightness control sensing area: thus causing the air-kerma rate incident on the patient's skin to automatically increase, resulting in an increase in dose to the interventionalist’s hands and the patient."
      },
      {
        "type": "p",
        "text": "It is well documented that a high eye dose is possible for interventionalists performing FGI procedures. Injury to the eye's lens from occupational exposure has been reported, specifically for an over-table x-ray tube configuration."
      },
      {
        "type": "p",
        "text": "Lead-lined eyeglasses have been shown to reduce eye dose. 0.25 mm lead-equivalent glasses attenuate about 90% from the front, and standard glasses range from 30-35%. Plastic lenses attenuate minimal radiation."
      },
      {
        "type": "p",
        "text": "The interventionalists and others normally turn their heads from the primary beam to view the fluoroscopy monitor during exposure."
      },
      {
        "type": "p",
        "text": "With this in mind, protective eyewear should provide shielding for side exposure, using either side shields or a wraparound design."
      },
      {
        "type": "p",
        "text": "Mobile lead-lined barriers are an acceptable form of whole-body radiation protection. These are typically 0.5 to 2 mm lead equivalence, large, and frequently transparent."
      },
      {
        "type": "p",
        "text": "Ancillary personnel who do not need to be next to the patient but are required to remain within the procedure room will find these as a convenient alternative to cumbersome lead aprons."
      },
      {
        "type": "p",
        "text": "They are also useful for interventional staff to step behind during high dose rate digital image acquisition series."
      },
      {
        "type": "p",
        "text": "If personnel can remain completely behind a protective barrier during the procedure, wearing a lead apron is generally unnecessary."
      },
      {
        "type": "p",
        "text": "Room layouts that permit easy and comfortable access to mobile and fixed shielding increase the likelihood of their use."
      },
      {
        "type": "p",
        "text": "The barrier design should be based on the maximum expected occupancy by any individual in all locations behind protective barriers during the work week."
      },
      {
        "type": "p",
        "text": "Highly specialized FGI equipment may come with table-mounted and ceiling-mounted lead or lead-equivalent protective barriers to protect the interventionist from radiation exposure."
      },
      {
        "type": "p",
        "text": "Table-mounted shields typically consist of lead drapes mounted to the side of the patient table. The typical lead equivalent thickness is 0.5mm and protects the lower extremities of staff from radiation scatter."
      },
      {
        "type": "p",
        "text": "Mobile c-arm fluoroscopes typically do not have this feature. Ceiling-mounted protective barriers are typically 0.5mm lead equivalent. They are mounted to the ceiling using articulating arms."
      },
      {
        "type": "p",
        "text": "These are transparent and designed to shield the upper body of the interventionist. The contoured lower sections of the ceiling-mounted protective barrier are designed to be positioned around the patient."
      },
      {
        "type": "p",
        "text": "Staff members working in FGI procedures should know when radiation is produced to optimize their radiation protection. Different fluoroscopy and image acquisition sounds can alert interventionists and staff that radiation is being generated."
      },
      {
        "type": "p",
        "text": "However, some fluoroscopy equipment does not emit noise during the production of X-rays. In these rooms, staff cannot rely on an audible indication of X-ray production."
      },
      {
        "type": "p",
        "text": "When sound is not emitted while the X-ray tube is energized, an amber light can be illuminated on the fluoroscopy unit."
      },
      {
        "type": "p",
        "text": "Even when the fluoroscopy unit utilizes audible and visual signals, an announcement before exposure should be made to allow staff to protect themselves."
      },
      {
        "type": "h2",
        "text": "Radiation Safety For Personnel Outside of FGI Procedure Rooms"
      },
      {
        "type": "p",
        "text": "Radiation exposure from FGI procedures is not limited to those inside the procedure room. Much of the patient's scattered radiation can potentially expose personnel outside of the room as well."
      },
      {
        "type": "p",
        "text": "Precautions and safety features are implemented to minimize exposure to those outside the room."
      },
      {
        "type": "p",
        "text": "Some situations require personnel to enter the FGI procedure room during a procedure."
      },
      {
        "type": "p",
        "text": "X-ray indicator lights or signs at the procedure room entrance indicate that the X-ray equipment is in use or that the X-ray beam has been activated."
      },
      {
        "type": "p",
        "text": "These will alert staff that radiation is present and precautions should be taken if room entry is required."
      },
      {
        "type": "p",
        "text": "Door interlocks that end x-ray production are not permitted at any entrances to FGI-procedure rooms."
      },
      {
        "type": "p",
        "text": "Door interlocks that prevent x-ray production when opened eliminate dose to personnel who open the procedure room door while exposure is initiated."
      },
      {
        "type": "p",
        "text": "However, the imaging disruption during a critical portion of the procedure could harm the patient. This may require the patient to be repeatedly imaged with X-rays or incorrect interventional device positioning."
      },
      {
        "type": "p",
        "text": "The dose rate at the procedure door during fluoroscopy will generally be less than 0.1 μGy s-1. With this low exposure level, the potential patient harm does not justify the installation of door interlocks."
      },
      {
        "type": "p",
        "text": "When planning an interventional facility, careful attention to workers' radiation exposure from the planning process's beginning can help reduce occupational exposure."
      },
      {
        "type": "p",
        "text": "The walls, floor, ceiling, doors, and windows surrounding an FGI procedure room should provide sufficient attenuation to reduce the radiation in outside spaces to an acceptable level."
      },
      {
        "type": "p",
        "text": "A busy cardiac angiography suite usually does not require more than 1.5mm lead equivalent barriers to reduce scattered radiation levels below the shielding design goal of 1 mGy y-1 (air kerma) at 3m from the center of the imaging field of view."
      },
      {
        "type": "h2",
        "text": "Dose Measurement Considerations for Workers in FGI Procedure Rooms"
      },
      {
        "type": "p",
        "text": "To accurately assess compliance with occupational dose limits, the personal protective equipment used by each individual in the FGI procedure environment must be considered."
      },
      {
        "type": "p",
        "text": "The dose distributions in these staff members are always highly non-uniform."
      },
      {
        "type": "p",
        "text": "The causes of these nonuniformities include nonuniform radiation fields, differential shielding of different body parts from the radiation, and scattered radiation produced within the irradiated individual."
      },
      {
        "type": "p",
        "text": "Due to their positioning next to the patient during exposures, there is a large difference between the exposure to the left and right sides of the interventionist."
      },
      {
        "type": "p",
        "text": "Typically, the left side of the interventionist is exposed more than the right side."
      },
      {
        "type": "p",
        "text": "The personal dosimeter must be worn in the same location to avoid artificial variations in dose estimates from one monitoring period to another. Two personal dosimeters are highly recommended for each person involved in FGI procedures."
      },
      {
        "type": "p",
        "text": "One should be worn under the protective apron, and a second should be worn at neck level above protective garments."
      },
      {
        "type": "p",
        "text": "A single personal dosimeter worn at neck level above protective garments may be used in the FGI procedure environment. A single personal dosimeter worn under the protective apron cannot be used in the FGI-procedure environment."
      },
      {
        "type": "p",
        "text": "In the United States, a 50 mrem monthly limit (equivalent dose) for an embryo and fetus (excluding medical and natural background radiation) is put in place once the pregnancy is declared."
      },
      {
        "type": "p",
        "text": "The shielding provided by a standard protective lead apron is typically sufficient to protect the embryo and fetus from exposure to staff involved in interventional procedures."
      },
      {
        "type": "p",
        "text": "Once the pregnancy is declared, a personal dosimeter is worn under the apron by the pregnant worker at waist level from the date the pregnancy is declared until delivery."
      },
      {
        "type": "p",
        "text": "This dosimeter overestimates the actual dose to the embryo and fetus because radiation attenuation by the mother's tissues is not considered."
      },
      {
        "type": "p",
        "text": "Monitoring of equivalent dose to the eye's lens should be performed with the dosimeter placed either at the collar level outside any radiation protective garment or near the eyes."
      },
      {
        "type": "p",
        "text": "Estimates of effective dose and equivalent dose to the skin, hands, feet, and eye lenses received during FGI procedures should always consider the personal protective equipment used in individual cases to properly assess compliance with occupational dose limits."
      },
      {
        "type": "p",
        "text": "Investigations should occur if personal dosimeter readings for an individual are substantially above or below the expected range for that individual's duties."
      },
      {
        "type": "h2",
        "text": "Conclusion"
      },
      {
        "type": "p",
        "text": "Radiation exposure to occupational workers is a decisive part of all FGI procedures. However, other significant decisions need to be made during a procedure."
      },
      {
        "type": "p",
        "text": "Since the patient is exposed to far more radiation than the staff, their needs are carefully weighed, determining the long-term benefits gained due to the procedure and the long-term effects of radiation exposure."
      },
      {
        "type": "p",
        "text": "The safety of the interventional staff should not be the primary concern but is still a factor in providing patient care."
      },
      {
        "type": "p",
        "text": "A well-trained FGI staff knows the effects of radiation exposure and how to avoid excessive exposure while providing the best care to the patient possible."
      }
    ]
  },
  {
    "slug": "radiation-shielding-coordination-for-hospitals-and-health-systems",
    "title": "Radiation Shielding Coordination for Hospitals and Health Systems",
    "excerpt": "Hospital shielding projects involve more stakeholders, more adjacent occupancy, and more opportunities for late changes than a single-room outpatient project. A repeatable governance process helps…",
    "readTime": "1 min read",
    "tag": "Hospitals",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Hospital shielding projects involve more stakeholders, more adjacent occupancy, and more opportunities for late changes than a single-room outpatient project. A repeatable governance process helps protect schedules across renovations, replacements, and new construction."
      },
      {
        "type": "h2",
        "text": "Establish project ownership"
      },
      {
        "type": "list",
        "items": [
          "Name a facility decision-maker and a clinical equipment owner.",
          "Identify architecture, construction, equipment-vendor, facilities, safety, and shielding-design contacts.",
          "Define who approves equipment, workload, room layout, and occupancy assumptions.",
          "Set a change-control process for equipment and architectural revisions.",
          "Track jurisdictional submissions, surveys, inspections, and registrations."
        ]
      },
      {
        "type": "h2",
        "text": "Coordinate the whole building"
      },
      {
        "type": "p",
        "text": "Hospitals should verify occupancy above, below, across corridors, in public areas, and in spaces expected to change use. Renovations may also involve existing shielding that is undocumented or difficult to verify. Build field investigation and documentation into the schedule."
      },
      {
        "type": "h2",
        "text": "Manage phased construction"
      },
      {
        "type": "list",
        "items": [
          "Identify temporary conditions and occupied areas near active work.",
          "Separate demolition assumptions from final-construction assumptions.",
          "Coordinate infection-control, structural, MEP, and shielding penetrations.",
          "Verify barrier continuity before concealment.",
          "Confirm the installed equipment position matches the approved design basis."
        ]
      },
      {
        "type": "h2",
        "text": "Standardize without overgeneralizing"
      },
      {
        "type": "p",
        "text": "Templates can improve consistency, but each room still needs project-specific equipment, workload, geometry, occupancy, construction, and jurisdictional inputs. Use standard intake forms and QA checklists while preserving room-specific calculations."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "understanding-shielding-designs-and-radiation-exposure-risks",
    "title": "Understanding Radiation Exposure Risks",
    "excerpt": "Radiation risk depends on the dose, the type of exposure, and who is exposed. The useful approach is simple: understand the exposure, control what can reasonably be controlled, and avoid unnecessary…",
    "readTime": "4 min read",
    "tag": "Radiation Safety",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Apr 11, 2024"
      },
      {
        "type": "p",
        "text": "Radiation risk depends on the dose, the type of exposure, and who is exposed. The useful approach is simple: understand the exposure, control what can reasonably be controlled, and avoid unnecessary dose without letting fear replace good radiation-safety judgment."
      },
      {
        "type": "h2",
        "text": "Importance of Shielding Design"
      },
      {
        "type": "p",
        "text": "The primary objective of shielding design is to prevent radiation from escaping a room, thus minimizing the risk of excessive exposure to those nearby."
      },
      {
        "type": "p",
        "text": "In medical facilities where radiation-based procedures are commonplace, the role of a shielding design cannot be overstated."
      },
      {
        "type": "p",
        "text": "Shielding designs, performed by qualified physicists specializing in radiation protection, play a pivotal role in ensuring the safety of patients, medical staff, and the general public."
      },
      {
        "type": "p",
        "text": "A shielding design tailored to each facility's needs is essential for effectively mitigating radiation exposure risks. Qualified physicists employ sophisticated calculations to determine the optimal shielding materials, thicknesses, and configurations to achieve adequate radiation safety while maintaining operational efficiency."
      },
      {
        "type": "p",
        "text": "Moreover, a shielding design extends beyond mere compliance with regulatory requirements; it encompasses a proactive approach to minimizing radiation exposure and enhancing overall safety."
      },
      {
        "type": "p",
        "text": "By engaging experienced physicists for shielding design, medical facilities can confidently navigate the complexities of radiation protection, safeguarding both human health and regulatory compliance."
      },
      {
        "type": "p",
        "text": "While radiation exposure poses cancer risks, the relationship between dose and effect is multifaceted."
      },
      {
        "type": "p",
        "text": "Understanding the nuances of radiation's impact on health, coupled with stringent regulations, protective measures, and effective shielding design, is essential for mitigating risks and maximizing the benefits of radiation use in healthcare."
      },
      {
        "type": "h3",
        "text": "If you need a shielding design, Heartland Physics is here for you. Feel free to reach out to us at Lancer@heartlandphysics.com. Our shielding design information is linked here."
      },
      {
        "type": "h2",
        "text": "High Dose Exposure and Cancer Risk"
      },
      {
        "type": "p",
        "text": "Historically, our understanding of radiation's impact on cancer has been informed by populations exposed to high levels of ionizing radiation, such as survivors of the Japanese atomic bombings and individuals undergoing certain medical procedures."
      },
      {
        "type": "p",
        "text": "Cancers associated with high-dose exposure include leukemia, breast, bladder, colon, liver, lung, esophagus, ovarian, multiple myeloma, and stomach cancers."
      },
      {
        "type": "p",
        "text": "Additionally, there's suggestive evidence linking ionizing radiation to the prostate, nasal cavity/sinus, pharyngeal and laryngeal, and pancreatic cancers."
      },
      {
        "type": "p",
        "text": "What complicates matters is that cancers induced by radiation are often indistinguishable from those arising naturally or due to exposure to other carcinogens."
      },
      {
        "type": "p",
        "text": "This underscores the importance of considering multiple factors, including chemical exposures and lifestyle habits like smoking and diet when evaluating cancer risk."
      },
      {
        "type": "h2",
        "text": "Low Dose and Dose-Rate Effects"
      },
      {
        "type": "p",
        "text": "A crucial point of contention revolves around the impact of low doses of radiation on cancer risk."
      },
      {
        "type": "p",
        "text": "While it's well-established that high doses can increase the likelihood of cancer, the evidence is less conclusive for low doses, typically below about 10,000 mrem (100 mSv)."
      },
      {
        "type": "p",
        "text": "Studies on occupational workers exposed to low radiation levels haven't shown adverse biological effects."
      },
      {
        "type": "p",
        "text": "However, the conservative stance within the radiation protection community is to assume some risk even at low doses, adhering to the linear no-threshold (LNT) dose-response model."
      },
      {
        "type": "p",
        "text": "According to this model, any increase in dose, no matter how small, results in a corresponding increase in risk."
      },
      {
        "type": "p",
        "text": "However, the LNT model is highly debated among experts, and some claim there are varying effects of cancer risk at low levels."
      },
      {
        "type": "h2",
        "text": "Acute Radiation Syndrome and Immediate Effects"
      },
      {
        "type": "p",
        "text": "At exceptionally high doses, radiation can have immediate and severe effects on the body, leading to acute radiation syndrome (ARS)."
      },
      {
        "type": "p",
        "text": "This condition, observed in atomic bomb survivors and Chornobyl responders, manifests as a rapid whole-body response due to extensive cell damage."
      },
      {
        "type": "p",
        "text": "High doses, particularly over a short period, can potentially kill cells, leading to tissue and organ damage. The severity of these effects correlates with the dose received, with higher doses posing a greater risk of death."
      },
      {
        "type": "p",
        "text": "ARS manifests in several stages depending on the exposure levels."
      },
      {
        "type": "h3",
        "text": "Hematopoietic Syndrome"
      },
      {
        "type": "p",
        "text": "This type of ARS results from a drop in the number of blood cells, which can lead to infections, bleeding, and anemia."
      },
      {
        "type": "p",
        "text": "Blood tests might detect these symptoms after receiving a high radiation dose, typically above 25 rem. Severe cases can make healing from injuries harder, increasing the risk of complications."
      },
      {
        "type": "h3",
        "text": "Gastrointestinal Syndrome"
      },
      {
        "type": "p",
        "text": "Symptoms like nausea, vomiting, loss of appetite, and abdominal pain may occur. Vomiting within a certain timeframe can indicate a high exposure, typically above 400 rem. Without specialized treatment, survival becomes unlikely due to severe infection risks."
      },
      {
        "type": "h3",
        "text": "Neurovascular Syndrome"
      },
      {
        "type": "p",
        "text": "This syndrome, occurring at very high radiation doses, presents with neurological symptoms like dizziness, headache, or decreased consciousness. Unlike the other types, vomiting isn't a prominent symptom. Unfortunately, even with intensive care, this syndrome is almost always fatal."
      },
      {
        "type": "p",
        "text": "It's important to understand that the doses required to cause these syndromes are far above what most people would encounter in everyday life, in most workplaces, or through routine medical procedures."
      },
      {
        "type": "h2",
        "text": "Regulations and Protection Measures"
      },
      {
        "type": "p",
        "text": "Regulatory standards are in place to mitigate the risks associated with radiation exposure, such as the dose limits outlined in the Code of Federal Regulations."
      },
      {
        "type": "p",
        "text": "These standards, which vary based on the body part affected, aim to ensure the safety of radiation workers."
      },
      {
        "type": "p",
        "text": "For instance, the annual whole-body dose limit is 5 rem per year for radiation workers and 0.1 rem per year for the general public."
      },
      {
        "type": "p",
        "text": "Note that these limits are far below the exposure levels discussed involving ARS."
      }
    ]
  },
  {
    "slug": "understanding-the-importance-of-shielding-design-in-medical-facilities-why-physicists-are-essential",
    "title": "The Importance of Shielding Designs in Medical Facilities",
    "excerpt": "A shielding design turns the room layout, X-ray equipment, workload, and surrounding occupancy into specific barrier requirements. Do it before construction so the project team knows what actually…",
    "readTime": "2 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Mar 26, 2024"
      },
      {
        "type": "p",
        "text": "A shielding design turns the room layout, X-ray equipment, workload, and surrounding occupancy into specific barrier requirements. Do it before construction so the project team knows what actually needs to be built."
      },
      {
        "type": "h2",
        "text": "The Foundation: NCRP-147 Guidelines"
      },
      {
        "type": "p",
        "text": "Adherence to established guidelines, such as those outlined by the National Council on Radiation Protection and Measurements (NCRP), is at the heart of shielding design."
      },
      {
        "type": "p",
        "text": "NCRP Report 147 provides comprehensive recommendations for radiation protection in medical facilities, offering detailed guidance on shielding requirements tailored to various equipment and procedures."
      },
      {
        "type": "h2",
        "text": "Harnessing Current Medical Research"
      },
      {
        "type": "p",
        "text": "Medical technology, associated risks, and safety considerations are constantly evolving. Keeping abreast of the latest research findings and industry trends is essential for effective shielding design."
      },
      {
        "type": "p",
        "text": "Physicists specializing in radiation protection continuously integrate insights from current medical research into their calculations and recommendations. This ensures that shielding designs remain compliant and reflect the most up-to-date understanding of radiation risks and mitigation strategies."
      },
      {
        "type": "h2",
        "text": "Precision through Industry Materials"
      },
      {
        "type": "p",
        "text": "Effective shielding is not solely reliant on calculations; the choice of materials is equally crucial. Modern advancements in material science offer a wide array of options for radiation shielding, each with unique properties and applications."
      },
      {
        "type": "p",
        "text": "Physicists leverage their expertise to select the most appropriate materials for each scenario, considering factors such as attenuation properties, cost-effectiveness, and structural compatibility."
      },
      {
        "type": "h2",
        "text": "Why You Need a Physicist"
      },
      {
        "type": "p",
        "text": "The complexity of shielding design necessitates the involvement of a qualified physicist. Here's why:"
      },
      {
        "type": "list",
        "items": [
          "Technical Expertise: Physicists possess a deep understanding of radiation physics, enabling them to accurately calculate shielding requirements based on factors such as source strength, distance, and exposure limits.",
          "Regulatory Compliance: Compliance with state and national regulations is non-negotiable in the medical field. Physicists are well-versed in these regulations and ensure that shielding designs meet or exceed all applicable standards.",
          "Customized Solutions: Every medical facility is unique, with its own layout, equipment, and operational requirements. Physicists provide tailored shielding solutions that address each facility's specific needs, maximizing safety while minimizing unnecessary costs or disruptions.",
          "Continual Improvement: By staying abreast of the latest research and technological advancements, physicists ensure that shielding designs remain effective and up-to-date in the face of evolving risks and challenges."
        ]
      },
      {
        "type": "p",
        "text": "The importance of shielding design in medical facilities cannot be overstated. By enlisting the expertise of a qualified physicist, facilities can rest assured that their shielding requirements are not only met but exceeded."
      },
      {
        "type": "p",
        "text": "From adhering to NCRP guidelines to harnessing the latest research insights and industry materials, physicists play a pivotal role in safeguarding the health and well-being of all those within the medical environment."
      }
    ]
  },
  {
    "slug": "what-x-ray-equipment-vendors-should-send-for-shielding-design",
    "title": "What X-Ray Equipment Vendors Should Send for Shielding Design",
    "excerpt": "Equipment vendors can shorten the shielding-design timeline by delivering a complete, final technical package early. A brochure or generic room layout is rarely enough for project-specific…",
    "readTime": "2 min read",
    "tag": "For Vendors",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Equipment vendors can shorten the shielding-design timeline by delivering a complete, final technical package early. A brochure or generic room layout is rarely enough for project-specific calculations and construction coordination."
      },
      {
        "type": "h2",
        "text": "Send the exact equipment package"
      },
      {
        "type": "list",
        "items": [
          "Manufacturer and exact model.",
          "Generator rating and applicable technique ranges.",
          "Tube, detector, table, gantry, wall-bucky, isocenter, and control locations.",
          "Common beam directions and mechanical travel limits.",
          "Manufacturer planning, installation, and site-preparation drawings.",
          "Required room clearances and equipment anchorage information.",
          "Any model-specific shielding or scatter information supplied by the manufacturer."
        ]
      },
      {
        "type": "h2",
        "text": "Help define expected use"
      },
      {
        "type": "p",
        "text": "The facility owns the clinical-use assumptions, but the vendor can help the team understand typical workflows, procedure types, acquisition modes, and equipment capabilities. Flag high-use applications, fluoroscopic modes, cone-beam functions, or configurations that may not be obvious from the model name."
      },
      {
        "type": "h2",
        "text": "Coordinate the final layout"
      },
      {
        "type": "list",
        "items": [
          "Confirm the equipment orientation on the latest architectural plan.",
          "Identify the operator and control location.",
          "Show fixed and mobile components and their likely operating positions.",
          "Notify the team when the model, generator, software capability, or room arrangement changes.",
          "Verify the installation matches the layout used for the shielding design."
        ]
      },
      {
        "type": "h2",
        "text": "Do not wait until delivery"
      },
      {
        "type": "p",
        "text": "Late equipment changes can trigger recalculation, document revisions, material changes, or rework. Send final data before shield-dependent construction and keep the shielding designer on the distribution list for significant changes."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "x-ray-equipment-installation-guide",
    "title": "Essential X-ray Equipment Installation Guide for Facility Owners and Contractors",
    "excerpt": "Plan an X-ray room with fewer delays. A practical shielding and installation checklist for facility owners, architects, contractors, and equipment vendors.",
    "readTime": "4 min read",
    "tag": "For Contractors",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Installing X-ray equipment goes smoothly when the room, equipment, shielding, utilities, and regulatory requirements are coordinated before the install date. Most expensive problems happen when one of those items is discovered after construction has already started."
      },
      {
        "type": "p",
        "text": "BEFORE CONSTRUCTION: INFORMATION TO COORDINATE"
      },
      {
        "type": "p",
        "text": "• Final floor plan and room dimensions. Use the latest architectural plan, with a reliable scale and room names."
      },
      {
        "type": "p",
        "text": "• Exact equipment and generator. Provide the manufacturer, model, generator rating, tube locations, expected beam directions, and the manufacturer’s planning or installation drawings. “Similar equipment” is often not enough for a final design."
      },
      {
        "type": "p",
        "text": "• Expected clinical use. Estimate the number and type of procedures, operating schedule, technique factors, and anticipated growth. The shielding designer will translate this information into an appropriate design workload."
      },
      {
        "type": "p",
        "text": "• Every adjacent space. Identify occupancy beyond each wall and on the floors above and below. Include exterior areas, roofs, corridors, offices, waiting rooms, and any space whose use could change."
      },
      {
        "type": "p",
        "text": "• Existing and proposed construction. Document wall, floor, and ceiling materials and thicknesses. Flag doors, windows, ducts, electrical boxes, plumbing, and other penetrations that may interrupt a barrier."
      },
      {
        "type": "p",
        "text": "• Control area and equipment geometry. Confirm control booth, door, tube, detector, table, gantry, and mobile-equipment locations. Small layout changes can change a barrier calculation."
      },
      {
        "type": "p",
        "text": "• State and local jurisdiction. Identify the project location early. Plan-review, registration, survey, inspection, and submission requirements vary by state and by project."
      },
      {
        "type": "p",
        "text": "RECOMMENDED PROJECT SEQUENCE"
      },
      {
        "type": "p",
        "text": "1. Select the modality and equipment. Confirm the exact model whenever possible."
      },
      {
        "type": "p",
        "text": "2. Freeze the relevant plan. Resolve room dimensions, equipment orientation, adjacent occupancy, doors, control areas, and major penetrations."
      },
      {
        "type": "p",
        "text": "3. Complete the shielding design. The designer uses the equipment, workload, geometry, construction, and occupancy information to calculate the required barriers and prepare construction-ready documentation."
      },
      {
        "type": "p",
        "text": "4. Complete any required pre-construction review. Some jurisdictions require shielding plans or other information before construction or installation. Confirm the applicable process before beginning shield-dependent work."
      },
      {
        "type": "p",
        "text": "5. Build and document the barriers. The contractor should follow the shielding details, coordinate penetrations, preserve required overlaps and continuity, and document substitutions or field changes before covering the work."
      },
      {
        "type": "p",
        "text": "6. Install the equipment. Verify that the final equipment location and orientation match the information used in the design."
      },
      {
        "type": "p",
        "text": "7. Complete surveys or inspections when required. A qualified professional can evaluate the installed room under appropriate operating conditions and document measurements. Requirements and timing vary."
      },
      {
        "type": "p",
        "text": "8. Finish registration and authorization steps before clinical use. The facility remains responsible for completing the steps required by its jurisdiction."
      },
      {
        "type": "p",
        "text": "RESPONSIBILITY CHECKLIST"
      },
      {
        "type": "p",
        "text": "Facility owner or operator"
      },
      {
        "type": "p",
        "text": "• Identify the project jurisdiction and regulatory contacts."
      },
      {
        "type": "p",
        "text": "• Approve the equipment, final layout, intended use, and schedule."
      },
      {
        "type": "p",
        "text": "• Provide accurate workload and occupancy information."
      },
      {
        "type": "p",
        "text": "• Complete required registrations, submissions, and operating procedures."
      },
      {
        "type": "p",
        "text": "Architect"
      },
      {
        "type": "p",
        "text": "• Maintain the coordinated floor plan and reflected ceiling information."
      },
      {
        "type": "p",
        "text": "• Show adjacent occupancy above, below, and around the room."
      },
      {
        "type": "p",
        "text": "• Incorporate shielding details into the construction documents."
      },
      {
        "type": "p",
        "text": "• Coordinate doors, windows, penetrations, and wall assemblies."
      },
      {
        "type": "p",
        "text": "Contractor and shielding installer"
      },
      {
        "type": "p",
        "text": "• Build from the current shielding drawings and specifications."
      },
      {
        "type": "p",
        "text": "• Verify material type and thickness before installation."
      },
      {
        "type": "p",
        "text": "• Maintain barrier continuity at joints, corners, doors, frames, and penetrations."
      },
      {
        "type": "p",
        "text": "• Raise conflicts or substitutions before the work is concealed."
      },
      {
        "type": "p",
        "text": "Equipment vendor"
      },
      {
        "type": "p",
        "text": "• Provide final equipment planning drawings and technical data."
      },
      {
        "type": "p",
        "text": "• Confirm tube, detector, table, gantry, control, and isocenter locations."
      },
      {
        "type": "p",
        "text": "• Notify the team when the selected model or room layout changes."
      },
      {
        "type": "p",
        "text": "• Install the equipment in the designed position and orientation."
      },
      {
        "type": "p",
        "text": "Shielding designer or qualified physicist"
      },
      {
        "type": "p",
        "text": "• Request and document the project inputs."
      },
      {
        "type": "p",
        "text": "• Perform project-specific calculations and prepare shielding recommendations."
      },
      {
        "type": "p",
        "text": "• Coordinate questions with the design and installation team."
      },
      {
        "type": "p",
        "text": "• Revise the design when material project inputs change."
      },
      {
        "type": "p",
        "text": "COMMON COSTLY MISTAKES"
      },
      {
        "type": "p",
        "text": "• Starting framing or ordering lead before the equipment and layout are final."
      },
      {
        "type": "p",
        "text": "• Designing from an unscaled sketch or an obsolete architectural sheet."
      },
      {
        "type": "p",
        "text": "• Forgetting occupied space above, below, outside, or on the far side of a corridor."
      },
      {
        "type": "p",
        "text": "• Treating an equipment replacement as automatically equivalent to the old unit."
      },
      {
        "type": "p",
        "text": "• Moving the tube, table, gantry, control area, or door after the design is complete."
      },
      {
        "type": "p",
        "text": "• Allowing unreviewed penetrations, gaps, or field substitutions in a barrier."
      },
      {
        "type": "p",
        "text": "• Assuming every state follows the same submission and inspection process."
      },
      {
        "type": "p",
        "text": "• Waiting until equipment delivery to begin shielding coordination."
      },
      {
        "type": "p",
        "text": "MODALITY-SPECIFIC PLANNING NOTES"
      },
      {
        "type": "p",
        "text": "General radiography"
      },
      {
        "type": "p",
        "text": "Fixed tube and bucky locations, beam directions, workload, room geometry, and all surrounding occupancy matter. Floors and ceilings may be part of the shielding envelope, not just walls and doors."
      },
      {
        "type": "p",
        "text": "CT and cone-beam CT"
      },
      {
        "type": "p",
        "text": "Requirements depend on workload, technique, scatter distribution, equipment geometry, and occupancy. Confirm the scanner model, isocenter, gantry orientation, scan volume, and expected procedure mix. Do not assume CT and CBCT rooms have interchangeable requirements."
      },
      {
        "type": "p",
        "text": "Fluoroscopy and C-arms"
      },
      {
        "type": "p",
        "text": "Scatter radiation and procedure mix can strongly influence the design. For mobile C-arms, identify where the unit will be used, common beam orientations, and likely staff positions rather than relying on one fixed setup."
      },
      {
        "type": "p",
        "text": "Mammography"
      },
      {
        "type": "p",
        "text": "Mammography uses different beam qualities and operating patterns from general radiography. Provide the exact unit, room layout, workload, and adjacent occupancy so the design reflects the installation rather than a generic room type."
      },
      {
        "type": "p",
        "text": "Dental, panoramic, cephalometric, and dental CBCT"
      },
      {
        "type": "p",
        "text": "These systems have different geometries and workloads. Operator position, patient orientation, beam direction, adjacent occupancy, and whether the equipment is intraoral, panoramic, cephalometric, or CBCT should be clear."
      },
      {
        "type": "p",
        "text": "Veterinary imaging"
      },
      {
        "type": "p",
        "text": "Animal handling can affect operator location and workflow. Document the equipment, expected procedure mix, restraint practices, room geometry, and occupancy just as carefully as for human imaging."
      },
      {
        "type": "p",
        "text": "REQUIREMENTS VARY"
      },
      {
        "type": "p",
        "text": "This guide is general planning information. It is not a shielding calculation, regulatory approval, or guarantee of compliance. The required design inputs, submission process, construction details, surveys, inspections, and registrations depend on the equipment, facility, jurisdiction, and actual use."
      },
      {
        "type": "p",
        "text": "START YOUR SHIELDING PROJECT"
      },
      {
        "type": "p",
        "text": "Bring Heartland Physics into the project before shield-dependent construction begins."
      },
      {
        "type": "p",
        "text": "To get started, send the project state, current floor plan, equipment manufacturer and model, manufacturer planning drawings, expected workload, room construction, and occupancy information for every adjacent area—including above and below."
      },
      {
        "type": "p",
        "text": "Heartland Physics can use those project details to prepare shielding recommendations and help your team coordinate the next steps."
      }
    ]
  },
  {
    "slug": "x-ray-registration-guides-by-state",
    "title": "X-Ray Registration & Shielding Requirements by State: 50-State Guide",
    "excerpt": "Find X-ray registration, shielding, plan-review, agency, and filing guidance for all 50 states, with official-source links and Heartland Physics resources.",
    "readTime": "3 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Installing, replacing, relocating, or remodeling an X-ray room? Start with the state. Registration, shielding-plan review, qualified-expert rules, fees, inspections, and filing methods can vary by jurisdiction. Heartland Physics maintains this 50-state guide so facility owners, architects, contractors, equipment vendors, and imaging practices can get to the right state information quickly."
      },
      {
        "type": "p",
        "text": "Each state guide is written as a practical starting point and links readers back to the responsible government agency or official filing resources. The regulator's current requirements always control if a rule, form, fee, or process changes."
      },
      {
        "type": "h2",
        "text": "Choose Your State"
      },
      {
        "type": "p",
        "text": "Select a state below for its X-ray registration and shielding guide."
      },
      {
        "type": "h3",
        "text": "A-C"
      },
      {
        "type": "list",
        "items": [
          "Alabama X-Ray Registration & Shielding Guide",
          "Alaska X-Ray Registration & Shielding Guide",
          "Arizona X-Ray Registration & Shielding Guide",
          "Arkansas X-Ray Registration & Shielding Guide",
          "California X-Ray Registration & Shielding Guide",
          "Colorado X-Ray Registration & Shielding Guide",
          "Connecticut X-Ray Registration & Shielding Guide"
        ]
      },
      {
        "type": "h3",
        "text": "D-I"
      },
      {
        "type": "list",
        "items": [
          "Delaware X-Ray Registration & Shielding Guide",
          "Florida X-Ray Registration & Shielding Guide",
          "Georgia X-Ray Registration & Shielding Guide",
          "Hawaii X-Ray Registration & Shielding Guide",
          "Idaho X-Ray Registration & Shielding Guide",
          "Illinois X-Ray Registration & Shielding Guide",
          "Indiana X-Ray Registration & Shielding Guide",
          "Iowa X-Ray Registration & Shielding Guide"
        ]
      },
      {
        "type": "h3",
        "text": "K-M"
      },
      {
        "type": "list",
        "items": [
          "Kansas X-Ray Registration & Shielding Guide",
          "Kentucky X-Ray Registration & Shielding Guide",
          "Louisiana X-Ray Registration & Shielding Guide",
          "Maine X-Ray Registration & Shielding Guide",
          "Maryland X-Ray Registration & Shielding Guide",
          "Massachusetts X-Ray Registration & Shielding Guide",
          "Michigan X-Ray Registration & Shielding Guide",
          "Minnesota X-Ray Registration & Shielding Guide",
          "Mississippi X-Ray Registration & Shielding Guide",
          "Missouri X-Ray Registration & Shielding Guide",
          "Montana X-Ray Registration & Shielding Guide"
        ]
      },
      {
        "type": "h3",
        "text": "N-P"
      },
      {
        "type": "list",
        "items": [
          "Nebraska X-Ray Registration & Shielding Guide",
          "Nevada X-Ray Registration & Shielding Guide",
          "New Hampshire X-Ray Registration & Shielding Guide",
          "New Jersey X-Ray Registration & Shielding Guide",
          "New Mexico X-Ray Registration & Shielding Guide",
          "New York X-Ray Registration & Shielding Guide",
          "North Carolina X-Ray Registration & Shielding Guide",
          "North Dakota X-Ray Registration & Shielding Guide",
          "Ohio X-Ray Registration & Shielding Guide",
          "Oklahoma X-Ray Registration & Shielding Guide",
          "Oregon X-Ray Registration & Shielding Guide",
          "Pennsylvania X-Ray Registration & Shielding Guide"
        ]
      },
      {
        "type": "h3",
        "text": "R-W"
      },
      {
        "type": "list",
        "items": [
          "Rhode Island X-Ray Registration & Shielding Guide",
          "South Carolina X-Ray Registration & Shielding Guide",
          "South Dakota X-Ray Registration & Shielding Guide",
          "Tennessee X-Ray Registration & Shielding Guide",
          "Texas X-Ray Registration & Shielding Guide",
          "Utah X-Ray Registration & Shielding Guide",
          "Vermont X-Ray Registration & Shielding Guide",
          "Virginia X-Ray Registration & Shielding Guide",
          "Washington X-Ray Registration & Shielding Guide",
          "West Virginia X-Ray Registration & Shielding Guide",
          "Wisconsin X-Ray Registration & Shielding Guide",
          "Wyoming X-Ray Registration & Shielding Guide"
        ]
      },
      {
        "type": "h2",
        "text": "What Each State Guide Covers"
      },
      {
        "type": "list",
        "items": [
          "The responsible state or local radiation-control agency.",
          "X-ray machine and facility registration steps and official filing links.",
          "Shielding-plan review or related room-design requirements when they apply.",
          "Qualified-expert, physicist, or service-provider rules when the jurisdiction uses them.",
          "Fees, timing, inspections, and recordkeeping when current official sources publish them.",
          "Official-source links and a Heartland Physics review date so readers can verify current requirements."
        ]
      },
      {
        "type": "h2",
        "text": "Who This 50-State X-Ray Guide Is For"
      },
      {
        "type": "list",
        "items": [
          "Medical, dental, veterinary, and outpatient imaging facility owners and administrators.",
          "Healthcare architects, engineers, and planners coordinating X-ray or imaging rooms.",
          "General contractors and specialty contractors building or remodeling imaging spaces.",
          "X-ray, CT, fluoroscopy, mammography, dental CBCT, and other diagnostic imaging equipment vendors and installers.",
          "Project teams trying to understand what has to happen before construction, installation, relocation, or equipment replacement."
        ]
      },
      {
        "type": "h2",
        "text": "How to Use the State Guides"
      },
      {
        "type": "list",
        "items": [
          "Choose the state where the X-ray equipment will be installed or operated.",
          "Review the state guide before construction, equipment installation, relocation, or a major equipment change.",
          "Open the linked official agency pages and use the current regulator forms and instructions.",
          "Gather the room plan, equipment details, intended use, and surrounding occupancy information if a shielding design or review is needed.",
          "Contact Heartland Physics for shielding-design help where its current qualifications and authorization cover the project."
        ]
      },
      {
        "type": "h2",
        "text": "Important Jurisdiction Note"
      },
      {
        "type": "p",
        "text": "X-ray registration and shielding requirements are not identical nationwide. Some states require a shielding plan or design to be submitted before installation or construction; others use different review, survey, registration, or record-retention processes. Local jurisdictions can also add requirements. Use the individual state guide as a starting point, then follow the current instructions from the responsible regulator."
      },
      {
        "type": "h2",
        "text": "Common Questions"
      },
      {
        "type": "p",
        "text": "Does every state require the same X-ray shielding plan?"
      },
      {
        "type": "p",
        "text": "No. Registration, plan-review, shielding, survey, inspection, and professional-qualification requirements vary by jurisdiction and by the type and use of the equipment."
      },
      {
        "type": "p",
        "text": "Does every X-ray room need lead-lined walls?"
      },
      {
        "type": "p",
        "text": "No. Barrier requirements depend on the equipment, workload, beam geometry, distances, surrounding occupancy, existing construction, and the applicable design criteria. The shielding calculation should determine what is actually needed."
      },
      {
        "type": "p",
        "text": "When should an X-ray shielding design be completed?"
      },
      {
        "type": "p",
        "text": "When shielding design or review is applicable, it should be addressed early enough to guide construction and equipment placement. Doing it after walls, doors, or equipment locations are fixed can create avoidable rework."
      },
      {
        "type": "p",
        "text": "Can Heartland Physics prepare shielding designs in every state?"
      },
      {
        "type": "p",
        "text": "Heartland Physics provides shielding design services for projects where its current qualifications and authorization cover the work. Send the project location and details and Heartland Physics can confirm the appropriate next step."
      },
      {
        "type": "h2",
        "text": "Need an X-Ray Shielding Design?"
      },
      {
        "type": "p",
        "text": "Heartland Physics prepares physicist-led radiation shielding designs and X-ray shielding calculations for diagnostic imaging projects where its current qualifications and authorization cover the work. If you are planning a new room, remodel, equipment replacement, or relocation, send the project location and available drawings so the shielding scope can be reviewed early."
      },
      {
        "type": "p",
        "text": "Technical and regulatory note: Heartland Physics maintains these guides as practical reference material. Requirements can change, and the responsible state or local radiation-control agency is the controlling source for current rules, forms, fees, and filing instructions."
      }
    ]
  },
  {
    "slug": "x-ray-room-planning-for-small-imaging-facilities",
    "title": "X-Ray Room Planning for Small Imaging Facilities",
    "excerpt": "Dental offices, veterinary clinics, urgent-care centers, orthopedic practices, outpatient imaging sites, and other small facilities often have tight rooms, tight schedules, and little tolerance for…",
    "readTime": "2 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Dental offices, veterinary clinics, urgent-care centers, orthopedic practices, outpatient imaging sites, and other small facilities often have tight rooms, tight schedules, and little tolerance for construction rework. Early coordination is the most effective cost-control step."
      },
      {
        "type": "h2",
        "text": "Start with the room and the equipment"
      },
      {
        "type": "list",
        "items": [
          "Confirm the exact modality and model before finalizing the room.",
          "Use a current scaled plan with clear room dimensions.",
          "Identify where the operator, patient, tube, detector, table, and control will be located.",
          "Label every adjacent area, including tenant spaces, corridors, exterior areas, and floors above and below.",
          "Document existing walls, slabs, ceilings, doors, windows, and penetrations."
        ]
      },
      {
        "type": "h2",
        "text": "Avoid false savings"
      },
      {
        "type": "p",
        "text": "Reusing an old room, copying a neighboring facility, or ordering shielding before calculations may appear faster. If the equipment, workload, occupancy, construction, or jurisdiction differs, those shortcuts can lead to excess material, insufficient coordination, delayed review, or rework."
      },
      {
        "type": "h2",
        "text": "Assign the regulatory tasks"
      },
      {
        "type": "list",
        "items": [
          "Identify the project state and responsible agency early.",
          "Confirm whether pre-construction plan review is required.",
          "Assign equipment registration and facility paperwork.",
          "Confirm whether a post-installation survey or inspection is required.",
          "Schedule required steps before the planned opening date."
        ]
      },
      {
        "type": "h2",
        "text": "Build a simple decision chain"
      },
      {
        "type": "p",
        "text": "Use one current plan, one approved equipment selection, and one person responsible for routing changes. Bring the architect, contractor, vendor, and shielding designer together before walls are closed."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "x-ray-shielding-construction-guide-for-contractors-and-installers",
    "title": "X-Ray Shielding Construction Guide for Contractors and Installers",
    "excerpt": "A shielding design becomes effective only when the specified barriers are installed continuously and match the final room and equipment layout. Contractors and shielding installers should treat the…",
    "readTime": "2 min read",
    "tag": "For Contractors",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "A shielding design becomes effective only when the specified barriers are installed continuously and match the final room and equipment layout. Contractors and shielding installers should treat the shielding documents as coordinated construction requirements, not as an isolated lead schedule."
      },
      {
        "type": "h2",
        "text": "Before ordering materials"
      },
      {
        "type": "list",
        "items": [
          "Confirm that the equipment model, room plan, and shielding design are final.",
          "Verify barrier material, thickness, height, extent, and location.",
          "Compare shielding drawings with architectural, structural, MEP, and equipment-vendor documents.",
          "Identify conflicts at doors, frames, windows, ducts, conduits, outlets, med-gas, and other penetrations.",
          "Confirm whether jurisdictional review must be completed before construction."
        ]
      },
      {
        "type": "h2",
        "text": "Protect barrier continuity"
      },
      {
        "type": "p",
        "text": "Joints, corners, fasteners, seams, door frames, glazing frames, floor transitions, ceiling transitions, and penetrations can interrupt an otherwise correct barrier. Follow the project-specific details and coordinate overlaps rather than assuming separate trades will close the gaps."
      },
      {
        "type": "p",
        "text": "Do not substitute materials based only on equal thickness. Different materials and assemblies do not necessarily provide equivalent attenuation."
      },
      {
        "type": "h2",
        "text": "Document the work"
      },
      {
        "type": "list",
        "items": [
          "Record product names, thicknesses, batch or certification information when available, and installed locations.",
          "Photograph barriers, joints, penetrations, and door-frame conditions before concealment.",
          "Maintain a current marked plan for field changes.",
          "Escalate discrepancies before walls or ceilings are closed.",
          "Confirm that the installed equipment position and orientation match the design basis."
        ]
      },
      {
        "type": "h2",
        "text": "Stop and ask when inputs change"
      },
      {
        "type": "p",
        "text": "Moving the tube, gantry, table, control area, or door; changing adjacent occupancy; revising wall construction; or adding a penetration can change the recommendation. Route these changes back to the design team before continuing."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "x-ray-shielding-coordination-guide-for-architects",
    "title": "X-Ray Shielding Coordination Guide for Architects",
    "excerpt": "Architects can prevent most shielding-related redesign by establishing the equipment, room geometry, occupancy, and jurisdictional assumptions before construction documents are issued. This guide…",
    "readTime": "2 min read",
    "tag": "For Architects",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "Architects can prevent most shielding-related redesign by establishing the equipment, room geometry, occupancy, and jurisdictional assumptions before construction documents are issued. This guide shows what the shielding designer needs and where those requirements should appear in the architectural set."
      },
      {
        "type": "h2",
        "text": "Coordinate these inputs at kickoff"
      },
      {
        "type": "list",
        "items": [
          "Project state and local jurisdiction.",
          "Exact equipment manufacturer, model, generator, tube positions, detector locations, and vendor planning drawings.",
          "Final room dimensions, equipment orientation, control location, doors, windows, and major penetrations.",
          "Actual occupancy around every wall and on the levels above and below.",
          "Existing and proposed wall, floor, ceiling, door, and window construction.",
          "Expected clinical use, workload, procedure mix, and anticipated growth."
        ]
      },
      {
        "type": "h2",
        "text": "Show the complete shielding envelope"
      },
      {
        "type": "p",
        "text": "Do not limit coordination to the four walls. Floors, ceilings, roofs, exterior areas, corridors, control barriers, doors, frames, glazing, and penetrations may affect the design. Label adjacent spaces by actual use rather than relying only on room numbers."
      },
      {
        "type": "p",
        "text": "Use a reliable scale and identify the drawing revision used for the calculations. If the room layout changes, make the shielding designer part of the change review."
      },
      {
        "type": "h2",
        "text": "Carry requirements into the documents"
      },
      {
        "type": "list",
        "items": [
          "Reference the shielding report and drawings in the project manual.",
          "Detail barrier continuity at corners, joints, doors, frames, windows, and penetrations.",
          "Coordinate structural, mechanical, electrical, plumbing, and med-gas work that crosses a barrier.",
          "Require review before material substitutions or layout changes.",
          "Keep obsolete shielding drawings out of the field set."
        ]
      },
      {
        "type": "h2",
        "text": "Avoid late RFIs"
      },
      {
        "type": "p",
        "text": "The highest-cost questions usually appear after framing or equipment release: Which model is final? What is above the room? Can a duct cross this wall? Does the door need shielding? Resolve these before shield-dependent work begins whenever possible."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "x-ray-shielding-design-for-general-radiography-rooms",
    "title": "X-Ray Shielding Design for General Radiography Rooms",
    "excerpt": "General radiography rooms may appear straightforward, but fixed beam directions, tube travel, wall and table bucky locations, workload, control geometry, and adjacent occupancy all affect the…",
    "readTime": "3 min read",
    "tag": "Shielding Design",
    "updated": "Last updated Aug 18",
    "blocks": [
      {
        "type": "p",
        "text": "General radiography rooms may appear straightforward, but fixed beam directions, tube travel, wall and table bucky locations, workload, control geometry, and adjacent occupancy all affect the shielding design."
      },
      {
        "type": "h2",
        "text": "Required equipment information"
      },
      {
        "type": "list",
        "items": [
          "Exact radiographic system and generator.",
          "Tube-stand travel and common tube positions.",
          "Wall-bucky and table-bucky locations.",
          "Technique ranges and expected procedure mix.",
          "Estimated procedures or workload.",
          "Manufacturer planning and installation drawings."
        ]
      },
      {
        "type": "h2",
        "text": "Required room information"
      },
      {
        "type": "list",
        "items": [
          "Current scaled floor plan and room dimensions.",
          "Control booth, viewing window, doors, and equipment orientation.",
          "Occupancy beyond every wall and above and below.",
          "Wall, floor, ceiling, door, and window construction.",
          "Ducts, electrical boxes, conduits, plumbing, and other penetrations."
        ]
      },
      {
        "type": "h2",
        "text": "Common coordination mistakes"
      },
      {
        "type": "p",
        "text": "Do not assume walls and doors are the only barriers. Floors and ceilings may be part of the shielding envelope. Do not move a tube stand, wall bucky, control booth, or door after calculations without review."
      },
      {
        "type": "p",
        "text": "An equipment replacement should be checked against the new model and expected use rather than assumed equivalent to the previous unit."
      },
      {
        "type": "h2",
        "text": "Before clinical use"
      },
      {
        "type": "p",
        "text": "Confirm required jurisdictional steps, registration, and any survey or inspection. Timing and documentation vary by state and project."
      },
      {
        "type": "h2",
        "text": "A practical next step"
      },
      {
        "type": "p",
        "text": "Start your project with Heartland Physics. Send the project state, current floor plan, equipment manufacturer and model, manufacturer planning documents, expected workload, room construction, and occupancy on every side - including above and below. Visit Heartland Physics to begin.",
        "links": [
          {
            "text": "Visit Heartland Physics",
            "href": "https://heartlandphysics.com/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Requirements vary by state and project. This page is general planning information, not a shielding calculation, regulatory approval, or guarantee of compliance."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-alabama-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Alabama: A Simple Step-by-Step Guide",
    "excerpt": "Opening an X-ray room in Alabama does not have to feel confusing. This page gives the complete state-level path for registering medical, dental, veterinary, chiropractic, and similar X-ray equipment.",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening an X-ray room in Alabama does not have to feel confusing. This page gives the complete state-level path for registering medical, dental, veterinary, chiropractic, and similar X-ray equipment."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Most new fixed X-ray and fluoroscopy rooms need Alabama shielding approval before installation. The facility must also register every X-ray machine before use. Alabama asks applicants to allow at least six weeks for a complete shielding review."
      },
      {
        "type": "h2",
        "text": "Start here: forms and direct filing links"
      },
      {
        "type": "p",
        "text": "Each button opens the exact official form or instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Fillable Alabama Registration Form",
            "href": "https://www.alabamapublichealth.gov/radiation/assets/medxrayreg.fillable1.pdf"
          },
          {
            "label": "Open the Alabama Shielding Plan Guide",
            "href": "https://www.alabamapublichealth.gov/radiation/assets/shieldingplanguide.pdf"
          },
          {
            "label": "Open Alabama’s Medical X-Ray Forms Page",
            "href": "https://www.alabamapublichealth.gov/radiation/forms.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather"
      },
      {
        "type": "list",
        "items": [
          "Legal facility name and physical address",
          "Owner and facility contact information",
          "Name of the person responsible for radiation control",
          "Machine room number, manufacturer, model, serial number, maximum kVp and mA, tube count, machine type, mobility, and use",
          "Scaled room drawing, nearby room uses, construction materials, and machine placement for the shielding design"
        ]
      },
      {
        "type": "h2",
        "text": "Step 1: Decide which shielding path applies"
      },
      {
        "type": "p",
        "text": "A new fixed X-ray or fluoroscopy installation needs a shielding plan approved before installation. This includes veterinary, cone-beam CT, and bone-density installations. An existing X-ray room may use a radiation-protection survey instead."
      },
      {
        "type": "p",
        "text": "A mobile fluoroscopy unit routinely used in one dedicated procedure room needs a shielding plan or survey. A mobile radiographic unit does not need shielding review unless it is being used as a fixed unit."
      },
      {
        "type": "p",
        "text": "A dental facility with only panoramic, intraoral, or portable equipment does not need a shielding plan. Handheld dental units follow Alabama’s separate handheld registration instructions."
      },
      {
        "type": "h2",
        "text": "Step 2: Prepare the shielding package"
      },
      {
        "type": "p",
        "text": "The shielding package should include the scale drawing, equipment location, workload, adjacent-area use, barrier materials, and site-specific shielding calculations, and it must match the room that will actually be built."
      },
      {
        "type": "h2",
        "text": "Step 3: Send the shielding package"
      },
      {
        "type": "p",
        "text": "Email the shielding package to medicalxrayshielding@adph.state.al.us. The mailing option is Alabama Department of Public Health, Office of Radiation Control, P.O. Box 303017, Montgomery, AL 36130-3017. Allow at least six weeks after the state receives a complete package."
      },
      {
        "type": "h2",
        "text": "Step 4: Complete and send the registration form"
      },
      {
        "type": "p",
        "text": "Enter the legal facility information, responsible person, and every machine and tube on the fillable registration form. Email the completed form to medicalxrayregistration@adph.state.al.us or mail it to the same Office of Radiation Control address."
      },
      {
        "type": "h2",
        "text": "Step 5: Wait for shielding approval, then install"
      },
      {
        "type": "p",
        "text": "Do not install a fixed unit in a new room until the shielding plan is approved. Build the room to match the approved drawing. Keep the approved plan, approval letter, and machine registration with the radiation-safety records."
      },
      {
        "type": "h2",
        "text": "Step 6: Begin operation only after the paperwork is complete"
      },
      {
        "type": "p",
        "text": "Alabama normally does not require a state inspection before first use. The shielding approval and facility registration still must be complete, and the equipment must meet all operating, safety, and quality-control rules."
      },
      {
        "type": "h2",
        "text": "Jefferson County and Birmingham"
      },
      {
        "type": "p",
        "text": "Jefferson County operates a separate radiation program. Facilities in that county should use the official Jefferson County radiation-program contact page for the county step while also completing the applicable Alabama requirements."
      },
      {
        "type": "h2",
        "text": "Do not make this mistake"
      },
      {
        "type": "p",
        "text": "Do not build the walls first. A late shielding change can require opening a wall, replacing a door, adding lead, or moving the machine."
      },
      {
        "type": "h2",
        "text": "How Heartland Physics can help"
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the Alabama project and confirm whether its current qualifications and authorization cover the shielding work. Complete any required shielding work before construction so the technical package matches the room that will actually be built."
      },
      {
        "type": "h2",
        "text": "State program contact"
      },
      {
        "type": "p",
        "text": "Alabama Office of Radiation Control: use the official state program contact page. Registration email: medicalxrayregistration@adph.state.al.us. Shielding email: medicalxrayshielding@adph.state.al.us."
      },
      {
        "type": "h2",
        "text": "Source note"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "The state or local authority controls if a requirement changes before the next review."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-alaska-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Alaska: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Alaska can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Alaska can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Alaska requires X-ray-producing devices to be registered with the Department of Health. The Radiological Health program uses its facility and device database for facility, device, and vendor records."
      },
      {
        "type": "p",
        "text": "Confirm the current registration fee and any plan-review requirements with the program before installation or routine use."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Alaska Radiological Health",
            "href": "https://health.alaska.gov/en/division-of-public-health/alaska-public-laboratories/radiological-health/"
          },
          {
            "label": "Open Alaska Dental X-Ray Device Guidance",
            "href": "https://health.alaska.gov/en/resources/dental-x-ray-devices/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Coordinate shielding and room-layout review before construction or installation when the project requires it. Alaska reviews radiation-protection information and may require qualified-expert involvement depending on the service and equipment."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the Alaska Radiological Health facility/device registration process and enter the facility, owner, Radiation Safety Officer, equipment, tube, and location information requested by the program."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the registration information through the current Alaska Radiological Health process and keep the program's confirmation with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration information current when equipment, ownership, location, or responsible personnel change. Complete any installation or radiation-safety review required for the project."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Alaska's current public materials should be checked for the applicable update or renewal cycle for the specific facility and device category."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Fees depend on the equipment and registration category and have changed over time. Confirm the current amount with Alaska Radiological Health before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Alaska Radiological Health: doh.radiation.info@alaska.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Alaska Source",
            "href": "https://health.alaska.gov/en/division-of-public-health/alaska-public-laboratories/radiological-health/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-american-samoa-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in American Samoa: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in American Samoa can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in American Samoa can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "American Samoa does not currently publish a clearly identified general X-ray machine registration portal or current radiation-machine fee schedule on the public government website."
      },
      {
        "type": "p",
        "text": "Before acquiring or installing equipment, contact the American Samoa Department of Health and obtain the current registration, inspection, and radiation-protection requirements in writing."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the American Samoa Government",
            "href": "https://www.americansamoa.gov/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Ask the Department of Health whether a shielding plan, room drawing, pre-installation review, or post-installation radiation survey is required for the proposed equipment before construction begins."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Request the current radiation-machine or facility application from the Department of Health and confirm which office has jurisdiction over the specific medical, dental, veterinary, research, or industrial installation."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Follow the filing method provided by the Department of Health. Include the facility, owner, responsible operator, equipment inventory, and shielding or inspection documentation requested by the regulator."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not assume that a mainland U.S. state process applies. Retain the Department's written instructions, approval or registration, equipment records, and inspection documentation."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "No single current public renewal cycle was identified for all X-ray installations. Confirm the renewal or reinspection schedule directly with the Department of Health."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "No current general X-ray registration fee schedule was identified on the public source reviewed. Confirm fees before filing."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Contact the American Samoa Department of Health through the current American Samoa Government directory and ask to be routed to the office responsible for radiation-producing equipment."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official American Samoa Source",
            "href": "https://www.americansamoa.gov/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-arizona-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Arizona: A Simple Step-by-Step Guide",
    "excerpt": "This page gives the complete Arizona path for opening a healing-arts X-ray facility and registering its equipment.",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "This page gives the complete Arizona path for opening a healing-arts X-ray facility and registering its equipment."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "A new facility files BRC-4. Each healing-arts X-ray machine gets its own BRC-4X. A new machine must be registered within 30 days after installation, and registration is not complete until the application fee is paid."
      },
      {
        "type": "h2",
        "text": "Start here: forms and direct filing links"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the New Facility Form (BRC-4)",
            "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/xray/registration/xray-brc-4.pdf"
          },
          {
            "label": "Download the Machine Form (BRC-4X)",
            "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/xray/registration/xray-arra-4x.pdf"
          },
          {
            "label": "Download Arizona’s X-Ray Fee Schedule",
            "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/forms/xray-fee-schedule.pdf"
          },
          {
            "label": "Open the Arizona X-Ray Program",
            "href": "https://www.azdhs.gov/licensing/radiation-regulatory/index.php#xray"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather"
      },
      {
        "type": "list",
        "items": [
          "Legal facility name, physical address, mailing address, email, and phone",
          "Owner and Radiation Safety Officer information",
          "Machine type, manufacturer, model, serial number, tube count, maximum kVp, and installation date",
          "Installer information",
          "Scaled room plan and construction details",
          "Qualified-expert evaluation for CT or cone-beam CT when applicable"
        ]
      },
      {
        "type": "h2",
        "text": "Step 1: Complete BRC-4"
      },
      {
        "type": "p",
        "text": "Mark New Facility. Enter the owner, facility, Radiation Safety Officer, machine count, facility type, and requested compliance information. The same form is used later for amendments and the 10-year renewal."
      },
      {
        "type": "h2",
        "text": "Step 2: Complete one BRC-4X for every machine"
      },
      {
        "type": "p",
        "text": "Enter the facility, machine type, manufacturer, model, serial number, tube information, room location, installation date, and operating use. Multiple machines require multiple BRC-4X forms."
      },
      {
        "type": "h2",
        "text": "Step 3: Attach the room and shielding information"
      },
      {
        "type": "p",
        "text": "For many stationary units and mobile units routinely used in one place, the technical package may include a scale drawing showing the room dimensions, machine, walls, doors, barrier construction and lead equivalence, nearby occupied areas, workload, and shielding calculations. Use a provider whose current qualifications cover the required work."
      },
      {
        "type": "h2",
        "text": "Step 4: Include equipment evaluations"
      },
      {
        "type": "p",
        "text": "For CT and cone-beam CT, include the latest or initial qualified-expert unit evaluation. The installer supplies installation and assembly records; Heartland Physics coordinates the physics portion with the facility."
      },
      {
        "type": "h2",
        "text": "Step 5: Calculate and include the fee"
      },
      {
        "type": "p",
        "text": "Arizona’s posted per-tube application and annual rates are $75 for hospitals; $51 for chiropractic, mammography, medical, and educational facilities; and $42 for dental, industrial, veterinary, and podiatry facilities."
      },
      {
        "type": "p",
        "text": "The current state fee sheet says payment is not available online and the fee is not prorated."
      },
      {
        "type": "h2",
        "text": "Step 6: Send the new-facility package"
      },
      {
        "type": "p",
        "text": "Mail the signed BRC-4, all BRC-4X forms, required attachments, and payment to Arizona Department of Health Services, Bureau of Radiation Control, Attention: X-Ray Compliance, 4814 South 40th Street, Phoenix, AZ 85040."
      },
      {
        "type": "h2",
        "text": "Step 7: Keep the registration current"
      },
      {
        "type": "p",
        "text": "Send machine additions or removals on BRC-4X to XRAY@AZDHS.GOV. Amendments and renewals also use XRAY@AZDHS.GOV. Keep the registration, room plan, shielding calculations, unit evaluations, and installer records together."
      },
      {
        "type": "h2",
        "text": "Do not make this mistake"
      },
      {
        "type": "p",
        "text": "Do not send BRC-4 without a BRC-4X for every unit. Missing machine details, attachments, or payment delay the registration."
      },
      {
        "type": "h2",
        "text": "How Heartland Physics can help"
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the Arizona project and confirm whether its current qualifications and authorization cover the shielding work. Complete any required room-design and shielding work before construction."
      },
      {
        "type": "h2",
        "text": "State program contact"
      },
      {
        "type": "p",
        "text": "Arizona Bureau of Radiation Control, X-Ray Compliance: XRAY@AZDHS.GOV. Main address: 4814 South 40th Street, Phoenix, AZ 85040."
      },
      {
        "type": "h2",
        "text": "Source note"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "The state or local authority controls if a requirement changes before the next review."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-arkansas-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Arkansas: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Arkansas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Arkansas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Arkansas requires a radiation-machine facility to register X-ray equipment. The current facility form directs registrants to file within 30 days after acquiring a radiation machine."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Arkansas RC Form 200",
            "href": "https://healthy.arkansas.gov/wp-content/uploads/RC_FORM_200_Radiation_Machine_Facility_Registration.pdf"
          },
          {
            "label": "Open the Arkansas X-Ray Program",
            "href": "https://healthy.arkansas.gov/programs-services/licensing-military-member-licensure-permits-plan-reviews/x-ray-program/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Review the room layout and shielding needs before construction or installation. Keep the final shielding calculations and any state or facility review documentation with the registration file."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Arkansas RC Form 200, Radiation Machine Facility Registration, with the facility and machine information requested for each radiation-producing unit."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the completed form and required fee to the Arkansas Department of Health, Radiation Control Section, X-Ray Program, using the instructions on the current form."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration information current as machines are added, removed, transferred, or relocated, and retain installation and inspection documentation for each unit."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Arkansas assesses radiation-machine registration fees annually. Follow the program's renewal notice and update the facility inventory when equipment changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current Arkansas materials list an annual fee of $65 per X-ray tube, capped at $260 for the facility. Confirm the amount on the current form before filing."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Arkansas Department of Health Radiation Control, X-Ray Program. Use the contact information on RC Form 200 or the state X-ray program page."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Arkansas Source",
            "href": "https://healthy.arkansas.gov/wp-content/uploads/RC_FORM_200_Radiation_Machine_Facility_Registration.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-california-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in California: A Simple Step-by-Step Guide",
    "excerpt": "California uses one online portal for new facilities, machine additions and removals, ownership changes, corrections, and withdrawals. This page gives the state process and the two major county…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "California uses one online portal for new facilities, machine additions and removals, ownership changes, corrections, and withdrawals. This page gives the state process and the two major county shielding-plan paths."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Register every radiation machine through the California portal within 30 days after acquisition. California assigns one FAC number to each physical facility address."
      },
      {
        "type": "p",
        "text": "Ordinary diagnostic machines may generally be used after installation when all state and local requirements are complete; mammography and therapy equipment above 500 kVp require additional approval."
      },
      {
        "type": "h2",
        "text": "Start here: direct online filing and forms"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Register or Update an X-Ray Facility Online",
            "href": "https://cdph-rhb.powerappsportals.us/"
          },
          {
            "label": "Open the California New Facility Guide",
            "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/CDPH%20Document%20Library/RHB/X-ray/RegGuides/NewFACRegGuide.pdf"
          },
          {
            "label": "Verify an Existing Facility Registration",
            "href": "https://regsearchtool.cdph.ca.gov/"
          },
          {
            "label": "Open Registration FAQs and Process Guides",
            "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/Pages/RHB-X-ray/RegistrationFAQ.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather"
      },
      {
        "type": "list",
        "items": [
          "Legal entity and DBA names",
          "Physical and mailing addresses",
          "Business phone and facility contact",
          "Machine manufacturer, model, tube count, acquisition date, and room location",
          "Previous owner and FAC information for an ownership change",
          "Room plan, workload, adjacent-area use, and construction details for shielding"
        ]
      },
      {
        "type": "h2",
        "text": "Step 1: Complete the shielding design before construction"
      },
      {
        "type": "p",
        "text": "Complete the technical shielding design before walls, doors, viewing windows, or operator barriers are built. The design should use the actual machine type, maximum kVp, planned workload, room drawing, surrounding occupancy, and construction details. Use a provider whose current qualifications cover the work and any applicable local review."
      },
      {
        "type": "h2",
        "text": "Step 2: Open the state portal and select the correct action"
      },
      {
        "type": "p",
        "text": "Choose New Facility when the physical address has no California FAC number. Choose Update Registration to add or remove machines or change facility information. Choose Ownership Change when the operating entity or taxpayer ID changes."
      },
      {
        "type": "p",
        "text": "Choose Withdraw only when the facility no longer possesses any functional radiation machine."
      },
      {
        "type": "h2",
        "text": "Step 3: Enter every machine"
      },
      {
        "type": "p",
        "text": "For each unit, enter the manufacturer, model, tube count, acquisition date, and exact room or department. Submit the form and save the confirmation email and tracking ID."
      },
      {
        "type": "h2",
        "text": "Step 4: Receive and save the FAC number"
      },
      {
        "type": "p",
        "text": "After processing, California emails the FAC number for a new facility. Use that number on future communications. The registration appears in the state verification search after processing."
      },
      {
        "type": "h2",
        "text": "Step 5: Pay the state registration fee"
      },
      {
        "type": "p",
        "text": "If payment is not collected in the portal, California mails the initial fee notice after processing. Renewal fees are shown on the facility’s invoice. State registration runs for two years from the end of the month issued."
      },
      {
        "type": "h2",
        "text": "Step 6: Complete the local shielding-plan step"
      },
      {
        "type": "p",
        "text": "Los Angeles County requires its Radiation Shielding Plan Check Service Request for X-ray and PET/CT rooms. The package includes the request, room plan, and required physics report. Email DPHRadiation@ph.lacounty.gov to receive the secure upload link."
      },
      {
        "type": "p",
        "text": "Current listed fees are $622 per machine at 70 kVp or below, $977 per machine from 71–300 kVp, and $1,776 per machine above 300 kVp. Do not pay until the county issues an invoice."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Los Angeles County Shielding Request",
            "href": "https://admin.publichealth.lacounty.gov/eh/docs/permit/radiation-shielding-plan-check-service-request.pdf"
          },
          {
            "label": "Open Los Angeles County Electronic Submission Steps",
            "href": "https://admin.publichealth.lacounty.gov/eh/i-want-to/submit-electronic-plan.htm"
          }
        ]
      },
      {
        "type": "p",
        "text": "San Diego County requires its shielding-plan application, the physicist report, and room plans. Submit them to the Radiological Health Program, 5500 Overland Avenue, Suite 110, San Diego, CA 92123."
      },
      {
        "type": "p",
        "text": "The current base plan-check fee is $117 for up to two rooms for fiscal year 2026–27; complex reviews may be billed at $197 per hour."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open San Diego County Shielding Instructions",
            "href": "https://www.sandiegocounty.gov/content/dam/sdc/deh/hmd/pdf/HM9900%20rev%2007-16%20%28003%29.pdf"
          },
          {
            "label": "Open San Diego County Current Fee Page",
            "href": "https://www.sandiegocounty.gov/content/sdc/deh/doing_business/Fees_Radiation_Shielding_Plan_Check.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Outside Los Angeles and San Diego counties, confirm with the applicable county or city authority whether local shielding-plan, building, or health review applies before construction."
      },
      {
        "type": "h2",
        "text": "Step 7: Keep registration current"
      },
      {
        "type": "p",
        "text": "Use the same portal within 30 days to report a new machine, removed machine, location change, address change, name change, or ownership change."
      },
      {
        "type": "p",
        "text": "A machine kept in storage remains registered unless it is physically incapable of producing radiation or is no longer in the facility’s possession."
      },
      {
        "type": "h2",
        "text": "Special equipment"
      },
      {
        "type": "list",
        "items": [
          "Mammography: obtain the required mammography machine certificate before patient use.",
          "Therapy above 500 kVp: obtain Department authorization before treatment use.",
          "All facilities: maintain a radiation-protection program and the required employee notice posting."
        ]
      },
      {
        "type": "h2",
        "text": "Do not make this mistake"
      },
      {
        "type": "p",
        "text": "Do not assume the state portal completes a county shielding-plan review. State registration and local construction or shielding approval are separate tasks."
      },
      {
        "type": "h2",
        "text": "How Heartland Physics can help"
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project and confirm whether its current qualifications cover the shielding work. The state registration process and any county or city shielding-plan review remain separate requirements controlled by the applicable regulator."
      },
      {
        "type": "h2",
        "text": "State program contact"
      },
      {
        "type": "p",
        "text": "California Registration Support Unit: XrayRegistration@cdph.ca.gov. Los Angeles Radiation Management: DPHRadiation@ph.lacounty.gov. For San Diego, use the official Radiological Health Program contact page."
      },
      {
        "type": "h2",
        "text": "Source note"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "The state or local authority controls if a requirement changes before the next review."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-canada-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Canada: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Canada can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Canada can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Canada does not have one national facility-registration portal for ordinary medical X-ray installations."
      },
      {
        "type": "p",
        "text": "Health Canada regulates radiation-emitting devices at the federal product level, while provinces and territories establish and administer requirements for safe installation and use, facility approval or registration, operators, inspections, and radiation protection."
      },
      {
        "type": "p",
        "text": "Start by identifying the province or territory where the equipment will be installed."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Health Canada: Governments' Role in X-Ray Safety",
            "href": "https://www.canada.ca/en/health-canada/services/health-risks-safety/radiation/types-sources/x-rays/governments-role.html"
          },
          {
            "label": "Open Health Canada Safety Code 35",
            "href": "https://www.canada.ca/en/health-canada/services/environmental-workplace-health/reports-publications/radiation/safety-code-35-safety-procedures-installation-use-control-equipment-large-medical-radiological-facilities-safety-code.html"
          },
          {
            "label": "Open the Federal-Provincial-Territorial Radiation Protection Committee",
            "href": "https://www.canada.ca/en/health-canada/services/health-risks-safety/radiation/understanding/federal-provincial-territorial-radiation-protection-committee.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Safety Code 35 directs facilities to have installation plans reviewed by the appropriate responsible government agency. Contact the applicable provincial or territorial radiation authority before construction to determine the required shielding-design, plan-review, and post-installation survey process."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Identify the province or territory and obtain that jurisdiction's current X-ray facility registration, installation approval, or equipment-registration application. Federal facilities should follow the applicable Health Canada process."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the plans, facility and equipment information, professional reports, and fees required by the responsible provincial, territorial, or federal authority. Do not use another province's process as a substitute."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Complete the inspection, radiation survey, acceptance testing, and operating approvals required by the jurisdiction and keep the approval, shielding records, and equipment documentation at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Registration, licensing, inspection, and renewal cycles are province/territory-specific. Confirm the cycle with the responsible radiation-protection authority for the installation location."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "There is no single Canada-wide X-ray facility registration fee. Fees, if any, are set by the responsible province, territory, or federal program."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Use Health Canada's federal/provincial/territorial radiation-protection resources to identify the responsible authority for the installation location."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Canada Source",
            "href": "https://www.canada.ca/en/health-canada/services/health-risks-safety/radiation/types-sources/x-rays/governments-role.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-colorado-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Colorado: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Colorado can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Colorado can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Colorado requires non-federal X-ray facilities to register initially and renew annually. New or modified rooms should be evaluated for shielding before installation, and Colorado uses registered service providers and qualified experts for regulated X-ray work."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Colorado X-Ray Machine Facilities",
            "href": "https://cdphe.colorado.gov/index.php/hm/xray-machine-facilities"
          },
          {
            "label": "Open the Colorado X-Ray Program",
            "href": "https://cdphe.colorado.gov/hm/xray"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Before installing the machine, contact a Colorado-approved Qualified Expert to determine the shielding evaluation or design requirements for the room."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Colorado's current R-4 X-ray facility registration process with the facility and equipment information requested by the Department."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the registration through the current Colorado process. The Department issues the applicable invoice or annual fee after the registration information is processed."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Use a registered service company for installation when required and complete the initial certification or inspection requirements applicable to the machine. Report registration changes within 30 days."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Renew the facility registration annually. Colorado also lists a $50 reinstatement charge when an X-ray facility registration has expired."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Annual fees depend on the registered equipment and facility. Use the current Colorado invoice and fee information for the exact amount; an expired registration may also incur a $50 reinstatement charge."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Colorado X-Ray Certification Unit: cdphe.hmxraycomments@state.co.us."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Colorado Source",
            "href": "https://cdphe.colorado.gov/index.php/hm/xray-machine-facilities"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-connecticut-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Connecticut: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Connecticut can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees,…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Connecticut can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Connecticut requires all diagnostic and therapeutic X-ray devices to be registered before use. Device registrations renew every two years, and the current state fee is $190 per X-ray device."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Connecticut X-Ray Device Registration",
            "href": "https://portal.ct.gov/deep/radiation/diagnostic-and-therapeutic-x-ray-devices"
          },
          {
            "label": "Open Connecticut DEEP Radiation",
            "href": "https://portal.ct.gov/deep/radiation/radiation"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Connecticut requires diagnostic and therapeutic X-ray devices to meet its radiation-protection requirements and requires facilities to maintain the applicable registration, equipment, maintenance, calibration, exposure, and other records for inspection. The current DEEP diagnostic X-ray registration materials do not state that routine diagnostic shielding design must be prepared by a Connecticut-licensed health physicist."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use Connecticut DEEP's ezFile process to register the facility's diagnostic or therapeutic X-ray devices and provide the required device and facility information."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "File through DEEP ezFile and pay the applicable device-registration fee. Register new devices and material location or inventory changes as required by DEEP."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the shielding design, registration confirmation, equipment inventory, and applicable testing or installation records available for inspection."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Connecticut X-ray device registrations renew biennially, generally in April of even-numbered years."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current DEEP fee is $190 per X-ray device for the registration cycle."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Connecticut DEEP Diagnostic and Therapeutic X-Ray Program: DEEP.DTXReg@ct.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Connecticut Source",
            "href": "https://portal.ct.gov/deep/radiation/diagnostic-and-therapeutic-x-ray-devices"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-delaware-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Delaware: A Simple Step-by-Step Guide",
    "excerpt": "Delaware uses a construction approval and operating approval process for many new and changed X-ray rooms. This page puts the forms and steps in one place.",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Delaware uses a construction approval and operating approval process for many new and changed X-ray rooms. This page puts the forms and steps in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "A new facility files ORC-R1. Most new or modified installations above 70 kVp also file OE R-15A with shielding plans before construction."
      },
      {
        "type": "p",
        "text": "Delaware issues approval to construct, then approval to operate and a registration permit after the final package and any required inspection."
      },
      {
        "type": "h2",
        "text": "Start here: forms"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the New Facility Application (ORC-R1)",
            "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/radfacapplic.pdf"
          },
          {
            "label": "Download the Shielding Plan Review Application (OE R-15A)",
            "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/orcplanreview.pdf"
          },
          {
            "label": "Download the Machine Verification Form (R1-C)",
            "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/radmv.pdf"
          },
          {
            "label": "Open Delaware’s Radiation Machine Forms Page",
            "href": "https://dhss.delaware.gov/dph/homepage/about/sections/hsp/licenses-and-permits/radiation-control/radiation-machine-facilities/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather"
      },
      {
        "type": "list",
        "items": [
          "Facility and owner information, including EIN or SSN",
          "Healing-arts supervisor and Delaware professional license number",
          "Radiation Safety Officer",
          "Delaware-registered radiation service provider and registration number",
          "Machine procedures, manufacturer, serial number, installation date, maximum kVp and mA, room, and status",
          "Scaled room plan, nearby occupancy, equipment location, barrier construction, workload, and shielding calculations"
        ]
      },
      {
        "type": "h2",
        "text": "Step 1: Complete ORC-R1"
      },
      {
        "type": "p",
        "text": "Enter the owner, facility, healing-arts supervisor, Radiation Safety Officer, service provider, procedures, modalities, and every machine. Sign the application. Do not send payment with it."
      },
      {
        "type": "h2",
        "text": "Step 2: Apply the 70 kVp rule"
      },
      {
        "type": "p",
        "text": "A new or modified installation above 70 kVp needs an OE R-15A plan-review package before construction."
      },
      {
        "type": "p",
        "text": "Equipment at or below 70 kVp does not require a shielding plan; provide the room drawing and the machine and remote-switch locations when requested for facility review."
      },
      {
        "type": "h2",
        "text": "Step 3: Prepare the plan-review package"
      },
      {
        "type": "p",
        "text": "The package includes OE R-15A, a scale plan, machine and accessory locations, doors and windows, operator barrier, exposure switch, adjacent occupancy above and below, building materials, proposed shielding, and the service provider’s calculations."
      },
      {
        "type": "p",
        "text": "CT submissions include the manufacturer’s iso-exposure curve and qualified medical physicist calculations."
      },
      {
        "type": "h2",
        "text": "Step 4: Send the construction-review package"
      },
      {
        "type": "p",
        "text": "Mail it to Delaware Office of Engineering, 43 South DuPont Highway, Dover, DE 19901. Use the official Office of Engineering contact page for plan-review questions. A complete application is normally processed in about two weeks."
      },
      {
        "type": "h2",
        "text": "Step 5: Wait for approval to construct"
      },
      {
        "type": "p",
        "text": "Build only after the Office of Engineering issues the Certificate of Approval to Construct. The room must match the approved plan. A major change requires a revised review."
      },
      {
        "type": "h2",
        "text": "Step 6: Send the facility registration"
      },
      {
        "type": "p",
        "text": "Mail completed ORC-R1 to Delaware Office of Radiation Control, 417 Federal Street, Dover, DE 19901. Retain a copy. The form asks applicants to allow at least three weeks for processing."
      },
      {
        "type": "h2",
        "text": "Step 7: Complete operating approval"
      },
      {
        "type": "p",
        "text": "Provide final machine information, installer records, and any documents requested by the Office of Radiation Control. Delaware may perform a pre-operational inspection. After approval, post the registration permit at the facility."
      },
      {
        "type": "h2",
        "text": "Step 8: Pay the invoice"
      },
      {
        "type": "p",
        "text": "Delaware bills the annual registration fee separately, normally in the fall. Do not include payment with ORC-R1; pay the state invoice when it arrives."
      },
      {
        "type": "h2",
        "text": "Do not make this mistake"
      },
      {
        "type": "p",
        "text": "Do not begin construction and then request approval. The engineering review is intended to approve the shielding design before the room is built."
      },
      {
        "type": "h2",
        "text": "How Heartland Physics can help"
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the Delaware project and confirm whether its current qualifications and authorization cover the shielding work. Delaware requires applicable shielding-plan work to follow its current service-provider and plan-review requirements."
      },
      {
        "type": "h2",
        "text": "State program contact"
      },
      {
        "type": "p",
        "text": "Delaware Office of Radiation Control: use the official program contact page. Office of Engineering plan review: use the official Office of Engineering contact page. Facility applications: 417 Federal Street, Dover, DE 19901. Plan-review packages: 43 South DuPont Highway, Dover, DE 19901."
      },
      {
        "type": "h2",
        "text": "Source note"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "The state or local authority controls if a requirement changes before the next review."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-district-of-columbia-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in District of Columbia: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in District of Columbia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": null,
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in District of Columbia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "DC Health registers radiation-producing machines through the Division of Radiation Control and Medical Devices. The division's online portal accepts Radiation Producing Machines applications, supporting documents, and payment. DC Health stopped accepting paper applications for this division effective April 10, 2023."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open DC Radiation Control & Medical Devices",
            "href": "https://dchealth.dc.gov/service/radiation-control-medical-devices-division"
          },
          {
            "label": "Open DC Radiation Protection Forms",
            "href": "https://dchealth.dc.gov/service/radiation-protection-services-and-forms"
          },
          {
            "label": "Open DC Radiation-Producing Machine Registration Forms",
            "href": "https://dchealth.dc.gov/service/radiation-producing-machines-registration-forms"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Address shielding and radiation-protection requirements before operation and retain the final plans, barrier information, and any required radiation surveys with the facility record. The District also separately regulates health-physics service providers."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Create an account in the DC Radiation Control online application portal, choose Radiation Producing Machines, and complete the facility, responsible-operator, radiation-safety, and equipment information requested by the system."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Upload the requested supporting documents and submit payment through the online portal. DC Health's current division page states that paper applications are no longer accepted for these applications."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the issued registration certification and technical records at the facility. Report changes that make the registration information inaccurate within the period required by DC Health."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the expiration and renewal instructions shown in the DC online portal and on the issued registration. Update registered machine and facility information when it changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current online portal determines the applicable filing/payment amount for the registration type. Confirm the fee in the portal rather than relying on an older paper-form fee schedule."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "DC Health Radiation Protection: 877-672-2174."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official District of Columbia Source",
            "href": "https://dchealth.dc.gov/service/radiation-control-medical-devices-division"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-florida-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Florida: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Florida can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Florida can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Florida requires radiation-producing machines to be registered with the Department of Health. New registrants and newly acquired machines generally have a 30-day filing/payment window, and machine registration fees are assessed annually."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Florida Radiation Machine Registration",
            "href": "https://www.floridahealth.gov/licensing-regulations/radiation-control/ionizing-radiation-machines-x-ray/"
          },
          {
            "label": "Open the Florida X-Ray Fee Schedule",
            "href": "https://www.floridahealth.gov/environmental-health/radiation-control/ion/_documents/Radiation-Machine-Registration-Fee-Schedule.pdf"
          },
          {
            "label": "Open Florida X-Ray Online Payment",
            "href": "https://xray.floridahealth.gov/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Evaluate shielding and room construction before installing the machine. Keep the final shielding design and any required survey or equipment-performance documentation with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Florida Form DH 1107 for radiation-machine registration with the facility, owner, machine, and tube information requested by the Radiation Machine Section."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit DH 1107 using the current Department instructions. After the registration is processed, use the state's X-ray payment system or other instructed payment method for the applicable fee."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Maintain the facility inventory and report additions, removals, relocations, ownership changes, and other registration changes as required by the Department."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Florida radiation-machine registration fees are annual and are due on or before October 28 for the registration year."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Current annual fees vary by facility type. Examples include $145 for the first tube and $85 for each additional tube for many medical diagnostic facilities, with lower schedules for dental, veterinary, and certain industrial categories."
      },
      {
        "type": "p",
        "text": "Use the current official fee schedule for your exact category."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Florida Department of Health Radiation Machine Section: RadiationControl@FLHealth.gov; 850-245-4888."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Florida Source",
            "href": "https://www.floridahealth.gov/licensing-regulations/radiation-control/ionizing-radiation-machines-x-ray/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-georgia-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Georgia: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Georgia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Georgia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Georgia requires an X-ray facility to be registered before operation. The Department's current process is online, and the registration package may require facility identity documents and shielding information for permanently installed X-ray rooms."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Georgia X-Ray Registration Information",
            "href": "https://dch.georgia.gov/divisionsoffices/hfrd/facilities-provider-information/x-ray"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Prepare the shielding design before construction or installation for rooms with permanently installed X-ray equipment when Georgia requires it. Bone densitometry and some nonmedical systems have different plan requirements."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the Georgia Department of Community Health X-ray registration process and provide the facility information, affidavit/photo identification, machine details, and shielding documents that apply to the installation."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the facility application through Georgia's current online registration process and complete any additional documentation requested by the Diagnostic Services program."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not operate the equipment until the facility registration requirements have been satisfied. Retain the shielding plan, registration information, installation records, and applicable equipment evaluations."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the registration term and renewal instructions shown in the Georgia portal and state notices for the facility's equipment category."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Use the current Georgia online application and applicable state fee schedule for the exact registration amount; fees can vary by equipment and facility type."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Georgia Diagnostic Services/X-Ray Registration: diagnosticprogram.hfrd@dch.ga.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Georgia Source",
            "href": "https://dch.georgia.gov/divisionsoffices/hfrd/facilities-provider-information/x-ray"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-guam-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Guam: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Guam can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Guam can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Guam has a Department of Public Health and Social Services regulatory framework, but the current public DPHSS site does not expose a clearly identified general X-ray machine registration form for all facility types."
      },
      {
        "type": "p",
        "text": "Contact DPHSS before acquiring or installing a machine to obtain the current radiation-machine application, fee, inspection, and shielding requirements."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Guam DPHSS",
            "href": "https://dphss.guam.gov/"
          },
          {
            "label": "Open Guam DPHSS Forms",
            "href": "https://dphss.guam.gov/forms"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Confirm with DPHSS whether the installation requires a shielding design, plan review, radiation survey, or other pre-operation radiation-protection documentation before construction or installation."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Ask DPHSS Division of Environmental Health or the office handling radiological health for the current radiation-producing-equipment registration or facility application applicable to the installation."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the facility and equipment information through the filing method DPHSS provides. Include the shielding, inspection, and responsible-person documentation requested for the equipment type."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the written DPHSS instructions, registration or approval, equipment inventory, shielding records, and inspection reports with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "A current general renewal cycle was not clearly published for all X-ray facilities on the public forms site reviewed. Verify the renewal and reinspection schedule directly with DPHSS."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "No single current public X-ray machine fee schedule was identified for all facility types. Confirm the amount with DPHSS before filing."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Guam Department of Public Health and Social Services. Start with the current DPHSS contact and forms pages and request the office responsible for radiological health/radiation-producing equipment."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Guam Source",
            "href": "https://dphss.guam.gov/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-hawaii-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Hawaii: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Hawaii can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Hawaii can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Hawaii requires a radiation facility license before acquiring, installing, possessing, or using electronic ionizing-radiation equipment. The state advises submitting the application and fee well before the planned installation because processing can take 30 days or more."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Hawaii Radiation Forms",
            "href": "https://health.hawaii.gov/irhb/radforms/"
          },
          {
            "label": "Download Hawaii Radiation Facility License Application",
            "href": "https://health.hawaii.gov/irhb/files/2013/07/radlicenseapp.pdf"
          },
          {
            "label": "Open Hawaii Radiation License Information",
            "href": "https://health.hawaii.gov/irhb/files/2013/07/radlicenseinfo.pdf"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Hawaii requires a qualified, licensed medical physicist for regulated shielding evaluation work. Complete the shielding evaluation and any required plan submission before construction or installation."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete the Hawaii Radiation Facility License application for the facility and radiation-producing equipment, including the ownership, location, equipment, and responsible-person information requested by the Indoor and Radiological Health Branch."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the application and required fee to Hawaii IRHB before the intended possession or installation date. The program's information sheet recommends allowing about 60 days for licensing actions."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Wait for the required facility authorization before installing, possessing, or operating the X-ray equipment, and keep the license and shielding documentation with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the expiration and renewal instructions on the Hawaii facility license. Update the agency when equipment, ownership, location, or other licensed information changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Hawaii radiation fees depend on the license and equipment category. Confirm the current facility-license amount on the IRHB forms page or with the program before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Hawaii Indoor and Radiological Health Branch, Radiation Section. Use the current contact information on the IRHB forms page."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Hawaii Source",
            "href": "https://health.hawaii.gov/irhb/radforms/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-idaho-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Idaho: A Simple Step-by-Step Guide",
    "excerpt": "Every X-ray machine in Idaho must be licensed. This page gives the full path for a new facility and direct access to the online forms.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Every X-ray machine in Idaho must be licensed. This page gives the full path for a new facility and direct access to the online forms."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Complete Idaho’s online X-Ray Licensure Application. New hospital, medical, and chiropractic facilities must submit the shielding plan before licensing. Idaho also requires a qualified-expert shielding review, and the facility sends a copy to the program within 30 days after receiving it."
      },
      {
        "type": "h2",
        "text": "Start here: online applications"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start the Online X-Ray License Application",
            "href": "https://app.keysurvey.com/f/41799329/6cd0/"
          },
          {
            "label": "Open the X-Ray Change of Information Form",
            "href": "https://app.keysurvey.com/f/41850267/84eb/"
          },
          {
            "label": "Open the Notice of Installation",
            "href": "https://app.keysurvey.com/f/41545218/7b8d/"
          },
          {
            "label": "Open Idaho’s X-Ray Licensing Page",
            "href": "https://healthandwelfare.idaho.gov/providers/idaho-laboratories-and-testing/x-ray-licensure"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather"
      },
      {
        "type": "list",
        "items": [
          "Legal facility name, mailing address, and physical address",
          "Owner, facility contact, and Radiation Safety Officer",
          "Machine type, manufacturer, model, serial number, tube count, and maximum kVp",
          "Room floor plan, machine position, and building materials",
          "Workload and use of spaces beside, above, and below the room",
          "Installer or registered service provider information"
        ]
      },
      {
        "type": "h2",
        "text": "Step 1: Order the shielding review"
      },
      {
        "type": "p",
        "text": "Prepare the qualified-expert floor plan and site-specific shielding calculations before the room is built when Idaho requires them. Use a qualified expert whose current Idaho status covers the work, and follow the state submission requirements for the facility type."
      },
      {
        "type": "h2",
        "text": "Step 2: Send the shielding review"
      },
      {
        "type": "p",
        "text": "Send a copy of the shielding review, floor plan, and calculations to Idaho within 30 days after the facility receives it. Email the program at LabImprovement@dhw.idaho.gov and retain the report with permanent radiation-safety records."
      },
      {
        "type": "h2",
        "text": "Step 3: Complete the online license application"
      },
      {
        "type": "p",
        "text": "Enter the facility, owner, contact, and Radiation Safety Officer information. Add every machine and X-ray tube. Submit the application and save the confirmation."
      },
      {
        "type": "h2",
        "text": "Step 4: Complete the installation notice"
      },
      {
        "type": "p",
        "text": "The installer or registered service provider submits the online Notice of Installation. The facility should retain the submission confirmation with the machine records."
      },
      {
        "type": "h2",
        "text": "Step 5: Pay the invoice"
      },
      {
        "type": "p",
        "text": "Do not send payment with the application. Idaho’s listed standard fee is a $50 facility fee plus $25 for each X-ray tube. The program sends an invoice after processing."
      },
      {
        "type": "h2",
        "text": "Step 6: Follow the license cycle"
      },
      {
        "type": "p",
        "text": "Hospitals, clinics, and medical facilities generally renew every two years. Dental, chiropractic, podiatry, and veterinary facilities generally renew every four years. Industrial, research, academic, and security facilities generally use a 10-year cycle."
      },
      {
        "type": "h2",
        "text": "Step 7: Report later changes"
      },
      {
        "type": "p",
        "text": "Use the online Change of Information form when facility or machine information changes. Keep the license, machine inventory, shielding report, installation notice, invoice, inspection records, and service records together."
      },
      {
        "type": "h2",
        "text": "Do not make this mistake"
      },
      {
        "type": "p",
        "text": "Do not wait until the room is built to order the shielding review. Idaho requires site-specific qualified-expert calculations, and some new facilities need them before licensing."
      },
      {
        "type": "h2",
        "text": "How Heartland Physics can help"
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the Idaho project and confirm whether its current qualifications and authorization cover the shielding work. Use the current Idaho qualified-expert and facility-licensing requirements before construction or installation."
      },
      {
        "type": "h2",
        "text": "State program contact"
      },
      {
        "type": "p",
        "text": "Idaho Radiation Control Program: LabImprovement@dhw.idaho.gov."
      },
      {
        "type": "h2",
        "text": "Source note"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "The state or local authority controls if a requirement changes before the next review."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-illinois-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Illinois: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Illinois can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Illinois can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "A new Illinois X-ray facility uses the paper facility-registration form. Send the signed form to IEMA-OHS before the machine is used. Registration and machine fees are billed every year."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Illinois Facility Registration Form",
            "href": "https://iemaohs.illinois.gov/content/dam/soi/en/web/iemaohs/nrs/radsafety/documents/fac-reg.pdf"
          },
          {
            "label": "Open Illinois Registration Instructions",
            "href": "https://iemaohs.illinois.gov/nrs/radsafety/xray-change.html"
          },
          {
            "label": "Open the Illinois X-Ray Program",
            "href": "https://iemaohs.illinois.gov/nrs/radsafety/xray.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical address, mailing address, and federal tax ID"
      },
      {
        "type": "p",
        "text": "• Owner and radiation-safety contact information"
      },
      {
        "type": "p",
        "text": "• Each machine's manufacturer, model, serial number, tube count, type, and installation date"
      },
      {
        "type": "p",
        "text": "• A room plan and shielding calculations when the installation or room requires shielding review"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room before construction"
      },
      {
        "type": "p",
        "text": "Have the room layout and machine workload reviewed before walls are closed. Use a provider whose current qualifications and authorization cover any shielding design or technical report required for the project."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the facility-registration form"
      },
      {
        "type": "p",
        "text": "Use the official Facility Registration form. Complete the facility, owner, contact, practice type, and equipment sections. List every radiation-producing machine at that location."
      },
      {
        "type": "h3",
        "text": "Step 3: Sign and mail the form"
      },
      {
        "type": "p",
        "text": "Mail the signed form to IEMA-OHS, 4800 Wabash Avenue, 3F-West, Springfield, IL 62711-7073. Keep a copy of the full package."
      },
      {
        "type": "h3",
        "text": "Step 4: Watch for the state invoice"
      },
      {
        "type": "p",
        "text": "Illinois reviews the form and bills the facility for the applicable annual registration and machine fees. Pay the invoice by its due date."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the registration current"
      },
      {
        "type": "p",
        "text": "Use the state's change process when equipment, ownership, address, or contacts change. Renew and pay the annual fee when billed."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Illinois charges annual registration and machine fees. The amount depends on the facility and equipment listed. The state sends the bill after it processes the registration."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Illinois Emergency Management Agency and Office of Homeland Security, Radiation Protection: ema.RadFacilities@illinois.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Illinois Source",
            "href": "https://iemaohs.illinois.gov/nrs/radsafety/xray-change.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-indiana-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Indiana: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Indiana can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Indiana can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Indiana requires the facility to register its X-ray machines before operation. Complete Parts A, B, and C of the registration form and send it to the Indiana Department of Health."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Indiana X-Ray Registration Form",
            "href": "https://forms.in.gov/Download.aspx?id=8060"
          },
          {
            "label": "Open the Indiana Radiology Program",
            "href": "https://www.in.gov/health/cshcr/radiology-weights-and-measures"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, tube count, and installation date"
      },
      {
        "type": "p",
        "text": "• Installer's FDA Form 2579 when the equipment is a diagnostic X-ray system"
      },
      {
        "type": "p",
        "text": "• Shielding design and room information for a new or changed room"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Design the room"
      },
      {
        "type": "p",
        "text": "Finish the room layout and shielding design before construction. Keep the final shielding report with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 2: Fill out Parts A, B, and C"
      },
      {
        "type": "p",
        "text": "Part A identifies the facility. Part B identifies the person responsible for radiation safety. Part C lists each machine. Use a separate line or continuation page for each unit."
      },
      {
        "type": "h3",
        "text": "Step 3: Attach machine and shielding records"
      },
      {
        "type": "p",
        "text": "Add the installer paperwork and any shielding report that applies to the project. Keep copies of equipment acceptance and performance tests."
      },
      {
        "type": "h3",
        "text": "Step 4: Mail the application"
      },
      {
        "type": "p",
        "text": "Send the signed package to Indiana Department of Health, Division of Radiology and Weights and Measures, 2 North Meridian Street, 4 Selig, Indianapolis, IN 46204."
      },
      {
        "type": "h3",
        "text": "Step 5: Complete the approved pre-use inspection before patient imaging"
      },
      {
        "type": "p",
        "text": "Before diagnostic use, the X-ray installation must be inspected by an individual approved by the Indiana Department of Health Medical Radiology Services Program. Keep the inspection/compliance report with the registration, machine records, operating procedures, and required notices, and report later equipment or ownership changes to the state."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Use the current fee instructions on the state form. The amount depends on the number and type of machines."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Indiana Department of Health, Division of Radiology and Weights and Measures: use the official program contact page."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Indiana Source",
            "href": "https://www.in.gov/health/cshcr/radiology-weights-and-measures"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-iowa-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Iowa: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Iowa can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Iowa can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Iowa registers radiation-producing machines through its Regulatory Licensing Portal. A new medical facility or new medical X-ray installation also needs a shielding review. A stationary machine may not be used until the required shielding review and registration steps are complete."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Iowa Regulatory Licensing Portal",
            "href": "https://amanda-portal.idph.state.ia.us/"
          },
          {
            "label": "Download the Iowa Installation Checklist",
            "href": "https://hhs.iowa.gov/media/7552/download?inline="
          },
          {
            "label": "Open Iowa X-Ray Machine Instructions",
            "href": "https://hhs.iowa.gov/health-prevention/providers-professionals/radiological-health/x-ray-machines"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, address, owner, and contacts"
      },
      {
        "type": "p",
        "text": "• Machine type, manufacturer, model, serial number, and installation date"
      },
      {
        "type": "p",
        "text": "• Room drawing, surrounding-area use, workload, distance, and machine technical data for shielding"
      },
      {
        "type": "p",
        "text": "• Installer's FDA Form 2579"
      },
      {
        "type": "p",
        "text": "• Equipment Performance Evaluation report"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Request the correct shielding-review form"
      },
      {
        "type": "p",
        "text": "Email radhealthia@hhs.iowa.gov and say: Please send the shielding review request form for a new [machine type] installation at [facility name and address]."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the shielding design"
      },
      {
        "type": "p",
        "text": "For a stationary medical machine, submit the shielding-review package before installation and use when required. Use a provider whose current qualifications cover the room drawing, calculations, and design report required by Iowa."
      },
      {
        "type": "h3",
        "text": "Step 3: Create or use the portal account"
      },
      {
        "type": "p",
        "text": "Open the Iowa Regulatory Licensing Portal. Choose the radiation-machine facility application or renewal that matches the facility. Enter the facility and machine information."
      },
      {
        "type": "h3",
        "text": "Step 4: Finish the installation records"
      },
      {
        "type": "p",
        "text": "The installer must file FDA Form 2579 within 15 days. Arrange the required Equipment Performance Evaluation within 30 days and keep the report."
      },
      {
        "type": "h3",
        "text": "Step 5: Pay the invoice and keep the annual registration current"
      },
      {
        "type": "p",
        "text": "Iowa places the invoice in the portal after review. Pay it online. Registration is annual, so complete the portal renewal each year."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Iowa charges annual facility and equipment fees. The portal shows the current amount after the machine and facility information is entered."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Iowa HHS Bureau of Radiological Health: radhealthia@hhs.iowa.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Iowa Source",
            "href": "https://hhs.iowa.gov/health-prevention/providers-professionals/radiological-health/x-ray-machines"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-jefferson-county-alabama-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Jefferson County, Alabama: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Jefferson County, Alabama can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Jefferson County, Alabama can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Jefferson County has a local radiation-health program separate from the ordinary Alabama state workflow."
      },
      {
        "type": "p",
        "text": "A person possessing an X-ray-producing machine in the county must register with the Jefferson County Department of Health, and a new registrant must complete the applicable registration before acquiring the machine."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Jefferson County Radiation Health Program",
            "href": "https://www.jcdh.org/SitePages/Programs-Services/EnvironmentalHealth/Air-RadiationProtectionDivision/RadHlthProg.aspx"
          },
          {
            "label": "Open Jefferson County Radiation Rules",
            "href": "https://www.jcdh.org/SitePages/Misc/PdfViewer?AdminUploadId=384"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Before construction, submit the required floor plans and equipment arrangement for new or modified diagnostic or therapeutic installations to JCDH for review and approval. JCDH may require a qualified expert to determine shielding requirements."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the current Jefferson County Radiation Health Program registration materials and provide the facility, responsible radiation-protection individual, machine, tube, installer/service-provider, and other information requested by the county."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the county registration and any required plan-review package before acquiring or installing the equipment when the county rules require advance approval."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Use service providers registered with JCDH when required, retain the registration notice and approved plans, and complete any inspections or radiation surveys requested by the county."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "The county registration expires on the date shown on the Notice of Registration. File renewal material before expiration; county rules provide continuation protection when a complete renewal is filed at least 30 days before expiration."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "JCDH regulations authorize registration and review fees, but a single current public fee schedule was not identified in this review. Confirm the current amount directly with the Radiation Health Program."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Jefferson County Department of Health Radiation Health Program: 205-930-1276."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Jefferson County, Alabama Source",
            "href": "https://www.jcdh.org/SitePages/Programs-Services/EnvironmentalHealth/Air-RadiationProtectionDivision/RadHlthProg.aspx"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-kansas-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Kansas: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Kansas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Kansas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Kansas requires radiation-producing equipment to be registered. The current registration packet states that the registration form and fee are due within 30 days of acquiring X-ray devices, and the initial package includes shielding-plan information."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Kansas X-Ray Registration Packet",
            "href": "https://www.kdhe.ks.gov/DocumentCenter/View/10420"
          },
          {
            "label": "Open KDHE Radiation Information",
            "href": "https://www.kdhe.ks.gov/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Prepare a shielding design before construction or installation. If a separate shielding design has not already been prepared, complete the shielding-plan review material included in the Kansas registration packet."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete the Kansas radiation-machine registration packet with facility, machine, tube, ownership, and shielding information for the installation."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Send the completed registration documents and applicable fee to KDHE using the instructions in the current packet."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the approved registration, shielding information, installer documentation, and inspection or equipment-performance records together at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow KDHE's registration renewal and invoicing cycle and report machine additions, removals, relocations, and ownership changes as required."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Kansas fees are based on the number and type of X-ray tubes and can be prorated for an initial registration depending on the quarter. Use the current packet for the exact amount."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Kansas X-Ray Compliance: kdhe.xray@ks.gov; 785-296-1560."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Kansas Source",
            "href": "https://www.kdhe.ks.gov/DocumentCenter/View/10420"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-kentucky-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Kentucky: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Kentucky can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Kentucky can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Kentucky requires radiation-producing machines to be registered and does not allow operation without a valid registration. Registration is renewed annually, and fees depend on the number and type of machines."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Kentucky Form RPS-402",
            "href": "https://www.chfs.ky.gov/agencies/dph/dphps/rhb/Documents/RPS402%20Application%20Rev%209_23.pdf"
          },
          {
            "label": "Open Kentucky Radiation Producing Machines",
            "href": "https://www.chfs.ky.gov/agencies/dph/dphps/rhb/Pages/rpmp.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Complete the shielding design and any required Kentucky plan review before construction or operation. Diagnostic shielding-design services must be performed within Kentucky's Qualified Expert requirements."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Kentucky Form RPS-402 with the facility, owner, radiation-machine, and responsible-person information requested by the Radiation Health Branch."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit RPS-402 and the applicable registration fee to the Kentucky Radiation Health Branch using the current form instructions."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not operate the X-ray equipment until the registration requirements are satisfied. Retain the machine registration, shielding documentation, installer records, and applicable surveys or inspections."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Kentucky radiation-machine registration is valid for one year and must be renewed annually."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Registration fees vary by machine type and number of units. Use the current RPS-402 instructions and fee schedule for the exact amount; the registration is not complete until the required fees are paid."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Kentucky Radiation Health Branch: RPM@ky.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Kentucky Source",
            "href": "https://www.chfs.ky.gov/agencies/dph/dphps/rhb/Documents/RPS402%20Application%20Rev%209_23.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-los-angeles-county-california-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Los Angeles County, California: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Los Angeles County, California can involve several radiation-control steps. This guide puts the ordinary registration sequence, official…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Los Angeles County, California can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "X-ray machines in Los Angeles County are registered with the California Department of Public Health Radiologic Health Branch, generally within 30 days of acquisition."
      },
      {
        "type": "p",
        "text": "Los Angeles County separately performs local radiation inspections and shielding-plan review for installations within its jurisdiction, including Long Beach, Pasadena, and Vernon."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Los Angeles County Radiation Management",
            "href": "https://www.publichealth.lacounty.gov/eh/about/radiation-management-program.htm"
          },
          {
            "label": "Download the LA County Shielding Plan Check Request",
            "href": "https://publichealth.lacounty.gov/eh/docs/permit/radiation-shielding-plan-check-service-request.pdf"
          },
          {
            "label": "Open California X-Ray Machine Registration",
            "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/Pages/RHB-X-ray/Registration.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Submit the Los Angeles County Radiation Shielding Plan Check Service Request and required technical package when a county shielding-plan review applies. The county's current request form identifies additional physicist-report requirements for CT, PET/CT, and therapy installations."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete the California RHB radiation-machine registration process for the equipment and, when plan review applies, prepare the separate Los Angeles County shielding-plan-check request and supporting floor plans/calculations."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Register the machine through the California state process and submit the county shielding-plan materials to the Los Angeles County Radiation Management Program using the current plan-check instructions."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep both state machine-registration records and county shielding-plan approval/inspection records. Complete any required local inspection or follow-up before routine clinical use."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "California radiation-machine registrations are generally renewed on the state's two-year cycle. County plan review is project-specific rather than a substitute for state registration."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Los Angeles County's July 2025 shielding-plan request listed plan-check fees of $622 per machine for equipment at or below 70 kVp, $977 per machine for 71-300 kVp equipment, and $1,776 per machine for equipment at or above 301 kVp."
      },
      {
        "type": "p",
        "text": "State registration fees are separate. Confirm the current county and state schedules before payment."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Los Angeles County Radiation Management Program: DPHradiation@ph.lacounty.gov; 213-351-7897. California RHB X-Ray Registration: XrayRegistration@cdph.ca.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Los Angeles County, California Source",
            "href": "https://www.publichealth.lacounty.gov/eh/about/radiation-management-program.htm"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-louisiana-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Louisiana: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Louisiana can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Louisiana can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Louisiana uses Form DRC-6 to register each X-ray machine. Send one completed form for each unit. Most new fixed rooms need an approved shielding plan before construction, except for the specific low-risk room types listed by the state."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Louisiana Form DRC-6",
            "href": "https://www.deq.louisiana.gov/assets/docs/Radiation/DRC-6-XRay-Machine-Reg-App_rev6-26.pdf"
          },
          {
            "label": "Open Louisiana Radiation Forms",
            "href": "https://www.deq.louisiana.gov/radiation-forms-and-applications"
          },
          {
            "label": "Open the Louisiana Radiation Program",
            "href": "https://www.deq.louisiana.gov/radiation"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and radiation-safety contact information"
      },
      {
        "type": "p",
        "text": "• One complete machine-information set for each unit"
      },
      {
        "type": "p",
        "text": "• Room floor plan and occupancy information"
      },
      {
        "type": "p",
        "text": "• Shielding calculations or the state's approval letter"
      },
      {
        "type": "p",
        "text": "• CBCT training and quality-assurance documents when applicable"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Decide whether shielding review is required"
      },
      {
        "type": "p",
        "text": "Louisiana generally requires floor plans and shielding information before construction. Dedicated mammography, podiatric radiographic, panoramic dental, and intraoral dental rooms are exempt from routine plan submission. Veterinary rooms are decided case by case."
      },
      {
        "type": "h3",
        "text": "Step 2: Prepare and submit the shielding package"
      },
      {
        "type": "p",
        "text": "Have a qualified shielding professional prepare the calculations and floor plan. Keep the state approval letter for the registration package."
      },
      {
        "type": "h3",
        "text": "Step 3: Complete one DRC-6 for each machine"
      },
      {
        "type": "p",
        "text": "Enter the facility, machine, location, ownership, and contact information. Attach the approved shielding letter or the required room information."
      },
      {
        "type": "h3",
        "text": "Step 4: Email or mail the application"
      },
      {
        "type": "p",
        "text": "Email the signed PDF to LDEQRadiationlicensing@la.gov. Or mail it to Office of Environmental Compliance, Radiation Section, P.O. Box 4312, Baton Rouge, LA 70821-4312."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the certificate and report changes"
      },
      {
        "type": "p",
        "text": "Keep each registration with the machine records. Send updates when a machine is added, moved, replaced, transferred, or removed."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Louisiana's fee depends on the machine and facility type. Follow the fee instructions sent by the Radiation Section after it reviews the submission."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Louisiana DEQ Radiation Section: LDEQRadiationlicensing@la.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Louisiana Source",
            "href": "https://www.deq.louisiana.gov/radiation-forms-and-applications"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-maine-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Maine: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Maine can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Maine can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "A new Maine X-ray facility submits the initial fee form and the radiation-machine form. Most new rooms need a shielding design accepted by the Radiation Control Program before the machine registration can be processed."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Maine Initial Fee Form HHE-804",
            "href": "https://www.maine.gov/dhhs/mecdc/environmental-health/rad/documents/forms/hhe-804%20new%20x-ray%20registration.pdf"
          },
          {
            "label": "Download Maine Machine Form HHE-805",
            "href": "https://www.maine.gov/dhhs/mecdc/environmental-health/rad/documents/forms/hhe-805-radiation-machine-registration.pdf"
          },
          {
            "label": "Open Maine X-Ray Licensing Instructions",
            "href": "https://www1.maine.gov/dhhs/mecdc/services/radiation-control-nuclear-safety/x-ray-licensing"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, and installation date"
      },
      {
        "type": "p",
        "text": "• Room plan, workload, distances, and surrounding-area use"
      },
      {
        "type": "p",
        "text": "• Qualified expert shielding report"
      },
      {
        "type": "p",
        "text": "• Installer and inspection records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Get the shielding design accepted"
      },
      {
        "type": "p",
        "text": "Email the shielding design to Radiation.DHHS@Maine.gov. Maine will issue an RSA number or acceptance letter. The machine registration will not be processed without it when shielding review is required."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete HHE-804"
      },
      {
        "type": "p",
        "text": "Use HHE-804 for the initial fee. A new unit is $60. A replacement unit is $30."
      },
      {
        "type": "h3",
        "text": "Step 3: Complete HHE-805"
      },
      {
        "type": "p",
        "text": "List the facility, responsible person, equipment, room, and installation information. Add the shielding acceptance information."
      },
      {
        "type": "h3",
        "text": "Step 4: Send the forms and payment"
      },
      {
        "type": "p",
        "text": "Mail the complete package to Maine Radiation Control Program, 286 Water Street, 3rd Floor, Augusta, ME 04333-0011. Keep a copy."
      },
      {
        "type": "h3",
        "text": "Step 5: Arrange the required qualified-expert inspection"
      },
      {
        "type": "p",
        "text": "For most clinic, private-office, chiropractic, and veterinary installations, arrange the first qualified-expert inspection on the state's required schedule. Keep every report for later inspection and renewal."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The initial fee is $60 for each new unit and $30 for each replacement unit. Later inspection and renewal obligations depend on facility type."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Maine Radiation Control Program: Radiation.DHHS@Maine.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Maine Source",
            "href": "https://www1.maine.gov/dhhs/mecdc/services/radiation-control-nuclear-safety/x-ray-licensing"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-maryland-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Maryland: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Maryland can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Maryland can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Maryland requires radiation machines to be registered before use. A new-machine package includes the registration application, installation reports, required professional credentials for applicable modalities, the registration fee, and equipment maintenance information."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Maryland New X-Ray Machine Registration Instructions",
            "href": "https://mde.maryland.gov/programs/air/RadiologicalHealth/Documents/www.mde.state.md.us/assets/document/air/Instructions_for_Registering_New_Machines_26.pdf"
          },
          {
            "label": "Open Maryland Radiological Health",
            "href": "https://mde.maryland.gov/programs/Air/RadiologicalHealth/Pages/index.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Address shielding and room design before construction or machine installation and retain the final calculations and any radiation-safety review with the machine-registration records."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Maryland's RX-1 registration information and include the applicable RX-24 installation report and other supporting material described in the state's new-machine instructions."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the complete package and payment as directed by Maryland's Radiological Health Program. The current instructions also direct facilities to email a duplicate packet and copy of the payment documentation to the state's X-ray submission address."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not place the machine into patient or routine use until Maryland grants the required registration. Keep the registration certificate, installation report, shielding records, and maintenance/testing documentation."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the registration term and renewal notice issued by Maryland and promptly report machine and facility changes that affect the registration."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current Maryland instructions list $292 per tube for many hospital, general medical, academic/industrial, veterinary, and mammography units; $80 per tube for dental and veterinary-dental units; and $1,154 per tube for irradiators/accelerators. Confirm the current category before filing."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Maryland radiation-machine submissions: mdexray.submission@maryland.gov; program contact Shannon Page: spage@maryland.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Maryland Source",
            "href": "https://mde.maryland.gov/programs/air/RadiologicalHealth/Documents/www.mde.state.md.us/assets/document/air/Instructions_for_Registering_New_Machines_26.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-massachusetts-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Massachusetts: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Massachusetts can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Massachusetts can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Massachusetts requires medical, dental, therapy, and analytical ionizing-radiation sources to be registered online through the Environmental Health eLicensing Portal."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start the Massachusetts Registration Process",
            "href": "https://www.mass.gov/how-to/register-an-ionizing-radiation-source"
          },
          {
            "label": "Open Massachusetts Radiation Control",
            "href": "https://www.mass.gov/radiation-control"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, address, tax information, and contacts"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Each source's manufacturer, model, serial number, type, and location"
      },
      {
        "type": "p",
        "text": "• Room and shielding information"
      },
      {
        "type": "p",
        "text": "• A payment method for the online fee"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room and shielding"
      },
      {
        "type": "p",
        "text": "Complete the room layout and shielding calculations before construction or installation. Keep the final report with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 2: Open the official registration page"
      },
      {
        "type": "p",
        "text": "Click Start the Massachusetts Registration Process above, then choose the Environmental Health eLicensing Portal button on the state page."
      },
      {
        "type": "h3",
        "text": "Step 3: Create an eLicensing account"
      },
      {
        "type": "p",
        "text": "Choose Create Account if the facility has never used the portal. Confirm the email address and sign in."
      },
      {
        "type": "h3",
        "text": "Step 4: Start Register an Ionizing Radiation Source"
      },
      {
        "type": "p",
        "text": "Enter the facility, contact, room, and machine information. Upload requested technical documents. Review every answer before submitting."
      },
      {
        "type": "h3",
        "text": "Step 5: Pay and save the receipt"
      },
      {
        "type": "p",
        "text": "Pay the online fee shown by the portal. Save the confirmation, registration record, shielding report, and equipment documents at the facility."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The portal calculates the current fee from the source and facility information entered in the application."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Massachusetts Division of Radiation Control eLicensing Help Desk: use the official eLicensing support page."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Massachusetts Source",
            "href": "https://www.mass.gov/how-to/register-an-ionizing-radiation-source"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-michigan-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Michigan: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Michigan can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Michigan can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Michigan requires every X-ray facility to register through the Radiation Safety Section portal before the machine is used. Many new or changed rooms also require shielding-plan approval."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Michigan Radiation Safety Portal",
            "href": "https://aca3.accela.com/MIHS/"
          },
          {
            "label": "Open Michigan New-Facility Instructions",
            "href": "https://www.michigan.gov/leo/bureaus-agencies/miosha/divisions/technical-services-division/rad-safety/planning-or-starting-up-a-new-x-ray-facility"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine type, manufacturer, model, serial number, tube count, and location"
      },
      {
        "type": "p",
        "text": "• Room floor plan, workload, distances, and occupancy information"
      },
      {
        "type": "p",
        "text": "• Installer and acceptance-test records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Check the plan-review requirement"
      },
      {
        "type": "p",
        "text": "Use Michigan's new-facility instructions to identify whether the installation needs shielding-plan approval. Complete this before construction when required."
      },
      {
        "type": "h3",
        "text": "Step 2: Prepare the shielding package"
      },
      {
        "type": "p",
        "text": "Have the required room drawing and calculations prepared by a provider whose current qualifications cover the work, and retain the technical report and state correspondence for follow-up questions."
      },
      {
        "type": "h3",
        "text": "Step 3: Create a portal account"
      },
      {
        "type": "p",
        "text": "Open the Michigan Radiation Safety Portal. Register a user account and connect it to the facility."
      },
      {
        "type": "h3",
        "text": "Step 4: Apply for the facility and machines"
      },
      {
        "type": "p",
        "text": "Choose the radiation-machine facility application. Enter every machine and room. Upload the plan-review and supporting records when requested."
      },
      {
        "type": "h3",
        "text": "Step 5: Pay, print, and post the certificate"
      },
      {
        "type": "p",
        "text": "Pay the portal fee. After approval, download and post the registration certificate. Use the portal for renewals, amendments, and later equipment changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Michigan calculates registration and plan-review charges from the facility and equipment entered in the portal."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Michigan Radiation Safety Section: rssinfo@michigan.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Michigan Source",
            "href": "https://www.michigan.gov/leo/bureaus-agencies/miosha/divisions/technical-services-division/rad-safety/planning-or-starting-up-a-new-x-ray-facility"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-minnesota-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Minnesota: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Minnesota can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Minnesota can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "A brand-new Minnesota facility or new owner mails the Initial Registration Form and payment before first use. After payment, the state sends an invitation to finish the equipment record in the online X-ray Registration System."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Minnesota Initial Registration Form",
            "href": "https://www.health.state.mn.us/communities/environment/radiation/docs/irform.pdf"
          },
          {
            "label": "Open the Minnesota X-Ray Registration System",
            "href": "https://xray.web.health.state.mn.us/"
          },
          {
            "label": "Open Minnesota Registration Instructions",
            "href": "https://www.health.state.mn.us/communities/environment/radiation/xray/forms.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, administrator, and contact information"
      },
      {
        "type": "p",
        "text": "• Federal and Minnesota tax IDs"
      },
      {
        "type": "p",
        "text": "• Equipment types and machine details"
      },
      {
        "type": "p",
        "text": "• Shielding documentation for the room"
      },
      {
        "type": "p",
        "text": "• Current Equipment Performance Evaluation records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete shielding and equipment checks"
      },
      {
        "type": "p",
        "text": "Keep the room shielding documentation. Have a Minnesota-registered service provider complete required calibration and performance work before first use."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the Initial Registration Form"
      },
      {
        "type": "p",
        "text": "Use this form only for a new facility, a new owner, or an unregistered satellite location. List the facility and all initial equipment."
      },
      {
        "type": "h3",
        "text": "Step 3: Mail the form and payment"
      },
      {
        "type": "p",
        "text": "Mail the application and required payment to Minnesota Department of Health, Radiation Control X-ray Unit, P.O. Box 64497, St. Paul, MN 55164-0497. The annual base fee is $155; equipment fees are added by machine type."
      },
      {
        "type": "h3",
        "text": "Step 4: Accept the portal invitation"
      },
      {
        "type": "p",
        "text": "After the payment is received, Minnesota emails an invitation. Sign in and complete every required facility and machine field before first use."
      },
      {
        "type": "h3",
        "text": "Step 5: Use the portal for changes and annual renewal"
      },
      {
        "type": "p",
        "text": "Add later equipment in the online system within 30 days and before first use. Pay annual invoices online and download the current certificate."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The annual facility base fee is $155. Equipment fees are added by type; for example, dental X-ray equipment is $60 per unit under the current guide."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Minnesota Department of Health X-ray Unit: health.xray@state.mn.us."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Minnesota Source",
            "href": "https://www.health.state.mn.us/communities/environment/radiation/xray/forms.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-mississippi-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Mississippi: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Mississippi can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Mississippi can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Mississippi uses an online DocuSign application for healing-arts or veterinary X-ray units. Industrial and other ionizing-radiation devices use a different DocuSign application."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start Healing Arts or Veterinary X-Ray Registration",
            "href": "https://powerforms.docusign.net/292fca76-459e-40b1-b8e2-0fc5b44c9030?accountId=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&acct=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&env=na3"
          },
          {
            "label": "Start Industrial or Other Device Registration",
            "href": "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=37e76750-1d42-4813-a699-16ff59c6d566&acct=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&env=na3&v=2"
          },
          {
            "label": "Open Mississippi Radiation Applications",
            "href": "https://msdh.ms.gov/page/30%2C0%2C102%2C1058.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and contact information"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, room, and installation date"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Installer's FDA Form 2579 for diagnostic systems"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Finish the room and shielding plan"
      },
      {
        "type": "p",
        "text": "Complete the layout and shielding calculations before construction or installation. Keep the final report with the registration records."
      },
      {
        "type": "h3",
        "text": "Step 2: Choose the correct online application"
      },
      {
        "type": "p",
        "text": "Medical, dental, chiropractic, podiatric, and veterinary facilities use the Healing Arts or Veterinary application. Industrial or other ionizing-radiation devices use the device application."
      },
      {
        "type": "h3",
        "text": "Step 3: Complete and sign the DocuSign form"
      },
      {
        "type": "p",
        "text": "Enter the facility, responsible person, machine, and room information. Upload or attach the requested technical records, then electronically sign and submit."
      },
      {
        "type": "h3",
        "text": "Step 4: Send Form 2579 if available"
      },
      {
        "type": "p",
        "text": "The installer may send the completed FDA Form 2579 to xrayregistration@msdh.ms.gov or mail it to MSDH Division of Radiological Health, 310 Airport Road, Pearl, MS 39208."
      },
      {
        "type": "h3",
        "text": "Step 5: Save the completed envelope and registration"
      },
      {
        "type": "p",
        "text": "Download the completed DocuSign envelope and keep it with the shielding, installation, performance, and state registration records."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The application identifies any current registration charge based on the machine and facility type."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Mississippi Division of Radiological Health: xrayregistration@msdh.ms.gov; 310 Airport Road, Pearl, MS 39208."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Mississippi Source",
            "href": "https://msdh.ms.gov/page/30%2C0%2C102%2C1058.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-missouri-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Missouri: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Missouri can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Missouri can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Missouri facilities register diagnostic X-ray machines with the Missouri Radiation Control Program. Complete the medical radiation registration form, list every machine, and send the signed form to the program."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Missouri Medical Radiation Registration Form",
            "href": "https://health.mo.gov/safety/radprotection/pdf/MoMedRadRegForm.pdf"
          },
          {
            "label": "Open Missouri Radiation Forms",
            "href": "https://health.mo.gov/providers/radiation-control/applications-forms"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and contact information"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, tube count, and room"
      },
      {
        "type": "p",
        "text": "• Shielding design and calculation report"
      },
      {
        "type": "p",
        "text": "• Installer and equipment-performance records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the shielding"
      },
      {
        "type": "p",
        "text": "New and relocated Missouri X-ray facilities need a shielding evaluation by a Missouri-approved Qualified Expert. New facilities also need the applicable Qualified Expert radiation-safety survey. Timing depends on the equipment class: CT, fluoroscopy/C-arm, radiation therapy, and mammography must be surveyed before routine clinical use; newly installed dental CBCT must be evaluated and inspected within 30 days; most other new Class B, C, and D equipment must have the required onsite survey within 90 days of beginning use."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration form"
      },
      {
        "type": "p",
        "text": "Enter the facility and owner information. List each machine in the inventory section. The form has room for up to 15 machines."
      },
      {
        "type": "h3",
        "text": "Step 3: Sign and submit"
      },
      {
        "type": "p",
        "text": "Email the signed form to MRCP@health.mo.gov. You may also mail it to Missouri Radiation Control Program, P.O. Box 570, Jefferson City, MO 65102-0570."
      },
      {
        "type": "h3",
        "text": "Step 4: Keep the registration file"
      },
      {
        "type": "p",
        "text": "Save the submitted form, shielding report, installation paperwork, performance tests, and state response."
      },
      {
        "type": "h3",
        "text": "Step 5: Report later changes"
      },
      {
        "type": "p",
        "text": "Notify the program when ownership, address, contacts, or equipment change. Follow the state's renewal or update notice when received."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Follow the current fee or invoice instructions from the Missouri Radiation Control Program. The amount depends on the registered equipment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Missouri Radiation Control Program: MRCP@health.mo.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Missouri Source",
            "href": "https://health.mo.gov/providers/radiation-control/applications-forms"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-montana-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Montana: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Montana can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Montana can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Montana requires a radiation machine to be registered within 30 days of possession. The state's current process is online, and registered machines are re-registered every two years."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Montana Radiation Machine Registration",
            "href": "https://dphhs.mt.gov/qad/radiationmachineregistration"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Review shielding and room-layout requirements before construction or installation and retain the final design or evaluation with the facility's radiation-machine records."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the Montana Radiation Machine Registration online process to enter the facility, machine, owner, and equipment-location information requested by DPHHS."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the registration through the current Montana online system within 30 days of possessing the radiation machine."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration and machine inventory current. Out-of-state operators bringing temporary radiation machines into Montana have separate advance-notice requirements."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Montana radiation-machine registrations are re-registered every two years."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Use the current Montana registration system and state fee information for the applicable amount for the facility and machine type."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Montana Radiation Machine Registration: Radiation.Machine.Registration@mt.gov; 406-444-5944."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Montana Source",
            "href": "https://dphhs.mt.gov/qad/radiationmachineregistration"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-nebraska-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Nebraska: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Nebraska can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Nebraska can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Nebraska requires each X-ray facility to submit Form NRH-4 and the applicable fee within 30 days after operations begin. Registration expires every year."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Nebraska Form NRH-4",
            "href": "https://dhhs.ne.gov/Radiation%20Control%20%20Documents/NRH-4%20-%20Fill.pdf"
          },
          {
            "label": "Download the NRH-4 Instructions",
            "href": "https://dhhs.ne.gov/Radiation%20Control%20%20Documents/NRH-4INST.pdf"
          },
          {
            "label": "Open Nebraska X-Ray Registration Instructions",
            "href": "https://dhhs.ne.gov/Pages/Radiation-Control-X-Ray-Registrations.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, billing, and equipment-location information"
      },
      {
        "type": "p",
        "text": "• Practice-type code from the NRH-4 instructions"
      },
      {
        "type": "p",
        "text": "• Each machine's type code, manufacturer, model, serial number, date, and room"
      },
      {
        "type": "p",
        "text": "• Named Radiation Safety Officer"
      },
      {
        "type": "p",
        "text": "• Citizenship attestation and any required supporting copy"
      },
      {
        "type": "p",
        "text": "• Current fee payment"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete the room and shielding records"
      },
      {
        "type": "p",
        "text": "Prepare the shielding plan before construction or machine installation. Keep the final design and any testing reports at the facility."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete NRH-4"
      },
      {
        "type": "p",
        "text": "Fill out facility, billing, practice type, equipment, Radiation Safety Officer, and citizenship sections. Use NRH-4A if more machine lines are needed."
      },
      {
        "type": "h3",
        "text": "Step 3: Send the form and fee"
      },
      {
        "type": "p",
        "text": "Email the completed form to dhhs.radiationprograms@nebraska.gov or mail the original to Nebraska DHHS Office of Radiological Health, 301 Centennial Mall South, P.O. Box 95026, Lincoln, NE 68509-5026."
      },
      {
        "type": "h3",
        "text": "Step 4: Post the certificate and required notices"
      },
      {
        "type": "p",
        "text": "After approval and payment, post the current Certificate of Registration, operating procedures, and NRH-3 Notice to Employees. Dental facilities may use NRH-3D."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew every year and report changes"
      },
      {
        "type": "p",
        "text": "Renew annually. Report any change that makes the application information wrong within 30 days."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The annual fee depends on the practice and machine types in Nebraska's fee rule. Submit the applicable fee with NRH-4; use the official program contact page to confirm the amount."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Nebraska Office of Radiological Health: dhhs.radiationprograms@nebraska.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Nebraska Source",
            "href": "https://dhhs.ne.gov/Pages/Radiation-Control-X-Ray-Registrations.aspx"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-nevada-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Nevada: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Nevada can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Nevada can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Nevada registers facility X-ray machines through the CLICS online system. The facility is responsible for the registration and fees, and the certificate must be posted before use. The state says processing may take about 30 days."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Nevada CLICS",
            "href": "https://nvrcp.aithent.com/"
          },
          {
            "label": "Open Nevada Machine Forms and Instructions",
            "href": "https://www.dpbh.nv.gov/regulatory/radiation-control-programs/radiation-producing-machines-program-rpm/forms/"
          },
          {
            "label": "Read Nevada Machine Registration FAQs",
            "href": "https://www.dpbh.nv.gov/regulatory/radiation-control-programs/radiation-producing-machines-program-rpm/faqs/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Nevada facility legal name, address, owner, and contact"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, room, and installation date"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Installer and acceptance-test records"
      },
      {
        "type": "p",
        "text": "• Online payment method"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room and shielding"
      },
      {
        "type": "p",
        "text": "Address room shielding before construction or installation and retain the final design and supporting records. Heartland Physics can review the Nevada project and confirm whether its current qualifications and authorization cover the shielding work."
      },
      {
        "type": "h3",
        "text": "Step 2: Create a CLICS account"
      },
      {
        "type": "p",
        "text": "Open the Nevada CLICS link. Register the facility user and confirm the email address."
      },
      {
        "type": "h3",
        "text": "Step 3: Apply for machine registration"
      },
      {
        "type": "p",
        "text": "Choose the radiation-producing machine registration. Enter the Nevada facility, responsible person, room, and machine information. Upload requested documents."
      },
      {
        "type": "h3",
        "text": "Step 4: Pay and wait for the certificate"
      },
      {
        "type": "p",
        "text": "Pay the online charges and save the confirmation. Allow about 30 days for processing. Nevada does not normally require a state inspection before initial use, but the registration certificate must be posted before operation."
      },
      {
        "type": "h3",
        "text": "Step 5: Use CLICS for later changes"
      },
      {
        "type": "p",
        "text": "Update the registration when a unit is added, moved, replaced, transferred, stored, or removed. Renew and pay fees when the system sends the notice."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Nevada calculates registration fees from the facility and machine information entered in CLICS."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Nevada Radiation Control Program: radiationcontrolprogram@health.nv.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Nevada Source",
            "href": "https://www.dpbh.nv.gov/regulatory/radiation-control-programs/radiation-producing-machines-program-rpm/faqs/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-new-hampshire-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in New Hampshire: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in New Hampshire can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in New Hampshire can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "New Hampshire requires one original, signed machine-registration application for each X-ray or MRI unit. Send it to the Radiological Health Section with the fee, business-registration proof, and installer records."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the New Hampshire Machine Application",
            "href": "https://www.dhhs.nh.gov/sites/g/files/ehbemt476/files/inline-documents/sonh/rhs-a-machineapp_0.pdf"
          },
          {
            "label": "Open New Hampshire Radiological Health",
            "href": "https://www.dhhs.nh.gov/programs-services/environmental-health-and-you/radiological-health"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• New Hampshire Secretary of State business-registration proof"
      },
      {
        "type": "p",
        "text": "• One full machine-information set per application"
      },
      {
        "type": "p",
        "text": "• Installer's FDA Form 2579"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Check payable to Treasurer – State of New Hampshire"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete the room and shielding design"
      },
      {
        "type": "p",
        "text": "Prepare the room plan and shielding calculations before construction or installation. Keep the final report."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete one application per unit"
      },
      {
        "type": "p",
        "text": "Enter the facility, contact, machine, room, tube count, purpose, and fee category. Use a separate signed application for each unit."
      },
      {
        "type": "h3",
        "text": "Step 3: Attach business and installer records"
      },
      {
        "type": "p",
        "text": "Include proof that the business is registered with the New Hampshire Secretary of State and a copy of FDA Form 2579 when applicable."
      },
      {
        "type": "h3",
        "text": "Step 4: Mail the original and payment"
      },
      {
        "type": "p",
        "text": "Mail the signed application to New Hampshire DHHS, Radiological Health Section, 29 Hazen Drive, Concord, NH 03301-6503. Make the check payable to Treasurer – State of New Hampshire."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the certificate and report changes"
      },
      {
        "type": "p",
        "text": "Keep the certificate and all supporting records at the facility. Use the state change or disposition form when a unit is replaced, moved, transferred, stored, or removed."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The annual fee is based on the machine category listed in the application instructions. The form includes the category table used to calculate payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "New Hampshire Radiological Health Section: use the official program contact page; 29 Hazen Drive, Concord, NH 03301-6503."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official New Hampshire Source",
            "href": "https://www.dhhs.nh.gov/sites/g/files/ehbemt476/files/inline-documents/sonh/rhs-a-machineapp_0.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-new-jersey-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in New Jersey: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in New Jersey can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in New Jersey can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "New Jersey requires the facility to submit both pages of the X-ray registration form within 30 days after installation. Do not send payment with the form; the state sends an invoice later."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the New Jersey X-Ray Registration Form",
            "href": "https://www.nj.gov/dep/rpp/reg/downloads/xrayreg.pdf"
          },
          {
            "label": "Open New Jersey X-Ray Registration Services",
            "href": "https://www.xray.nj.gov/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and contact information"
      },
      {
        "type": "p",
        "text": "• Every machine's manufacturer, model, serial number, type, room, and installation date"
      },
      {
        "type": "p",
        "text": "• Radiation-safety survey for each installation"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Installer information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete the shielding design and installation survey"
      },
      {
        "type": "p",
        "text": "Plan the room before construction. After installation, keep the radiation-safety survey for each machine and room."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete both pages of the registration form"
      },
      {
        "type": "p",
        "text": "Enter facility, owner, contact, and machine information. Do not skip the second page. Sign the application."
      },
      {
        "type": "h3",
        "text": "Step 3: Email or mail the PDF"
      },
      {
        "type": "p",
        "text": "Email the signed form to BXC@dep.nj.gov, or mail it to Bureau of X-Ray Compliance, P.O. Box 420, Mail Code 25-01, Trenton, NJ 08625-0420. Submit within 30 days after installation."
      },
      {
        "type": "h3",
        "text": "Step 4: Wait for the invoice"
      },
      {
        "type": "p",
        "text": "Do not send money with the registration form. New Jersey reviews the filing and sends the bill separately."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep records ready for inspection"
      },
      {
        "type": "p",
        "text": "Keep the registration, shielding design, radiation-safety surveys, installation documents, and operating procedures at the facility."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Do not pay with the initial form. New Jersey invoices the facility after it processes the registration."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "New Jersey Bureau of X-Ray Compliance: BXC@dep.nj.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official New Jersey Source",
            "href": "https://www.nj.gov/dep/rpp/reg/downloads/xrayreg.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-new-mexico-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in New Mexico: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in New Mexico can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in New Mexico can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "New Mexico uses one Registration to Operate Radiation Machines form for new applications, renewals, and amendments. Email is the state's preferred submission method."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the New Mexico Registration Form",
            "href": "https://www.env.nm.gov/rcb/wp-content/uploads/sites/16/2025/03/Flattened-Registration-to-Operate-Radiation-Machines-Form.pdf"
          },
          {
            "label": "Open the New Mexico Radiation Machines Program",
            "href": "https://www.env.nm.gov/rcb/radiation-machines/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and billing information"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine type, manufacturer, model, serial number, room, and installation date"
      },
      {
        "type": "p",
        "text": "• Shielding design and room information"
      },
      {
        "type": "p",
        "text": "• Installer and equipment-performance records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete the shielding and room plan"
      },
      {
        "type": "p",
        "text": "Finish the shielding design before construction or machine installation. Keep the final calculations and plan."
      },
      {
        "type": "h3",
        "text": "Step 2: Choose the application reason"
      },
      {
        "type": "p",
        "text": "Mark new registration, renewal, or amendment on the form. Complete the facility and responsible-person sections."
      },
      {
        "type": "h3",
        "text": "Step 3: List every machine"
      },
      {
        "type": "p",
        "text": "Enter the manufacturer, model, serial number, machine type, room, and dates. Attach extra pages if needed."
      },
      {
        "type": "h3",
        "text": "Step 4: Sign and email the form"
      },
      {
        "type": "p",
        "text": "Email the completed PDF to RCB.XRayMachines@Env.NM.Gov. Email is preferred. You may mail it to NMED, 525 Camino de los Marquez, Suite 1B, P.O. Box 5469, Santa Fe, NM 87505-5469."
      },
      {
        "type": "h3",
        "text": "Step 5: Save the state response and keep the record current"
      },
      {
        "type": "p",
        "text": "Keep the registration and supporting records. File an amendment when machines, ownership, address, or key facility information change."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Follow the current fee instructions on the New Mexico form or invoice. The amount depends on the facility and registered machines."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "New Mexico Radiation Control Bureau: RCB.XRayMachines@Env.NM.Gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official New Mexico Source",
            "href": "https://www.env.nm.gov/rcb/radiation-machines/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-new-york-city-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in New York City: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in New York City can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in New York City can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "New York City has its own radiation-equipment registration program. Facilities using radiation-producing equipment for patient diagnosis or treatment need a current Certificate of Registration from the NYC Department of Health and Mental Hygiene."
      },
      {
        "type": "p",
        "text": "The standard registration fee is $100 and the certificate renews every two years."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open NYC Radiological Equipment Information",
            "href": "https://www.nyc.gov/site/doh/business/permits-and-licenses/radiological-equipment-x-rays-and-materials.page"
          },
          {
            "label": "Open NYC Radiation Equipment Registration Instructions",
            "href": "https://nyc-business.nyc.gov/nycbusiness/description/radiation-producing-equipment-certificate-of-registration"
          },
          {
            "label": "Download NYC X-Ray Permit Instructions",
            "href": "https://www.nyc.gov/assets/doh/downloads/pdf/radioh/equipment-permit-app-inst.pdf"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Address room shielding and radiation-protection requirements before installation. NYC also requires technical documentation with the registration: dental, podiatric, and veterinary facilities have inspection requirements before patient use, while other clinical facilities generally submit a medical physicist report documenting initial quality-control testing."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the NYC Radiation Producing Equipment Certificate of Registration application and list all radiation-producing machines at the facility. Gather the administrative insurance documents and technical documents identified by the permit instructions."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Apply through the NYC online licensing system or another currently accepted method shown by DOHMH. New applications are not accepted by mail. Pay the registration fee and upload the required supporting documents."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not use equipment on patients until the required registration and applicable inspection or physicist documentation are complete. Keep the certificate, technical reports, machine inventory, and inspection records at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Renew every two years. NYC states that the certificate expires two years from the end of the month in which the application was approved, and renewal reminders are generally sent in advance."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The standard Radiation Producing Equipment Certificate of Registration fee is $100 for two years. A separate certified registration for installations with linear accelerators is listed at $600 for five years. Confirm the current permit type before payment."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "NYC DOHMH Office of Radiological Health: orh@health.nyc.gov; 718-786-6002."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official New York City Source",
            "href": "https://www.nyc.gov/site/doh/business/permits-and-licenses/radiological-equipment-x-rays-and-materials.page"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-new-york-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in New York: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in New York can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in New York can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Outside New York City, a new X-ray practice registers with the New York State Bureau of Environmental Radiation Protection."
      },
      {
        "type": "p",
        "text": "Outside New York City, contact the New York State Bureau of Environmental Radiation Protection at least two weeks before the first day of operation. New York City uses a separate city program."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open New York X-Ray Registration Instructions",
            "href": "https://www.health.ny.gov/environmental/radiological/radon/registration.htm"
          },
          {
            "label": "Open New York Radiation Equipment FAQs",
            "href": "https://www.health.ny.gov/environmental/radiological/faqs/radequip.htm"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Business name, physical address, county, phone, and federal tax ID"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer name and contact"
      },
      {
        "type": "p",
        "text": "• Equipment type and number of machines"
      },
      {
        "type": "p",
        "text": "• Planned first-use date"
      },
      {
        "type": "p",
        "text": "• Shielding design, room plan, and installation records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room and schedule early"
      },
      {
        "type": "p",
        "text": "Complete any required room and shielding planning before construction. Outside New York City, contact the state Bureau of Environmental Radiation Protection at least two weeks before the first day of operation."
      },
      {
        "type": "h3",
        "text": "Step 2: Contact the correct agency"
      },
      {
        "type": "p",
        "text": "Outside New York City, email berp@health.ny.gov at least two weeks before first use. Inside New York City, use the official city radiation-program contact page."
      },
      {
        "type": "h3",
        "text": "Step 3: Give the required facility details"
      },
      {
        "type": "p",
        "text": "Provide the business name, RSO, address, phone, county, federal tax ID, equipment type and count, and planned first-use date."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the application the bureau sends"
      },
      {
        "type": "p",
        "text": "Fill in every requested facility and machine field. Return it with any requested room, shielding, installer, or equipment documents."
      },
      {
        "type": "h3",
        "text": "Step 5: Pay the bill and keep registration current"
      },
      {
        "type": "p",
        "text": "New York charges a $50 annual base fee plus modality fees. Registrations renew every two years, while billing occurs annually."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The annual base fee is $50, plus the current fee for each equipment modality. Registration is renewed every two years and billed annually."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "New York State BERP: berp@health.ny.gov; Empire State Plaza, Corning Tower, Room 1201, Albany, NY 12237. For New York City, use the official city radiation-program contact page."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official New York Source",
            "href": "https://www.health.ny.gov/environmental/radiological/radon/registration.htm"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-north-carolina-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in North Carolina: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in North Carolina can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in North Carolina can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "North Carolina requires a facility and each radiation machine to be registered. The rule requires registration within 30 days following initial operation, and registration fees are assessed when the registration is issued and annually on July 1."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open North Carolina X-Ray Applications",
            "href": "https://radiation.ncdhhs.gov/xray/applic.htm"
          },
          {
            "label": "Open North Carolina Registration Information",
            "href": "https://radiation.ncdhhs.gov/Xray/documents/RegistrationInformation.pdf"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Determine whether a shielding plan and state review are required before construction or installation. Many medical X-ray installations require shielding-plan review, with specific exemptions and modality rules."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete the North Carolina Business Application and the equipment-specific registration form for the type of radiation machine being installed."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit applications and updates to the current North Carolina X-ray registration address or email. The program currently accepts registration materials at XrayNORS@dhhs.nc.gov."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration, shielding plan or exemption documentation, equipment inventory, installer records, and required inspections or performance evaluations with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "North Carolina assesses registration fees annually on July 1 and requires facilities to keep registration information current when equipment or facility information changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "North Carolina's fee schedule varies by facility category and number of tubes."
      },
      {
        "type": "p",
        "text": "For many clinics, physician offices, dental, chiropractic, podiatry, and similar facilities, the published schedule starts at $70 for the facility/first tube plus $12.50 for each additional tube, subject to the rule's limits."
      },
      {
        "type": "p",
        "text": "Confirm the current category and fee before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "North Carolina X-Ray Registration: XrayNORS@dhhs.nc.gov; payment questions: RPSPayments@dhhs.nc.gov; 919-814-2250."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official North Carolina Source",
            "href": "https://radiation.ncdhhs.gov/xray/applic.htm"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-north-dakota-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in North Dakota: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in North Dakota can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees,…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in North Dakota can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "North Dakota requires X-ray facilities to register radiation machines. The current program instructs facilities to apply within 30 days following installation, and the registration fee shown on the state form covers a three-year registration period."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open North Dakota X-Ray Registration",
            "href": "https://deq.nd.gov/wm/radiation/x-ray.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "For a new installation, submit plans, shielding specifications, and equipment arrangement when required before construction. The state may require a qualified expert for shielding or radiation-protection review."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete North Dakota SFN 8428 with the facility and radiation-machine information requested by the Department of Environmental Quality."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit SFN 8428 and the fee shown on the current form to the North Dakota Radiation Control Program using the filing instructions provided by DEQ."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "The state issues registration documentation for approved machines. Keep the registration, shielding records, machine inventory, and installation/inspection documentation at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "The current North Dakota radiation-machine registration period is three years. Follow DEQ's renewal notice and update the inventory when equipment changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The applicable three-year registration fee is stated on the current SFN 8428 form and varies with the registration details. Confirm the current form before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "North Dakota Radiation Control Program. Use the contact information on the DEQ X-Ray page for current registration assistance."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official North Dakota Source",
            "href": "https://deq.nd.gov/wm/radiation/x-ray.aspx"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-northern-mariana-islands-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Northern Mariana Islands: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Northern Mariana Islands can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Northern Mariana Islands can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "The Northern Mariana Islands' current public health authority is the Commonwealth Healthcare Corporation, but a clearly identified current general X-ray machine registration portal is not published on the public CHCC site."
      },
      {
        "type": "p",
        "text": "Confirm the applicable facility, radiation-machine, shielding, and inspection requirements with CHCC before installing equipment."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Commonwealth Healthcare Corporation",
            "href": "https://www.chcc.health/"
          },
          {
            "label": "Open the CNMI Administrative Register Index",
            "href": "https://cnmilaw.org/regindex.php"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Before construction, ask CHCC or the responsible CNMI public/environmental health office whether a shielding design, plan review, or radiation survey must be submitted for the proposed machine."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Request the current registration or facility-licensing instructions for radiation-producing equipment and identify the exact program responsible for the intended medical, dental, veterinary, research, or industrial use."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "File the application and supporting documents using the method provided by CHCC or the responsible CNMI office. Do not rely on older CNMI Register forms without confirming that they remain current."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Retain the regulator's written instructions, facility approval, equipment documentation, shielding records, and inspection reports."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "No single current public renewal cycle for all X-ray equipment was identified in this review. Confirm renewal and inspection timing directly with the responsible CNMI authority."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "No current general X-ray registration fee schedule was identified on the public CHCC source reviewed. Confirm any fee before filing."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Commonwealth Healthcare Corporation: use the current CHCC contact information and ask to be routed to the public/environmental health program responsible for radiation-producing equipment."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Northern Mariana Islands Source",
            "href": "https://www.chcc.health/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-ohio-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Ohio: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Ohio can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Ohio can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Ohio requires a radiation-generating-equipment facility to apply for registration at least 30 days before handling or operating the equipment. Registrations are generally valid for two years, and Ohio law sets a biennial radiation-generating-equipment registration fee."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Ohio Radiation-Generating Equipment Registration Rule",
            "href": "https://codes.ohio.gov/ohio-administrative-code/rule-3701:1-38-03"
          },
          {
            "label": "Open Ohio Registration Fee Law",
            "href": "https://codes.ohio.gov/ohio-revised-code/section-3748.07"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Complete the required shielding evaluation and facility design work before construction or installation. Ohio's diagnostic shielding designer must meet the state's Radiation Expert qualifications even though no separate ODH shielding-only registration is required."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Obtain the current radiation-generating-equipment facility registration application or portal instructions from the Ohio Department of Health Bureau of Environmental Health and Radiation Protection and provide the requested facility and equipment information."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the complete application and fee at least 30 days before handling the radiation-generating equipment, following the current ODH instructions."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Wait for the required facility registration, then maintain the certificate, shielding and equipment records, and required inspections or quality-control documentation."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Ohio registrations generally expire two years after issuance. Submit the renewal in time to avoid a lapse; the rule calls for renewal activity before expiration."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Ohio Revised Code currently lists a $262 biennial registration fee for radiation-generating equipment. Confirm the current invoice and any equipment-specific charges with ODH."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Ohio Department of Health, Bureau of Environmental Health and Radiation Protection. Use the current ODH X-ray/radiation control contact for application assistance."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Ohio Source",
            "href": "https://codes.ohio.gov/ohio-administrative-code/rule-3701:1-38-03"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-oklahoma-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Oklahoma: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Oklahoma can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Oklahoma can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Oklahoma requires a permit to operate diagnostic X-ray equipment. As of April 22, 2026, the Oklahoma State Department of Health moved its initial and renewal licensing process online."
      },
      {
        "type": "p",
        "text": "Diagnostic medical X-ray is handled by OSDH; certain industrial, analytical, and therapeutic equipment is handled separately by Oklahoma DEQ."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Oklahoma Diagnostic X-Ray Licensing",
            "href": "https://www.oklahoma.gov/health/services/licensing-inspections/consumer-health-service/licensure/x-ray.html"
          },
          {
            "label": "Open Oklahoma DEQ Radiation Program",
            "href": "https://oklahoma.gov/deq/divisions/land-protection/radiation.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Review shielding and room-layout requirements before installation and retain the final shielding calculations plus any required inspection or calibration records with the permit file."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the OSDH online licensing portal for diagnostic X-ray facilities and provide the ownership, facility, machine, inspection/calibration, and other information required for the equipment category."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the application and fee through the current OSDH licensing process. If the equipment is industrial, analytical, or therapeutic rather than diagnostic medical, confirm whether Oklahoma DEQ is the proper regulator before filing."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not operate diagnostic X-ray equipment without the required permit. Retain the permit, shielding information, equipment inventory, inspections, calibrations, and applicable quality-control records."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Oklahoma diagnostic X-ray permits renew annually."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current OSDH fee schedule lists $30 per tube for dental/podiatric, $25 per tube for veterinary, and $95 per tube for other diagnostic X-ray categories, with a $500 facility maximum. Confirm the current category in the online system."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "OSDH Consumer Health Service Licensing: CHSLicensing@health.ok.gov; 405-426-8250."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Oklahoma Source",
            "href": "https://www.oklahoma.gov/health/services/licensing-inspections/consumer-health-service/licensure/x-ray.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-oregon-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Oregon: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Oregon can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Oregon can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Oregon uses a paper X-ray registration application. Send the completed form, then wait for the state invoice. The form says a facility may operate after the application is submitted, but it must follow every safety and licensing rule."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Oregon X-Ray Registration Application",
            "href": "https://www.oregon.gov/oha/ph/HealthyEnvironments/RadiationProtection/xray/Documents/registrationapplication.pdf"
          },
          {
            "label": "Open Oregon Registration Instructions",
            "href": "https://www.oregon.gov/oha/ph/healthyenvironments/radiationprotection/xray/pages/registration.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, billing, and contact information"
      },
      {
        "type": "p",
        "text": "• Machine type, manufacturer, model, serial number, room, and installation date"
      },
      {
        "type": "p",
        "text": "• Licensed installer information"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Payment for the later invoice"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room and use a licensed vendor"
      },
      {
        "type": "p",
        "text": "Complete the shielding design before construction or installation. The installer or vendor must hold the required Oregon license."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Fill in the facility, owner, contact, practice, and equipment sections. List each tube and machine."
      },
      {
        "type": "h3",
        "text": "Step 3: Email or mail the form"
      },
      {
        "type": "p",
        "text": "Email the form to Judith.A.Smith@oha.oregon.gov, or mail it to Oregon Radiation Protection Services, 800 NE Oregon Street, Suite 640, Portland, OR 97232."
      },
      {
        "type": "h3",
        "text": "Step 4: Pay the invoice"
      },
      {
        "type": "p",
        "text": "Oregon reviews the form and sends an invoice. Pay it promptly. The state reports that certificates usually arrive about four to six weeks after payment."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the registration and update changes"
      },
      {
        "type": "p",
        "text": "Keep the certificate, shielding plan, installation record, and performance documents. Report ownership, address, and machine changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Current two-year facility fees include $427 for chiropractic, hospital, medical, osteopathic, and radiology facilities; $285 for industrial and podiatry; and $210 for academic, dental, and veterinary facilities."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Oregon Radiation Protection Services: Judith.A.Smith@oha.oregon.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Oregon Source",
            "href": "https://www.oregon.gov/oha/ph/healthyenvironments/radiationprotection/xray/pages/registration.aspx"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-pennsylvania-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Pennsylvania: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Pennsylvania can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Pennsylvania can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Pennsylvania requires the facility to register each radiation-producing machine within 30 days after acquiring it. Mail the registration form and the full fee to the Department of Environmental Protection."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Pennsylvania Registration Form",
            "href": "https://greenport.pa.gov/elibrary/PDFProvider.ashx?PromptToSave=False&Size=170261&ViewerMode=2&action=PDFStream&docID=1489395&docName=02+REGISTRATION+FORM&nativeExt=pdf&overlay=0&revision=1"
          },
          {
            "label": "Open Pennsylvania Machine Registration Instructions",
            "href": "https://www.pa.gov/services/dep/register-a-radiation-producing-machine"
          },
          {
            "label": "Open Pennsylvania GreenPort Renewal Information",
            "href": "https://www.pa.gov/agencies/dep/programs-and-services/business/epermitting/radiation-protection-epermitting"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility, owner, and contact information"
      },
      {
        "type": "p",
        "text": "• Every tube's manufacturer, model, serial number, type, and location"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Check or money order payable to Commonwealth of Pennsylvania"
      },
      {
        "type": "p",
        "text": "• Installer and performance records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete the shielding design"
      },
      {
        "type": "p",
        "text": "Prepare the room and shielding plan before construction or installation. Keep the final report for inspection."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration form"
      },
      {
        "type": "p",
        "text": "List the facility, owner, contacts, and every X-ray tube. Submit within 30 days after acquiring the machine."
      },
      {
        "type": "h3",
        "text": "Step 3: Calculate the fee"
      },
      {
        "type": "p",
        "text": "Add the facility administrative fee to $65 for each X-ray tube. Administrative fees are $130 for chiropractic, dental, podiatric, and veterinary facilities; $940 for hospitals; and $455 for other facilities."
      },
      {
        "type": "h3",
        "text": "Step 4: Mail the form and full payment"
      },
      {
        "type": "p",
        "text": "Mail the package to DEP Bureau of Radiation Protection, P.O. Box 8469, Harrisburg, PA 17105-8469. Use a check or money order payable to Commonwealth of Pennsylvania."
      },
      {
        "type": "h3",
        "text": "Step 5: Prepare for inspection and renewal"
      },
      {
        "type": "p",
        "text": "A complete application and fee activate the certificate on receipt. Pennsylvania aims to perform the initial inspection within 120 days. Use GreenPort for later e-permitting and renewal tasks."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Facility fee: $130 for chiropractic, dental, podiatric, and veterinary; $940 for hospitals; $455 for other facilities. Add $65 for each X-ray tube."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Pennsylvania DEP Radiation Protection: RA-EPRPControl@pa.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Pennsylvania Source",
            "href": "https://www.pa.gov/services/dep/register-a-radiation-producing-machine"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-puerto-rico-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Puerto Rico: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Puerto Rico can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Puerto Rico can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Puerto Rico's Department of Health regulates radiation machines through its environmental and radiological-health functions. The Department's Salud Digital platform is used for online health transactions and includes radiation-machine matters."
      },
      {
        "type": "p",
        "text": "Facilities should confirm the exact radiological-health certification and related facility requirements for the equipment type before installation or operation."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Puerto Rico Salud Digital",
            "href": "https://covid19datos.salud.pr.gov/CMS/95"
          },
          {
            "label": "Open Puerto Rico Environmental Health",
            "href": "https://covid19datos.salud.pr.gov/CMS/185"
          },
          {
            "label": "Open Puerto Rico Department of Health",
            "href": "https://www.salud.pr.gov/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Coordinate the radiation-protection study and shielding documentation before installation, alteration, or relocation when required by the applicable Puerto Rico health rules. Keep the final protection study with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use Puerto Rico Department of Health/Salud Digital to identify the current transaction for máquinas de radiación and complete the facility, equipment, ownership, and supporting information requested by the Radiological Health/Environmental Health program."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the transaction, supporting documents, and payment through the current Salud Digital process or other method directed by the Department of Health."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the current radiological-health certification, machine inventory, shielding/protection study, inspection documentation, and any health-facility license records that also apply to the site."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "License and certification validity is controlled by the current Puerto Rico Department of Health requirements and may be affected by administrative orders. Confirm the expiration and renewal date shown in Salud Digital and on the issued certification."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Fees depend on the transaction and facility/equipment category. Confirm the current amount in Salud Digital before submitting payment."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Puerto Rico Department of Health: 787-765-2929; contactus@salud.pr.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Puerto Rico Source",
            "href": "https://covid19datos.salud.pr.gov/CMS/95"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-rhode-island-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Rhode Island: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Rhode Island can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Rhode Island can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Rhode Island uses a different X-ray facility application for each facility type. The application must include the required fee and an attached shielding plan and evaluation."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download the Specific Radiology Facility Application",
            "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRaySpecificRadiologyFacility.pdf"
          },
          {
            "label": "Download the Dental Facility Application",
            "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRayDental.pdf"
          },
          {
            "label": "Download the General Radiology Facility Application",
            "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRayRADFacility.pdf"
          },
          {
            "label": "Open All Rhode Island Radiation Applications",
            "href": "https://health.ri.gov/about-us/ridoh-programs-centers-divisions/radiation-control-program"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• The application that matches the facility type"
      },
      {
        "type": "p",
        "text": "• Facility, owner, supervisor, and radiation-protection contact information"
      },
      {
        "type": "p",
        "text": "• Machine and tube inventory"
      },
      {
        "type": "p",
        "text": "• Shielding plan and evaluation"
      },
      {
        "type": "p",
        "text": "• Check payable to RI General Treasurer"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Choose the correct facility application"
      },
      {
        "type": "p",
        "text": "Use the Rhode Island program page to select dental, veterinary, hospital, specific radiology, general radiology, industrial, or another matching facility type."
      },
      {
        "type": "h3",
        "text": "Step 2: Prepare the shielding plan and evaluation"
      },
      {
        "type": "p",
        "text": "Except for regulatory exemptions, new X-ray facilities and modifications require shielding plan review by the Rhode Island Department of Health before construction. The facility application identifies the consulting radiation-physics service and its Rhode Island RPS registration number, so use a provider whose current Rhode Island registration covers the work."
      },
      {
        "type": "h3",
        "text": "Step 3: Complete every question"
      },
      {
        "type": "p",
        "text": "Do not leave blanks. Enter the facility supervisor, radiation-protection contact, ownership, addresses, machine inventory, and requested safety information."
      },
      {
        "type": "h3",
        "text": "Step 4: Add the fee and mail the package"
      },
      {
        "type": "p",
        "text": "For a Specific Radiology Facility, the current application fee is $225. Other facility types use the fee printed on their form."
      },
      {
        "type": "p",
        "text": "Make the check payable to RI General Treasurer and mail to Radiation Control Program, Center for Health Facilities Regulation, Rhode Island Department of Health, 3 Capitol Hill, Room 305, Providence, RI 02908-5097."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the registration and report changes"
      },
      {
        "type": "p",
        "text": "Keep the registration, shielding attachment, inspection documents, and equipment records. A change of ownership requires a new application."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The fee is printed on the application for each facility type. The Specific Radiology Facility application is currently $225."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Rhode Island Radiation Control Program: DOH.RadHealth@health.ri.gov; 3 Capitol Hill, Room 305, Providence, RI 02908-5097."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Rhode Island Source",
            "href": "https://health.ri.gov/about-us/ridoh-programs-centers-divisions/radiation-control-program"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-san-diego-county-california-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in San Diego County, California: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in San Diego County, California can involve several radiation-control steps. This guide puts the ordinary registration sequence, official…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": null,
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in San Diego County, California can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "San Diego County performs local radiological-health inspection and shielding-plan review, while X-ray machine registration is completed with the California Department of Public Health Radiologic Health Branch. Treat the county plan review and state machine registration as separate steps."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open San Diego County Radiological Health",
            "href": "https://www.sandiegocounty.gov/content/sdc/deh/hazmat/radhealth.html"
          },
          {
            "label": "Open San Diego County Shielding Plan Instructions",
            "href": "https://www.sandiegocounty.gov/content/dam/sdc/deh/waste/pdf/chd/HM9900%20rev%2007-2025.pdf"
          },
          {
            "label": "Open California X-Ray Machine Registration",
            "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/Pages/RHB-X-ray/Registration.aspx"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "For installations requiring local review, submit the San Diego County plan-check application, physicist or shielding report when applicable, floor plans showing barriers, room dimensions, adjacent occupancies, and the other information requested in the current county instructions."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Prepare the San Diego County shielding-plan package and separately complete California RHB's radiation-machine registration for the installed X-ray equipment."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Send the county plan-check materials using the current Radiological Health instructions and register the X-ray machine with California RHB after acquisition. The county's current instructions state that state registration remains required after shielding approval."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the county shielding approval, state registration, installer records, and inspection documentation together. Complete any county inspection or follow-up required for the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "California machine registration follows the state renewal cycle. San Diego County shielding-plan review is tied to the installation or modification project."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "San Diego County plan-review fees depend on the complexity, number of rooms, and intended use shown on the current application. California machine-registration fees are separate. Use the current county and state forms for exact amounts."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "San Diego County Radiological Health: 858-694-3621."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official San Diego County, California Source",
            "href": "https://www.sandiegocounty.gov/content/sdc/deh/hazmat/radhealth.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-south-carolina-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in South Carolina: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in South Carolina can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in South Carolina can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "South Carolina uses a two-step process for many X-ray facilities: obtain Facility Registration Approval before installation, then register the installed X-ray equipment. The state says a facility must not install the machine before the required Facility Registration Approval is issued."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open South Carolina X-Ray Registration Guide",
            "href": "https://des.sc.gov/sites/des/files/Documents/BLWM/RadProtection/B1_Registration.pdf"
          },
          {
            "label": "Open South Carolina Shielding Plan Requirements",
            "href": "https://www.des.sc.gov/programs/bureau-land-waste-management/radiation-protection-program/shielding-plan-requirements"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Submit the shielding plan when the installation is in a category requiring state plan review. The state charges a separate plan-review fee when applicable."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Before installation, complete SCDES Form 0845 for Facility Registration Approval and include the required supporting material. After installation, complete SCDES Form 0819 to register the X-ray equipment."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the Facility Registration Approval package to XRayFRA-ShieldingPlans@des.sc.gov before installation. Register installed equipment within 30 days using the current equipment-registration instructions, including XRayRegistration@des.sc.gov where directed."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Do not install before the required FRA is issued. After equipment registration, retain the FRA, shielding-plan review, machine registration, installer records, and required surveys or inspections."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the annual registration billing and update requirements shown in South Carolina's current radiation-control program materials."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current Facility Registration Approval application fee is $62.50. X-ray equipment registration fees vary by modality, and a $62.50 shielding-plan review fee applies per X-ray control when plan review is required."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "South Carolina DES: XRayFRA-ShieldingPlans@des.sc.gov for facility/shielding review; XRayRegistration@des.sc.gov for equipment registration."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official South Carolina Source",
            "href": "https://des.sc.gov/sites/des/files/Documents/BLWM/RadProtection/B1_Registration.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-south-dakota-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in South Dakota: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in South Dakota can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in South Dakota can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "South Dakota treats an X-ray facility as a licensed healthcare facility. Apply through the state's healthcare licensing system. The license renews every year, and the X-ray facility must be surveyed at least every three years by a state inspector or physicist."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start the South Dakota X-Ray Facility Application",
            "href": "https://www.sdhls.org/"
          },
          {
            "label": "Open South Dakota X-Ray Facility Instructions",
            "href": "https://doh.sd.gov/healthcare-professionals/health-facility-licensure/prepare-for-x-ray-facility-inspection/"
          },
          {
            "label": "Open General Facility Licensing Instructions",
            "href": "https://doh.sd.gov/healthcare-professionals/health-facility-licensure/healthcare-facility-licensure/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, address, ownership, and contacts"
      },
      {
        "type": "p",
        "text": "• Machine and room information"
      },
      {
        "type": "p",
        "text": "• Shielding design for new construction or changed rooms"
      },
      {
        "type": "p",
        "text": "• Personnel education and training records"
      },
      {
        "type": "p",
        "text": "• Film badge or dosimetry records"
      },
      {
        "type": "p",
        "text": "• Technique chart, protective-device checks, and equipment quality records"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Plan the room before construction"
      },
      {
        "type": "p",
        "text": "Submit plans for new X-ray construction so the shielding requirements can be reviewed. When a health physicist's shielding recommendations are used, use a provider whose current qualifications cover the work."
      },
      {
        "type": "h3",
        "text": "Step 2: Create an account in the licensing system"
      },
      {
        "type": "p",
        "text": "Open the South Dakota healthcare licensing system and choose the X-ray facility license application."
      },
      {
        "type": "h3",
        "text": "Step 3: Complete the facility application"
      },
      {
        "type": "p",
        "text": "Enter the ownership, location, contact, room, and machine information. Upload requested construction, shielding, and safety records and pay the application charge shown by the system."
      },
      {
        "type": "h3",
        "text": "Step 4: Prepare the seven inspection record groups"
      },
      {
        "type": "p",
        "text": "Keep dosimetry reports, technique charts, processor or image-quality records, patient examination records, staff training, annual protective-device evaluations, and annual CT physicist reports when applicable."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew annually and complete the three-year survey"
      },
      {
        "type": "p",
        "text": "Renew the facility license each year after December 1. Arrange a state or physicist X-ray survey at least every three years and correct any findings by the deadline."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The online licensing system shows the current X-ray facility application and annual renewal fee."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "South Dakota X-ray facility contacts: John Priest, john.priest@state.sd.us; Melissa Heymans, Melissa.Heymans@state.sd.us."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official South Dakota Source",
            "href": "https://doh.sd.gov/healthcare-professionals/health-facility-licensure/prepare-for-x-ray-facility-inspection/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      },
      {
        "type": "p",
        "text": "3 views"
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-tennessee-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Tennessee: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Tennessee can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Tennessee can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Tennessee requires X-ray equipment to be registered with the state's X-Ray Registration program. Current 2026 guidance instructs a registrant that acquires a new X-ray unit to register it within 10 days of possession. Annual fees depend on the equipment class."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Tennessee X-Ray Registration Information",
            "href": "https://www.tn.gov/environment/permits/radiological-health/xray-registration.html"
          },
          {
            "label": "Open Tennessee X-Ray Installer Information",
            "href": "https://www.tn.gov/environment/permits/radiological-health/xray-registration/xray-installers.html"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Confirm the room's shielding requirements before construction or installation and keep the shielding calculations/design with the facility records. Tennessee does not impose a separate shielding-designer license or registration for shielding-calculation/design-only work."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the Tennessee X-Ray Registration process and provide the facility, owner, equipment, and tube information required for the new machine. The facility/registrant, rather than the installer, is responsible for registering the unit."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the new-equipment registration information to the Tennessee X-Ray Registration program using the current online or program instructions, including XRay.Registration@tn.gov when directed."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Complete the inspection requirements applicable to the equipment. Tennessee's program describes an initial inspection by a registered inspector within three months as part of the process for qualifying for the reduced annual fee structure."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Tennessee X-ray registration fees are annual. Follow the program's renewal notice and report equipment additions, removals, or ownership/location changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Annual fees depend on the equipment class. Current state materials use different schedules for dental, medical, therapy, and other equipment. Confirm the class and current invoice before payment; facilities meeting the state's inspection conditions may qualify for a reduced subsequent-year fee."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Tennessee X-Ray Registration: XRay.Registration@tn.gov; 615-532-0364."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Tennessee Source",
            "href": "https://www.tn.gov/environment/permits/radiological-health/xray-registration.html"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-texas-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Texas: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Texas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Texas can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Texas requires a Certificate of Registration before regulated radiation-machine operations begin. The current registration application is RC Form 226-2, revised in 2026, and the application package includes the machine/facility information and other business or RSO documents that apply to the facility."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Download Texas RC Form 226-2",
            "href": "https://www.dshs.texas.gov/sites/default/files/radiation/x-ray/pdf/rc-226-02-rad-machine-app.pdf"
          },
          {
            "label": "Open Texas Radiation Control",
            "href": "https://www.dshs.texas.gov/texas-radiation-control"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Address the room shielding and applicable Texas design requirements before installation. For professional shielding or medical-physics services, use a provider who meets the Texas credential requirements for the work being performed."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Texas RC Form 226-2 for radiation-machine registration and include the applicable business-information, Radiation Safety Officer, machine, and supporting documents listed in the current packet."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the application and applicable fee to Texas DSHS Radiation Control using the current form instructions. The registration must be in place before regulated operations begin."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the Certificate of Registration, machine inventory, shielding and installation records, and required surveys, testing, or inspections available at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Follow the expiration date and renewal instructions on the Texas Certificate of Registration and update DSHS when registered information changes."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Texas fees depend on the certificate and machine category. Use the current RC 204 fee schedule referenced by the RC 226-2 application for the exact amount."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Texas DSHS X-Ray Registration: XrayRegistration@dshs.texas.gov."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Texas Source",
            "href": "https://www.dshs.texas.gov/sites/default/files/radiation/x-ray/pdf/rc-226-02-rad-machine-app.pdf"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-u-s-virgin-islands-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in U.S. Virgin Islands: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in U.S. Virgin Islands can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in U.S. Virgin Islands can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can help organize X-ray registration information and technical records. Shielding design must be performed by a person who meets the jurisdiction's qualification rules; Heartland provides shielding services only where its current authorization and qualifications cover the project."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "The U.S. Virgin Islands Department of Health does not currently publish a clearly identified general X-ray machine registration portal on its public site."
      },
      {
        "type": "p",
        "text": "Before purchasing or installing equipment, contact VI DOH and confirm the current radiation-equipment permit, facility-licensing, inspection, and shielding requirements for the specific island and facility type."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open U.S. Virgin Islands Department of Health",
            "href": "https://doh.vi.gov/"
          },
          {
            "label": "Open VI DOH Environmental Health",
            "href": "https://doh.vi.gov/programs/environmental-health/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Ask VI DOH whether a shielding plan, professional radiation-protection evaluation, or post-installation survey must be completed before the equipment is placed into use."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Request the current radiation-producing-equipment or applicable health-facility application and identify whether Environmental Health, Health Planning, Professional Licensure, or another VI DOH program handles the installation."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the requested facility, equipment, responsible-person, inspection, and shielding information using the filing method provided by VI DOH."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Retain the Department's written instructions, registration/permit or facility approval, shielding records, machine inventory, and inspection documentation."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "No single current public renewal cycle was identified for all X-ray equipment. Confirm the renewal and reinspection schedule directly with VI DOH."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "No general current X-ray-machine registration fee schedule was identified on the public sources reviewed. Confirm applicable permit and inspection fees before filing."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "U.S. Virgin Islands Department of Health: St. Croix 340-718-1311; St. Thomas 340-774-9000; St. John 340-776-6400."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official source and review date"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official U.S. Virgin Islands Source",
            "href": "https://doh.vi.gov/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Heartland Physics last checked this guide against the official sources listed above on August 20, 2026."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-utah-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Utah: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Utah can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Utah can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Utah uses the Division of Waste Management and Radiation Control Community Portal for new X-ray machine registration, renewals, and changes. Registration is annual."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Utah Community Portal",
            "href": "https://deqorg.utah.gov/"
          },
          {
            "label": "Open Utah X-Ray Forms and Instructions",
            "href": "https://deq.utah.gov/dwmrc/x-ray-forms"
          },
          {
            "label": "Download Utah New-Registration Instructions",
            "href": "https://lf-public.deq.utah.gov/WebLink/ElectronicFile.aspx?dbid=0&docid=438439&eqdocs=DSHW-2023-001579&repo=Public"
          },
          {
            "label": "Open Utah Fees and Inspection Information",
            "href": "https://deq.utah.gov/waste-management-and-radiation-control/inspections-registrations-and-fees-x-ray-program"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• Radiation-safety contact"
      },
      {
        "type": "p",
        "text": "• Machine manufacturer, model, serial number, type, tube count, and room"
      },
      {
        "type": "p",
        "text": "• Shielding design and room records"
      },
      {
        "type": "p",
        "text": "• Online payment method"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete room planning and shielding"
      },
      {
        "type": "p",
        "text": "Prepare the shielding design before construction or installation. Keep the final plan and calculations."
      },
      {
        "type": "h3",
        "text": "Step 2: Create a Community Portal account"
      },
      {
        "type": "p",
        "text": "Open the portal, register the facility user, and confirm the email address."
      },
      {
        "type": "h3",
        "text": "Step 3: Start a new X-ray registration"
      },
      {
        "type": "p",
        "text": "Choose the X-ray program and new machine registration. Enter the facility, contact, room, and machine information. Upload the requested records."
      },
      {
        "type": "h3",
        "text": "Step 4: Pay and save the registration"
      },
      {
        "type": "p",
        "text": "Pay the portal fee. Utah reports that a complete online registration is often processed in about two working days after payment."
      },
      {
        "type": "h3",
        "text": "Step 5: Report changes within 14 days and renew annually"
      },
      {
        "type": "p",
        "text": "Notify the state within 14 days when a machine is acquired, transferred, or disposed of. Complete the annual registration renewal and fee payment in the portal."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Utah currently charges an annual X-ray registration fee of $55 per registered tube. The Division also publishes separate inspection fees by facility and equipment type. Use the current DWMRC fee page and portal before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Utah Division of Waste Management and Radiation Control: use the official program contact page for current contact details."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Utah Source",
            "href": "https://deq.utah.gov/dwmrc/x-ray-forms"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-vermont-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Vermont: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Vermont can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Vermont can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Vermont's radiation-machine registration is online and must be renewed every year. Submit the online machine form, wait for the emailed invoice, pay it, and then print the certificate sent by email."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start the Vermont 2026 Machine Registration",
            "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=O5O0IK26PEOcAnDtzHVZxmpH3mmaZbVPvxp6TcPbADZUN05HMUU3SkkxWjEwOUpEMjdNV0I3NlM0UyQlQCN0PWcu"
          },
          {
            "label": "Open Vermont X-Ray Registration Instructions",
            "href": "https://www.healthvermont.gov/environment/radiological-health/x-rays"
          },
          {
            "label": "Open Vermont Online Payment",
            "href": "https://vt.accessgov.com/xray/Forms/Page/xray/registration/0"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility and owner information"
      },
      {
        "type": "p",
        "text": "• Business and machine contacts"
      },
      {
        "type": "p",
        "text": "• Each machine's type, manufacturer, model, serial number, and location"
      },
      {
        "type": "p",
        "text": "• Shielding and service records"
      },
      {
        "type": "p",
        "text": "• An email address that will receive the invoice and certificate"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Finish the room and shielding plan"
      },
      {
        "type": "p",
        "text": "Complete the shielding design before construction or machine installation. Keep the report and registered service-provider records."
      },
      {
        "type": "h3",
        "text": "Step 2: Submit the online registration form"
      },
      {
        "type": "p",
        "text": "Open the 2026 form. Confirm the business information and enter the type and number of machines. Submit the form."
      },
      {
        "type": "h3",
        "text": "Step 3: Wait for the invoice email"
      },
      {
        "type": "p",
        "text": "The invoice may not arrive the same day. Save it because its invoice number is required for online payment."
      },
      {
        "type": "h3",
        "text": "Step 4: Pay online or by check"
      },
      {
        "type": "p",
        "text": "Use the online payment button above. Or mail a check payable to Vermont Department of Health with a copy of the invoice to Environmental Health, Radiological Health Program, 280 State Drive, Waterbury, VT 05671-8350."
      },
      {
        "type": "h3",
        "text": "Step 5: Print the certificate and renew every year"
      },
      {
        "type": "p",
        "text": "Vermont emails the certificate after payment. Print and display it. Repeat the registration and payment process each year."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Vermont emails an invoice after the online registration form is reviewed. The amount is based on the facility's machine inventory."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Vermont Radiological Health Program: use the contact link on the official X-ray page for email."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Vermont Source",
            "href": "https://www.healthvermont.gov/environment/radiological-health/x-rays"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-virginia-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Virginia: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Virginia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "2 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Virginia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Virginia requires X-ray machines to be registered with the Office of Radiological Health, subject to limited exceptions. The medical registration process instructs facilities to register within 30 days following installation and request the required initial inspection."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Virginia Medical X-Ray Machine Registration",
            "href": "https://www.vdh.virginia.gov/radiological-health/radiological-health/x-ray-machine-program/medical-x-ray-machines/"
          },
          {
            "label": "Download Virginia Form RH-F-2",
            "href": "https://www.vdh.virginia.gov/content/uploads/sites/7/2019/12/Form-0120-MedicalRegistration.pdf"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Review shielding and room-layout requirements before installation, and keep the completed shielding design and related radiation-protection records with the facility's machine registration file."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Complete Virginia Form RH-F-2, Medical X-Ray Machine Registration, with the facility, owner, machine, and tube information requested by the Office of Radiological Health."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit RH-F-2 within 30 days following installation using the current VDH instructions and request the initial inspection required for the machine."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "VDH assigns facility/machine registration information and decals as applicable. Keep the registration, shielding records, installer information, and inspection documentation at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Virginia assesses the X-ray machine registration fee annually. Keep the registration current and report machine or facility changes to VDH."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current VDH medical X-ray page lists a $100 annual registration fee. Confirm the current amount for the facility and machine category before payment."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Virginia Office of Radiological Health: radhealth-comments@vdh.virginia.gov; 804-864-8150."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Virginia Source",
            "href": "https://www.vdh.virginia.gov/radiological-health/radiological-health/x-ray-machine-program/medical-x-ray-machines/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-washington-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Washington: A Simple Step-by-Step Guide",
    "excerpt": "Opening or changing an X-ray facility in Washington can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place.",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening or changing an X-ray facility in Washington can feel confusing. This guide puts the state-level steps, forms, filing links, fees, and contacts in one place."
      },
      {
        "type": "quote",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Washington registers X-ray facilities and devices through the Department of Revenue Business Licensing Service. New, remodeled, or moved medical X-ray rooms need shielding calculations before construction or relocation."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Each blue button opens the exact official form, portal, or state instruction page in a new tab."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Start Washington Business Licensing Online",
            "href": "https://dor.wa.gov/open-business/apply-business-license"
          },
          {
            "label": "Open Washington X-Ray Registration Instructions",
            "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/x-ray-equipment-registration"
          },
          {
            "label": "Open Washington Mail-In Registration Instructions and Forms",
            "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/new-x-ray-registration"
          },
          {
            "label": "Open Washington X-Ray Facility Plan Review",
            "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/x-ray-equipment-registration/x-ray-facility-plan-review"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Washington business-license information"
      },
      {
        "type": "p",
        "text": "• Facility and owner contacts"
      },
      {
        "type": "p",
        "text": "• Machine types and tube counts"
      },
      {
        "type": "p",
        "text": "• Room plan and shielding calculations for a covered medical room"
      },
      {
        "type": "p",
        "text": "• Business License Application and X-Ray Facility and Devices Registration for mail filing"
      },
      {
        "type": "p",
        "text": "• Fee payment"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Complete plan review before construction"
      },
      {
        "type": "p",
        "text": "New, remodeled, or relocated medical X-ray facilities that are subject to plan review must submit shielding calculations before construction begins or before the machine is moved. WAC 246-225-030 states that diagnostic veterinary, podiatric, and dental facilities are exempt from submitting shielding calculations and floor plans. DOH’s current registrant guidance also lists dental shielding including dental CBCT, diagnostic veterinary, mammography, and podiatry with generators not exceeding 70 kVp among plans it does not review. For a podiatry installation above 70 kVp, confirm the current DOH interpretation before construction. Covered medical rooms must use a qualified expert and Department review."
      },
      {
        "type": "h3",
        "text": "Step 2: Choose online or mail registration"
      },
      {
        "type": "p",
        "text": "Online: use Business Licensing Service and add the X-Ray Facility and Devices endorsement. Mail: complete both the Business License Application and the X-Ray Facility and Devices Registration form."
      },
      {
        "type": "h3",
        "text": "Step 3: Enter the facility and device information"
      },
      {
        "type": "p",
        "text": "List the location, practice type, machine type, and tube count. Use the fee table in the X-ray form to enter the registration charges."
      },
      {
        "type": "h3",
        "text": "Step 4: Submit and pay"
      },
      {
        "type": "p",
        "text": "For mail filing, send both forms and a check or money order payable to Department of Revenue to State of Washington, Business Licensing Service, P.O. Box 9034, Olympia, WA 98507-9034."
      },
      {
        "type": "h3",
        "text": "Step 5: Keep the annual registration current"
      },
      {
        "type": "p",
        "text": "Washington bills the facility for re-registration every year. Keep the business license, X-ray registration, plan-review letter, shielding calculations, and inspection records."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "Washington fees depend on the practice type and the number and type of X-ray tubes. The online Business Licensing Service or the X-Ray Facility and Devices form calculates the current amount."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "Washington Office of Radiation Protection X-Ray Program and Business Licensing Service: use the official program contact pages for current email and filing support."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate or license"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, and state review letter when applicable"
      },
      {
        "type": "p",
        "text": "• Installer paperwork, FDA Form 2579 when applicable, acceptance tests, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Operating procedures, staff training, dosimetry, maintenance, and inspection records that apply to the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This guide covers the usual state-level radiation-machine process. Mammography, radiation therapy, mobile use, healing-arts screening, and some industrial systems can have extra approvals. Complete those extra steps when they apply to your equipment."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Washington Source",
            "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/x-ray-equipment-registration"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-west-virginia-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in West Virginia: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in West Virginia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees,…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in West Virginia can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "West Virginia requires radiation machines to be registered with the Radiological Health Program before operation. The program lists Form 1R for radiation-machine registration and requires facilities to keep the machine registration current."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. State forms and fees can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open West Virginia Radiological Health",
            "href": "https://oehs.wvdhhr.org/rtia/radiological-health/"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or Radiation Protection Officer information when the jurisdiction requests it"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current registration fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Address room shielding before construction or installation and retain the final design, assumptions, and any state plan-review documentation with the facility records."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Obtain and complete the current West Virginia Form 1R, Radiation Machine Registration, with the facility and equipment information requested by the Radiological Health Program."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit Form 1R and the current required fee to the West Virginia Radiological Health Program before operating the radiation machine."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration, shielding design, machine inventory, installation documents, and required inspections or equipment-performance records at the facility."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Use the current Radiological Health renewal process to keep the facility registration current. The current Form 1R states that changes to the registration information must be reported in writing within 10 days."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current West Virginia Form 1R lists a $150 registration/renewal fee. Use the current Radiological Health program page and form before payment because fees and procedures can change."
      },
      {
        "type": "h2",
        "text": "State contact"
      },
      {
        "type": "p",
        "text": "West Virginia Radiological Health Program: 304-558-2981. Use the current program page for registration contacts and Form 1R."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted registration application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, or equipment decal information"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and state plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine registration process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official West Virginia Source",
            "href": "https://oehs.wvdhhr.org/rtia/radiological-health/"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-wisconsin-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Wisconsin: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Wisconsin can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Wisconsin can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Wisconsin requires all X-ray devices to be registered with the Department of Health Services. Registrations are annual and expire December 31."
      },
      {
        "type": "p",
        "text": "New devices and registration changes should be reported through the state's current online registration process, generally within 30 days of the change."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Wisconsin X-Ray Registration",
            "href": "https://www.dhs.wisconsin.gov/radiation/xray/registration.htm"
          },
          {
            "label": "Open the Wisconsin X-Ray Fee Schedule",
            "href": "https://www.dhs.wisconsin.gov/radiation/xray/feeschedule.htm"
          },
          {
            "label": "Open the Wisconsin X-Ray Program",
            "href": "https://www.dhs.wisconsin.gov/radiation/xray/index.htm"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Evaluate the room layout and shielding before installation and keep the final shielding design, assumptions, and any post-installation radiation survey or equipment-performance records with the facility file."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Use the Wisconsin DHS online Initial Registration/Change process and provide the facility, owner, machine, tube, and location information requested for each X-ray device."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the online registration/change information and pay the applicable registration fee using the current DHS instructions or invoice process."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Keep the registration information current when devices are added, removed, transferred, relocated, or when facility ownership changes. A change of ownership requires a new registration."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Renew annually. Wisconsin generally sends renewal invoices in November for registrations expiring December 31."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "The current DHS schedule lists $50 per site plus $50 per X-ray tube for many medical/non-dental facilities, and $50 per site plus $35 per tube for dental facilities. A $50 late fee may apply. Confirm the current schedule before payment."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Wisconsin DHS X-Ray Program: DHSXray@dhs.wisconsin.gov; 608-267-4782."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open the Official Wisconsin Source",
            "href": "https://www.dhs.wisconsin.gov/radiation/xray/registration.htm"
          }
        ]
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  },
  {
    "slug": "how-to-register-an-x-ray-machine-in-wyoming-a-simple-step-by-step-guide",
    "title": "How to Register an X-Ray Machine in Wyoming: A Simple Step-by-Step Guide",
    "excerpt": "Opening, buying, moving, or changing an X-ray facility in Wyoming can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and…",
    "readTime": "3 min read",
    "tag": "Registration Guide",
    "updated": "Last updated Aug 21",
    "blocks": [
      {
        "type": "p",
        "text": "Opening, buying, moving, or changing an X-ray facility in Wyoming can involve several radiation-control steps. This guide puts the ordinary registration sequence, official links, timing, fees, and records in one place."
      },
      {
        "type": "p",
        "text": "Heartland Physics can review the project scope and confirm whether its current qualifications and authorization cover any shielding work required for this project. Use the current government sources linked below for registration, plan review, fees, inspections, and filing requirements."
      },
      {
        "type": "h2",
        "text": "Quick answer"
      },
      {
        "type": "p",
        "text": "Wyoming has jurisdiction over X-ray equipment, but current public materials do not present one general statewide machine-registration portal that clearly applies to every type of X-ray facility."
      },
      {
        "type": "p",
        "text": "The correct process can depend on the facility type and licensing authority. Confirm the applicable registration, inspection, and shielding requirements before purchase or installation."
      },
      {
        "type": "h2",
        "text": "Start here: official forms and filing links"
      },
      {
        "type": "p",
        "text": "Use the official links below for the current application, instructions, or radiation-control program page. Forms, fees, and filing systems can change, so use the current agency version rather than an old saved copy."
      },
      {
        "type": "links",
        "items": [
          {
            "label": "Open Wyoming Dental X-Ray Inspection Information",
            "href": "https://dental.wyo.gov/licensing/x-ray-inspection-forms"
          }
        ]
      },
      {
        "type": "h2",
        "text": "What to gather before you start"
      },
      {
        "type": "p",
        "text": "• Facility legal name, physical location, mailing/billing information, and responsible owner or operator"
      },
      {
        "type": "p",
        "text": "• Each X-ray machine's manufacturer, model, serial number, tube information, room/location, and intended use"
      },
      {
        "type": "p",
        "text": "• Radiation Safety Officer or other responsible-person information when requested"
      },
      {
        "type": "p",
        "text": "• Shielding plan, room drawing, workload/occupancy assumptions, or plan-review documentation when applicable"
      },
      {
        "type": "p",
        "text": "• Installer or assembler reports, acceptance testing, inspection/calibration records, and applicable professional credentials"
      },
      {
        "type": "p",
        "text": "• Current application fee or payment information"
      },
      {
        "type": "h2",
        "text": "Step-by-step instructions"
      },
      {
        "type": "h3",
        "text": "Step 1: Handle the room and shielding requirements"
      },
      {
        "type": "p",
        "text": "Before construction or installation, ask the applicable Wyoming regulator whether a shielding plan, radiation survey, or pre-installation review is required for the facility type. Keep the written response and final shielding records with the equipment file."
      },
      {
        "type": "h3",
        "text": "Step 2: Complete the registration application"
      },
      {
        "type": "p",
        "text": "Identify the Wyoming agency or professional licensing board that regulates the facility type and request the current radiation-machine registration or inspection instructions before acquiring the unit."
      },
      {
        "type": "h3",
        "text": "Step 3: Submit the application and fee"
      },
      {
        "type": "p",
        "text": "Submit the form, equipment information, inspection documentation, and fee required by the applicable Wyoming authority. Do not assume that a process used for dental equipment applies to medical, veterinary, industrial, or other installations."
      },
      {
        "type": "h3",
        "text": "Step 4: Complete the post-filing requirements"
      },
      {
        "type": "p",
        "text": "Complete any required initial inspection or equipment evaluation before clinical or routine use and maintain the regulator's approval or inspection records."
      },
      {
        "type": "h3",
        "text": "Step 5: Renew and report changes"
      },
      {
        "type": "p",
        "text": "Renewal and inspection cycles vary by facility type. For example, Wyoming's dental program publishes its own inspection requirements. Verify the cycle that applies to your installation."
      },
      {
        "type": "h2",
        "text": "Cost"
      },
      {
        "type": "p",
        "text": "No single statewide X-ray-machine registration fee schedule was identified on the current public sources reviewed for all facility types. Confirm fees with the applicable Wyoming regulator before filing."
      },
      {
        "type": "h2",
        "text": "Regulatory contact"
      },
      {
        "type": "p",
        "text": "Start with the Wyoming authority that licenses or oversees the facility type. Dental facilities can use the Wyoming Board of Dental Examiners' X-Ray Inspection resources."
      },
      {
        "type": "h2",
        "text": "Keep these records together"
      },
      {
        "type": "p",
        "text": "• Submitted application and payment receipt"
      },
      {
        "type": "p",
        "text": "• Current registration certificate, permit, license, inspection approval, or written regulator determination"
      },
      {
        "type": "p",
        "text": "• Shielding design, calculations, room drawings, and plan-review correspondence when applicable"
      },
      {
        "type": "p",
        "text": "• Installer/assembler paperwork, acceptance tests, calibration records, and equipment-performance reports"
      },
      {
        "type": "p",
        "text": "• Inspection reports, operating procedures, staff training, dosimetry, maintenance, and other records required for the facility"
      },
      {
        "type": "h2",
        "text": "Important reminder"
      },
      {
        "type": "p",
        "text": "This is a practical guide to the ordinary radiation-machine process, not a substitute for the regulator's current instructions. Mammography, radiation therapy, mobile services, industrial radiography, research equipment, and other specialized uses can trigger additional permits, professional qualifications, inspections, or federal requirements."
      },
      {
        "type": "h2",
        "text": "Official sources"
      },
      {
        "type": "p",
        "text": "Use the current government sources linked on this page. Requirements, forms, fees, contacts, and procedures can change."
      }
    ]
  }
];
